var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Grid_1;
import { isNullOrUndefined, setValue, getValue, defaultCurrencyCode, updateCSSText } from '@syncfusion/ej2-base';
import { Component, ChildProperty, Browser, closest, extend } from '@syncfusion/ej2-base';
import { addClass, removeClass, append, remove, classList, setStyleAttribute } from '@syncfusion/ej2-base';
import { Property, Collection, Complex, Event, NotifyPropertyChanges, L10n } from '@syncfusion/ej2-base';
import { EventHandler, KeyboardEvents } from '@syncfusion/ej2-base';
import { DataManager, DataUtil, UrlAdaptor } from '@syncfusion/ej2-data';
import { createSpinner, hideSpinner, showSpinner, Tooltip } from '@syncfusion/ej2-popups';
import { iterateArrayOrObject, prepareColumns, parentsUntil, wrap, templateCompiler, isGroupAdaptive, refreshForeignData, getScrollBarWidth } from './util';
import { getRowHeight, setColumnIndex, Global, ispercentageWidth, getNumberFormat, getTransformValues } from './util';
import { setRowElements, resetRowIndex, compareChanges, getCellByColAndRowIndex, performComplexDataOperation } from './util';
import * as events from '../base/constant';
import { Render } from '../renderer/render';
import { Column } from '../models/column';
import { RenderType } from './enum';
import { RowRenderer } from '../renderer/row-renderer';
import { CellRenderer } from '../renderer/cell-renderer';
import { CellRendererFactory } from '../services/cell-render-factory';
import { ServiceLocator } from '../services/service-locator';
import { ValueFormatter } from '../services/value-formatter';
import { RendererFactory } from '../services/renderer-factory';
import { ColumnWidthService } from '../services/width-controller';
import { AriaService } from '../services/aria-service';
import { FocusStrategy } from '../services/focus-strategy';
import { PageSettings } from '../models/page-settings';
import { ColumnChooserSettings } from '../models/column-chooser-settings';
import { Selection } from '../actions/selection';
import { Search } from '../actions/search';
import { ShowHide } from '../actions/show-hide';
import { Scroll } from '../actions/scroll';
import { Print } from '../actions/print';
import { AggregateRow } from '../models/aggregate';
import { Clipboard } from '../actions/clipboard';
import { Logger } from '../actions/logger';
import { RowModelGenerator } from '../services/row-model-generator';
import { SanitizeHtmlHelper } from '@syncfusion/ej2-base';
import * as literals from '../base/string-literals';
import { HeaderCellRenderer } from '../renderer/header-cell-renderer';
/**
 * Represents the field name and direction of sort column.
 */
export class SortDescriptor extends ChildProperty {
}
__decorate([
    Property()
], SortDescriptor.prototype, "field", void 0);
__decorate([
    Property()
], SortDescriptor.prototype, "direction", void 0);
__decorate([
    Property(false)
], SortDescriptor.prototype, "isFromGroup", void 0);
/**
 * Configures the sorting behavior of Grid.
 */
export class SortSettings extends ChildProperty {
}
__decorate([
    Collection([], SortDescriptor)
], SortSettings.prototype, "columns", void 0);
__decorate([
    Property(true)
], SortSettings.prototype, "allowUnsort", void 0);
/**
 * Represents the predicate for the filter column.
 */
export class Predicate extends ChildProperty {
}
__decorate([
    Property()
], Predicate.prototype, "field", void 0);
__decorate([
    Property()
], Predicate.prototype, "operator", void 0);
__decorate([
    Property()
], Predicate.prototype, "value", void 0);
__decorate([
    Property()
], Predicate.prototype, "matchCase", void 0);
__decorate([
    Property(false)
], Predicate.prototype, "ignoreAccent", void 0);
__decorate([
    Property()
], Predicate.prototype, "predicate", void 0);
__decorate([
    Property({})
], Predicate.prototype, "actualFilterValue", void 0);
__decorate([
    Property({})
], Predicate.prototype, "actualOperator", void 0);
__decorate([
    Property()
], Predicate.prototype, "type", void 0);
__decorate([
    Property()
], Predicate.prototype, "ejpredicate", void 0);
__decorate([
    Property()
], Predicate.prototype, "uid", void 0);
__decorate([
    Property()
], Predicate.prototype, "isForeignKey", void 0);
__decorate([
    Property()
], Predicate.prototype, "condition", void 0);
/**
 * Configures the infinite scroll behavior of Grid.
 */
export class InfiniteScrollSettings extends ChildProperty {
}
__decorate([
    Property(false)
], InfiniteScrollSettings.prototype, "enableCache", void 0);
__decorate([
    Property(3)
], InfiniteScrollSettings.prototype, "maxBlocks", void 0);
__decorate([
    Property(3)
], InfiniteScrollSettings.prototype, "initialBlocks", void 0);
/**
 * Configures the filtering behavior of the Grid.
 */
export class FilterSettings extends ChildProperty {
}
__decorate([
    Collection([], Predicate)
], FilterSettings.prototype, "columns", void 0);
__decorate([
    Property('FilterBar')
], FilterSettings.prototype, "type", void 0);
__decorate([
    Property('OnEnter')
], FilterSettings.prototype, "mode", void 0);
__decorate([
    Property(true)
], FilterSettings.prototype, "showFilterBarStatus", void 0);
__decorate([
    Property(1500)
], FilterSettings.prototype, "immediateModeDelay", void 0);
__decorate([
    Property()
], FilterSettings.prototype, "operators", void 0);
__decorate([
    Property(false)
], FilterSettings.prototype, "ignoreAccent", void 0);
__decorate([
    Property(false)
], FilterSettings.prototype, "enableInfiniteScrolling", void 0);
__decorate([
    Property(50)
], FilterSettings.prototype, "itemsCount", void 0);
__decorate([
    Property('Shimmer')
], FilterSettings.prototype, "loadingIndicator", void 0);
__decorate([
    Property(false)
], FilterSettings.prototype, "enableCaseSensitivity", void 0);
__decorate([
    Property(false)
], FilterSettings.prototype, "showFilterBarOperator", void 0);
/**
 * Configures the selection behavior of the Grid.
 */
export class SelectionSettings extends ChildProperty {
}
__decorate([
    Property('Row')
], SelectionSettings.prototype, "mode", void 0);
__decorate([
    Property('Flow')
], SelectionSettings.prototype, "cellSelectionMode", void 0);
__decorate([
    Property('Single')
], SelectionSettings.prototype, "type", void 0);
__decorate([
    Property(false)
], SelectionSettings.prototype, "checkboxOnly", void 0);
__decorate([
    Property(false)
], SelectionSettings.prototype, "persistSelection", void 0);
__decorate([
    Property('Default')
], SelectionSettings.prototype, "checkboxMode", void 0);
__decorate([
    Property(false)
], SelectionSettings.prototype, "enableSimpleMultiRowSelection", void 0);
__decorate([
    Property(true)
], SelectionSettings.prototype, "enableToggle", void 0);
__decorate([
    Property(false)
], SelectionSettings.prototype, "allowColumnSelection", void 0);
/**
 * Configures the search behavior of the Grid.
 */
export class SearchSettings extends ChildProperty {
}
__decorate([
    Property([])
], SearchSettings.prototype, "fields", void 0);
__decorate([
    Property('')
], SearchSettings.prototype, "key", void 0);
__decorate([
    Property('contains')
], SearchSettings.prototype, "operator", void 0);
__decorate([
    Property(true)
], SearchSettings.prototype, "ignoreCase", void 0);
__decorate([
    Property(false)
], SearchSettings.prototype, "ignoreAccent", void 0);
/**
 * Configures the row drop settings of the Grid.
 */
export class RowDropSettings extends ChildProperty {
}
__decorate([
    Property()
], RowDropSettings.prototype, "targetID", void 0);
/**
 * Configures the text wrap settings of the Grid.
 */
export class TextWrapSettings extends ChildProperty {
}
__decorate([
    Property('Both')
], TextWrapSettings.prototype, "wrapMode", void 0);
/**
 * Configures the resize behavior of the Grid.
 */
export class ResizeSettings extends ChildProperty {
}
__decorate([
    Property('Normal')
], ResizeSettings.prototype, "mode", void 0);
/**
 * Configures the group behavior of the Grid.
 */
export class GroupSettings extends ChildProperty {
}
__decorate([
    Property(true)
], GroupSettings.prototype, "showDropArea", void 0);
__decorate([
    Property(false)
], GroupSettings.prototype, "allowReordering", void 0);
__decorate([
    Property(false)
], GroupSettings.prototype, "showToggleButton", void 0);
__decorate([
    Property(false)
], GroupSettings.prototype, "showGroupedColumn", void 0);
__decorate([
    Property(true)
], GroupSettings.prototype, "showUngroupButton", void 0);
__decorate([
    Property(false)
], GroupSettings.prototype, "disablePageWiseAggregates", void 0);
__decorate([
    Property([])
], GroupSettings.prototype, "columns", void 0);
__decorate([
    Property()
], GroupSettings.prototype, "captionTemplate", void 0);
__decorate([
    Property(false)
], GroupSettings.prototype, "enableLazyLoading", void 0);
/**
 * Configures the edit behavior of the Grid.
 */
export class EditSettings extends ChildProperty {
}
__decorate([
    Property(false)
], EditSettings.prototype, "allowAdding", void 0);
__decorate([
    Property(false)
], EditSettings.prototype, "allowEditing", void 0);
__decorate([
    Property(false)
], EditSettings.prototype, "allowDeleting", void 0);
__decorate([
    Property('Normal')
], EditSettings.prototype, "mode", void 0);
__decorate([
    Property(true)
], EditSettings.prototype, "allowEditOnDblClick", void 0);
__decorate([
    Property(true)
], EditSettings.prototype, "showConfirmDialog", void 0);
__decorate([
    Property(false)
], EditSettings.prototype, "showDeleteConfirmDialog", void 0);
__decorate([
    Property()
], EditSettings.prototype, "template", void 0);
__decorate([
    Property()
], EditSettings.prototype, "headerTemplate", void 0);
__decorate([
    Property()
], EditSettings.prototype, "footerTemplate", void 0);
__decorate([
    Property('Top')
], EditSettings.prototype, "newRowPosition", void 0);
__decorate([
    Property({})
], EditSettings.prototype, "dialog", void 0);
__decorate([
    Property(false)
], EditSettings.prototype, "allowNextRowEdit", void 0);
__decorate([
    Property(false)
], EditSettings.prototype, "showAddNewRow", void 0);
/**
 * Configures the Loading Indicator of the Grid.
 */
export class LoadingIndicator extends ChildProperty {
}
__decorate([
    Property('Spinner')
], LoadingIndicator.prototype, "indicatorType", void 0);
/**
 * Represents the Grid component.
 * ```html
 * <div id="grid"></div>
 * <script>
 *  var gridObj = new Grid({ allowPaging: true });
 *  gridObj.appendTo("#grid");
 * </script>
 * ```
 */
let Grid = Grid_1 = class Grid extends Component {
    /**
     * Constructor for creating the component
     *
     * @param {GridModel} options - specifies the options
     * @param {string | HTMLElement} element - specifies the element
     * @hidden
     */
    constructor(options, element) {
        super(options, element);
        this.isPreventScrollEvent = false;
        this.inViewIndexes = [];
        this.keyA = false;
        this.frozenRightCount = 0;
        this.freezeColumnRefresh = true;
        this.rightcount = 0;
        this.frozenLeftCount = 0;
        this.leftcount = 0;
        this.tablesCount = 1;
        this.movableCount = 0;
        this.movablecount = 0;
        this.fixedcount = 0;
        this.fixedCount = 0;
        this.visibleFrozenLeft = 0;
        this.visibleFrozenFixed = 0;
        this.isPreparedFrozenColumns = false;
        this.visibleFrozenRight = 0;
        this.visibleMovable = 0;
        this.frozenLeftColumns = [];
        this.frozenRightColumns = [];
        this.movableColumns = [];
        this.fixedColumns = [];
        this.stackedLeft = [];
        this.stackedRight = [];
        this.stackedFixed = [];
        this.stackedMovable = [];
        this.stackedarrayLeft = [];
        this.stackedarrayRight = [];
        this.stackedarrayFixed = [];
        this.stackedarrayMovable = [];
        this.media = {};
        this.autoFitColumnsResize = false;
        /** @hidden */
        this.tableIndex = 0;
        this.componentRefresh = Component.prototype.refresh;
        this.isChangeDataSourceCall = false;
        this.mergedColumns = false;
        /** @hidden */
        this.isVirtualAdaptive = false;
        /** @hidden */
        /**
         * * If `requireTemplateRef` is set to false in the load event, then the template element can't be accessed in grid queryCellInfo, and rowDataBound events.
         * * By default, React's grid queryCellInfo and rowDataBound events allow access to the template element.
         * * Avoid accessing the template elements in the grid queryCellInfo and rowDataBound events to improve rendering performance by setting this value as false.
         *
         * @default true
         */
        this.requireTemplateRef = true;
        /** @hidden */
        this.vRows = [];
        /** @hidden */
        this.vcRows = [];
        /** @hidden */
        this.vGroupOffsets = {};
        /** @hidden */
        this.rowUid = 0;
        /** @hidden */
        this.translateX = 0;
        /** @hidden */
        this.isManualRefresh = false;
        /** @hidden */
        this.isAutoFitColumns = false;
        /** @hidden */
        this.enableDeepCompare = false;
        /** @hidden */
        this.totalDataRecordsCount = 0;
        /** @hidden */
        this.disableSelectedRecords = [];
        /** @hidden */
        this.partialSelectedRecords = [];
        /** @hidden */
        this.partialSelectedIndexes = [];
        /** @hidden */
        this.pinnedTopRowModels = [];
        /** @hidden */
        this.pinnedTopRecords = [];
        /** @hidden */
        this.pinnedTopRowKeys = {};
        /** @hidden */
        this.pinnedRowIndexes = {};
        /** @hidden */
        this.contentRowIndexes = {};
        /** @hidden */
        this.isSpan = false;
        /** @hidden */
        this.islazyloadRequest = false;
        /** @hidden */
        this.isAddNewRow = false;
        /** @hidden */
        this.addNewRowFocus = true;
        /** @hidden */
        this.selectVirtualRowOnAdd = false;
        /** @hidden */
        this.lockcolPositionCount = 0;
        /** @hidden */
        this.prevPageMoving = false;
        /** @hidden */
        this.pageTemplateChange = false;
        /** @hidden */
        this.isAutoGen = false;
        /** @hidden */
        this.isAutoGenerateColumns = false;
        /** @hidden */
        this.pageRequireRefresh = true;
        this.mediaBindInstance = {};
        /** @hidden */
        this.commandDelIndex = undefined;
        /** @hidden */
        this.preventAutoFit = false;
        /** @hidden */
        this.asyncTimeOut = 50;
        /** @hidden */
        this.isExportGrid = false;
        /** @hidden */
        this.isWidgetsDestroyed = false;
        this.enableLogger = false;
        this.needsID = true;
        Grid_1.Inject(Selection);
        setValue('mergePersistData', this.mergePersistGridData, this);
    }
    /**
     * Get the properties to be maintained in the persisted state.
     *
     * @returns {string} returns the persist data
     */
    getPersistData() {
        const keyEntity = ['pageSettings', 'sortSettings',
            'filterSettings', 'groupSettings', 'columns', 'searchSettings', 'selectedRowIndex', 'scrollPosition'];
        const ignoreOnPersist = {
            pageSettings: ['template', 'pageSizes', 'enableQueryString', 'totalRecordsCount', 'pageCount'],
            filterSettings: ['type', 'mode', 'showFilterBarStatus', 'immediateModeDelay', 'ignoreAccent'],
            groupSettings: ['showDropArea', 'showToggleButton', 'showGroupedColumn', 'showUngroupButton',
                'disablePageWiseAggregates', 'hideCaptionCount'],
            searchSettings: ['fields', 'operator', 'ignoreCase'],
            sortSettings: [], columns: [], selectedRowIndex: [], scrollPosition: []
        };
        for (let i = 0; i < keyEntity.length; i++) {
            const currentObject = this[keyEntity[parseInt(i.toString(), 10)]];
            for (const val of ignoreOnPersist[keyEntity[parseInt(i.toString(), 10)]]) {
                delete currentObject[`${val}`];
            }
        }
        const temp = this.pageSettings.template;
        const settings = Object.assign({ template: undefined }, this.pageSettings);
        if (this.enableVirtualization && this.enablePersistence && this.contentModule &&
            this.contentModule.getPageFromTop && !isNullOrUndefined(this.scrollPosition) &&
            !isNullOrUndefined(this.scrollPosition.top)) {
            settings['properties']['currentPage'] = this.contentModule.getPageFromTop(this.scrollPosition.top, { block: 1 });
        }
        this.setProperties({ pageSettings: settings }, true);
        const captionTemplateRef = this.groupSettings.captionTemplate;
        const isAngularCaptionTemplate = captionTemplateRef && this.isAngular;
        if (isAngularCaptionTemplate) {
            delete this.groupSettings['properties']['captionTemplate'];
        }
        this.pageTemplateChange = !isNullOrUndefined(this.pagerTemplate);
        const persistData = this.addOnPersist(keyEntity);
        settings.template = temp;
        this.setProperties({ pageSettings: settings }, true);
        if (isAngularCaptionTemplate) {
            this.groupSettings.captionTemplate = captionTemplateRef;
        }
        return persistData;
    }
    /**
     * To provide the array of modules needed for component rendering
     *
     * @returns {ModuleDeclaration[]} Returns the module Declaration
     * @hidden
     */
    requiredModules() {
        this.setFrozenCount();
        this.enableInfiniteAggrgate();
        const modules = [];
        if (this.isDestroyed) {
            return modules;
        }
        if (this.allowFiltering) {
            modules.push({
                member: 'filter',
                args: [this, this.filterSettings, this.serviceLocator],
                name: 'Filter'
            });
        }
        if (this.allowExcelExport) {
            modules.push({
                member: 'ExcelExport',
                args: [this, this.serviceLocator],
                name: 'ExcelExport'
            });
        }
        if (this.allowPdfExport) {
            modules.push({
                member: 'PdfExport',
                args: [this],
                name: 'PdfExport'
            });
        }
        if (this.allowSorting) {
            modules.push({
                member: 'sort',
                args: [this, this.sortSettings, this.sortedColumns, this.serviceLocator],
                name: 'Sort'
            });
        }
        if (this.allowPaging) {
            modules.push({
                member: 'pager',
                args: [this, this.pageSettings],
                name: 'Page'
            });
        }
        if (this.allowSelection) {
            modules.push({
                member: 'selection',
                args: [this, this.selectionSettings, this.serviceLocator],
                name: 'Selection'
            });
        }
        if (this.resizeCheck()) {
            modules.push({
                member: 'resize',
                args: [this],
                name: 'Resize'
            });
        }
        if (this.allowReordering) {
            modules.push({
                member: 'reorder',
                args: [this],
                name: 'Reorder'
            });
        }
        if (this.allowRowDragAndDrop) {
            modules.push({
                member: 'rowDragAndDrop',
                args: [this],
                name: 'RowDD'
            });
        }
        if (this.allowGrouping) {
            modules.push({
                member: 'group',
                args: [this, this.groupSettings, this.sortedColumns, this.serviceLocator],
                name: 'Group'
            });
        }
        if (this.aggregates.length) {
            modules.push({ member: 'aggregate', args: [this, this.serviceLocator], name: 'Aggregate' });
        }
        if (this.isDetail()) {
            modules.push({
                member: 'detailRow',
                args: [this, this.serviceLocator],
                name: 'DetailRow'
            });
        }
        if (this.toolbar || this.toolbarTemplate) {
            modules.push({
                member: 'toolbar',
                args: [this, this.serviceLocator],
                name: 'Toolbar'
            });
        }
        if (this.enableVirtualization || this.enableColumnVirtualization) {
            modules.push({
                member: 'virtualscroll',
                args: [this, this.serviceLocator],
                name: 'VirtualScroll'
            });
        }
        if (this.getFrozenColumns() || this.frozenRows || this.frozenRightCount || this.frozenLeftCount) {
            modules.push({ member: 'freeze', args: [this, this.serviceLocator], name: 'Freeze' });
        }
        if (!isNullOrUndefined(this.columns) && this.isCommandColumn(this.columns)) {
            modules.push({
                member: 'commandColumn',
                args: [this, this.serviceLocator],
                name: 'CommandColumn'
            });
        }
        if (this.editSettings.allowAdding || this.editSettings.allowDeleting || this.editSettings.allowEditing) {
            modules.push({
                member: 'edit',
                args: [this, this.serviceLocator],
                name: 'Edit'
            });
        }
        this.extendRequiredModules(modules);
        return modules;
    }
    extendRequiredModules(modules) {
        if (this.enableInfiniteScrolling) {
            modules.push({
                member: 'infiniteScroll',
                args: [this, this.serviceLocator],
                name: 'InfiniteScroll'
            });
        }
        if (this.groupSettings.enableLazyLoading) {
            modules.push({
                member: 'lazyLoadGroup',
                args: [this, this.serviceLocator],
                name: 'LazyLoadGroup'
            });
        }
        if (this.contextMenuItems) {
            modules.push({
                member: 'contextMenu',
                args: [this, this.serviceLocator],
                name: 'ContextMenu'
            });
        }
        if (this.showColumnMenu) {
            modules.push({
                member: 'columnMenu',
                args: [this, this.serviceLocator],
                name: 'ColumnMenu'
            });
        }
        if (this.showColumnChooser) {
            modules.push({
                member: 'columnChooser',
                args: [this, this.serviceLocator],
                name: 'ColumnChooser'
            });
        }
        if (!isNullOrUndefined(this.columns) && this.isForeignKeyEnabled(this.columns)) {
            modules.push({ member: 'foreignKey', args: [this, this.serviceLocator], name: 'ForeignKey' });
        }
        if (this.enableLogger) {
            modules.push({ member: 'logger', args: [this], name: 'Logger' });
        }
    }
    resizeCheck() {
        const autoFitColumns = this.getColumns().filter((c) => c.autoFit === true).length ? true : false;
        if (!isNullOrUndefined(this.columnModel) && this.columnModel.length && !(this.columnModel[0] instanceof Column)) {
            this.columnModel = [];
        }
        const columnMenu = this.showColumnMenu && (!this.columnMenuItems || this.columnMenuItems
            .filter((c) => c === 'AutoFit' || c === 'AutoFitAll').length) ? true : false;
        const contextMenu = this.contextMenuItems && this.contextMenuItems
            .filter((c) => c === 'AutoFit' || c === 'AutoFitAll').length ? true : false;
        return this.allowResizing || this.autoFitColumnsResize || autoFitColumns || columnMenu || contextMenu;
    }
    /**
     * For internal use only - Initialize the event handler;
     *
     * @returns {void}
     * @private
     */
    preRender() {
        this.serviceLocator = new ServiceLocator;
        this.initProperties();
        this.initializeServices();
    }
    initProperties() {
        this.isInitial = true;
        this.sortedColumns = [];
        this.inViewIndexes = [];
        this.mediaCol = [];
        this.isInitialLoad = false;
        this.allowServerDataBinding = false;
        this.ignoreCollectionWatch = true;
        this.mergeCells = {};
        this.isEdit = false;
        this.checkAllRows = 'None';
        this.isCheckBoxSelection = false;
        this.isPersistSelection = false;
        this.componentRefresh = Component.prototype.refresh;
        this.freezeColumnRefresh = true;
        this.filterOperators = {
            contains: 'contains', endsWith: 'endswith', equal: 'equal', greaterThan: 'greaterthan', greaterThanOrEqual: 'greaterthanorequal',
            lessThan: 'lessthan', lessThanOrEqual: 'lessthanorequal', notEqual: 'notequal', startsWith: 'startswith', wildCard: 'wildcard',
            isNull: 'isnull', notNull: 'notnull', like: 'like'
        };
        this.defaultChartLocale = {
            Chart: 'Chart',
            BarChart: 'Bar Chart',
            Bar: 'Bar',
            StackingBar: 'Stacked Bar',
            StackingBar100: '100% Stacked Bar',
            Pie: 'Pie Chart',
            ColumnChart: 'Column Chart',
            Column: 'Column',
            StackingColumn: 'Stacked Column',
            StackingColumn100: '100% Stacked Column',
            LineChart: 'Line Chart',
            Line: 'Line',
            StackingLine: 'Stacked Line',
            StackingLine100: '100% Stacked Line',
            AreaChart: 'Area Chart',
            Area: 'Area',
            StackingArea: 'Stacked Area',
            StackingArea100: '100% Stacked Area',
            Scatter: 'Scatter Chart'
        };
        this.defaultLocale = Object.assign({ EmptyRecord: 'No records to display', True: 'true', False: 'false', InvalidFilterMessage: 'Invalid Filter Data', GroupDropArea: 'Drag a column header here to group its column', UnGroup: 'Click here to ungroup', UnGroupButton: 'Click here to ungroup', GroupDisable: 'Grouping is disabled for this column', FilterbarTitle: '\'s filter bar cell', EmptyDataSourceError: 'DataSource must not be empty at initial load since columns are generated from dataSource in AutoGenerate Column Grid', 
            // Toolbar Items
            Add: 'Add', Edit: 'Edit', Cancel: 'Cancel', Update: 'Update', Delete: 'Delete', Print: 'Print', Pdfexport: 'PDF Export', Excelexport: 'Excel Export', Wordexport: 'Word Export', Csvexport: 'CSV Export', Search: 'Search', Columnchooser: 'Columns', Save: 'Save', Item: 'item', Items: 'items', EditOperationAlert: 'No records selected for edit operation', DeleteOperationAlert: 'No records selected for delete operation', SaveButton: 'Save', OKButton: 'OK', CancelButton: 'Cancel', EditFormTitle: 'Details of ', AddFormTitle: 'Add New Record', BatchSaveConfirm: 'Are you sure you want to save changes?', BatchSaveLostChanges: 'Unsaved changes will be lost. Are you sure you want to continue?', ConfirmDelete: 'Are you sure you want to Delete Record?', CancelEdit: 'Are you sure you want to Cancel the changes?', ChooseColumns: 'Choose Column', ColumnMenu: 'Column Menu', SearchColumns: 'search columns', Matchs: 'No matches found', FilterButton: 'Filter', FilterTitle: 'Filter', FilterIcon: 'Filter', ClearButton: 'Clear', StartsWith: 'Starts With', NotStartsWith: 'Does Not Start With', Like: 'Like', EndsWith: 'Ends With', NotEndsWith: 'Does Not End With', Contains: 'Contains', NotContains: 'Does Not Contain', IsNull: 'Null', NotNull: 'Not Null', IsEmpty: 'Empty', IsNotEmpty: 'Not Empty', Equal: 'Equal', NotEqual: 'Not Equal', LessThan: 'Less Than', LessThanOrEqual: 'Less Than Or Equal', GreaterThan: 'Greater Than', GreaterThanOrEqual: 'Greater Than Or Equal', In: 'In', NotIn: 'Not In', ChooseDate: 'Choose a Date', EnterValue: 'Enter the value', Copy: 'Copy', Group: 'Group by this column', Ungroup: 'Ungroup by this column', GroupButton: 'Group button', UnGroupAria: 'ungroup button', GroupSeperator: 'Separator for the grouped columns', UnGroupIcon: 'ungroup the grouped column ', GroupedSortIcon: 'sort the grouped column ', GroupedDrag: 'Drag the grouped column', GroupCaption: ' is groupcaption cell', CheckBoxLabel: 'checkbox', SelectAllCheckbox: 'Select all checkbox', SelectRow: 'Select row', autoFitAll: 'Autofit all columns', autoFit: 'Autofit this column', AutoFitAll: 'Autofit all columns', AutoFit: 'Autofit this column', Export: 'Export', FirstPage: 'First Page', LastPage: 'Last Page', PreviousPage: 'Previous Page', NextPage: 'Next Page', SortAscending: 'Sort Ascending', SortDescending: 'Sort Descending', EditRecord: 'Edit Record', DeleteRecord: 'Delete Record', FilterMenu: 'Filter', SelectAll: 'Select All', AddCurrentSelection: 'Add current selection to filter', Blanks: 'Blanks', FilterTrue: 'True', FilterFalse: 'False', NoResult: 'No matches found', ClearFilter: 'Clear Filter', Clear: 'Clear', NumberFilter: 'Number Filters', TextFilter: 'Text Filters', DateFilter: 'Date Filters', DateTimeFilter: 'DateTime Filters', MatchCase: 'Match Case', Between: 'Between', CustomFilter: 'Custom Filter', CustomFilterPlaceHolder: 'Enter the value', CustomFilterDatePlaceHolder: 'Choose a date', AND: 'AND', OR: 'OR', ShowRowsWhere: 'Show rows where:', ToolbarMenuDialogARIA: 'Toolbar menu dialog', FilterMenuDialogARIA: 'Filter menu', ExcelFilterDialogARIA: 'Excel filter', CheckBoxFilterDialogARIA: 'Checkbox filter', DialogEditARIA: 'Edit dialog', ColumnMenuDialogARIA: 'Column menu dialog', CustomFilterDialogARIA: 'Customer filter dialog', SortAtoZ: 'Sort A to Z', SortZtoA: 'Sort Z to A', SortByOldest: 'Sort by Oldest', SortByNewest: 'Sort by Newest', SortSmallestToLargest: 'Sort Smallest to Largest', SortLargestToSmallest: 'Sort Largest to Smallest', Sort: 'Sort', SortIcon: 'Sort', FilterDescription: 'Press Alt Down to open filter Menu', SortDescription: 'Press Enter to sort', ColumnMenuDescription: 'Press Alt Down to open Column Menu', GroupDescription: 'Press Ctrl space to group', ColumnHeader: ' column header ', TemplateCell: ' is template cell', CommandColumnAria: 'is Command column column header ', DialogEdit: 'Dialog edit', ClipBoard: 'clipboard', AscendingText: 'Ascending', DescendingText: 'Descending', NoneText: 'None', Expanded: 'Expanded', Collapsed: 'Collapsed', PinRow: 'Pin Row', UnpinRow: 'Unpin Row' }, this.defaultChartLocale);
        this.keyConfigs = {
            downArrow: 'downarrow',
            upArrow: 'uparrow',
            rightArrow: 'rightarrow',
            leftArrow: 'leftarrow',
            shiftDown: 'shift+downarrow',
            shiftUp: 'shift+uparrow',
            shiftRight: 'shift+rightarrow',
            shiftLeft: 'shift+leftarrow',
            home: 'home',
            end: 'end',
            escape: 'escape',
            ctrlHome: 'ctrl+home',
            ctrlEnd: 'ctrl+end',
            pageUp: 'pageup',
            pageDown: 'pagedown',
            ctrlAltPageUp: 'ctrl+alt+pageup',
            ctrlAltPageDown: 'ctrl+alt+pagedown',
            altPageUp: 'alt+pageup',
            altPageDown: 'alt+pagedown',
            altDownArrow: 'alt+downarrow',
            altUpArrow: 'alt+uparrow',
            ctrlDownArrow: 'ctrl+downarrow',
            ctrlUpArrow: 'ctrl+uparrow',
            ctrlPlusA: 'ctrl+A',
            ctrlPlusP: 'ctrl+P',
            insert: 'insert',
            delete: 'delete',
            f2: 'f2',
            enter: 'enter',
            ctrlEnter: 'ctrl+enter',
            shiftEnter: 'shift+enter',
            tab: 'tab',
            shiftTab: 'shift+tab',
            space: 'space',
            ctrlPlusC: 'ctrl+C',
            ctrlShiftPlusH: 'ctrl+shift+H',
            ctrlSpace: 'ctrl+space',
            ctrlLeftArrow: 'ctrl+leftarrow',
            ctrlRightArrow: 'ctrl+rightarrow'
        };
    }
    /**
     * For internal use only - To Initialize the component rendering.
     *
     * @returns {void}
     * @private
     */
    render() {
        this.log(['module_missing', 'promise_enabled', 'locale_missing', 'check_datasource_columns']);
        this.ariaService.setOptions(this.element, { role: 'grid' });
        createSpinner({ target: this.element, cssClass: this.cssClass ? this.cssClass : null }, this.createElement);
        this.renderModule = new Render(this, this.serviceLocator);
        this.searchModule = new Search(this);
        this.scrollModule = new Scroll(this);
        this.notify(events.initialLoad, {});
        if (this.pageSettings.enableQueryString) {
            const pageValue = new URL(window.location.href).searchParams.get('page');
            if (!isNullOrUndefined(pageValue) && window.location.href.indexOf('?page=') > 0) {
                const currentPageValue = parseInt(pageValue, 10);
                this.setProperties({ pageSettings: { currentPage: currentPageValue } }, true);
                this.pageSettings.currentPage = currentPageValue;
            }
        }
        if ((this.getDataModule().dataManager.dataSource.offline === true || this.getDataModule().dataManager.dataSource.url === undefined)
            && !(!isNullOrUndefined(this.dataSource) && this.dataSource.result)) {
            this.isVirtualAdaptive = true;
        }
        if (this.aggregateModule && this.aggregates.length) {
            for (let i = 0; i < this.aggregates.length; i++) {
                for (let j = 0; j < this.aggregates[parseInt(i.toString(), 10)].columns.length; j++) {
                    const column = this.aggregates[parseInt(i.toString(), 10)].columns[parseInt(j.toString(), 10)];
                    if (column['types']) {
                        column.type = column['types'];
                    }
                }
            }
        }
        if (this.isReact) {
            const args = { requireTemplateRef: this.requireTemplateRef };
            this.trigger(events.load, args);
            if (!args.requireTemplateRef) {
                this.requireTemplateRef = args.requireTemplateRef;
            }
        }
        else {
            this.trigger(events.load);
        }
        if (typeof this.isRowSelectable === 'string') {
            this.isRowSelectable = getValue(this.isRowSelectable, window);
        }
        if (typeof this.isRowPinned === 'string') {
            this.isRowPinned = getValue(this.isRowPinned, window);
        }
        if (this.isRowPinned) {
            if (this.allowSelection) {
                this.selectionSettings.persistSelection = true;
                this.selectionSettings.type = 'Multiple';
            }
        }
        prepareColumns(this.columns, this.enableColumnVirtualization, this);
        if (this.enableColumnVirtualization && this.isChangeDataSourceCall && this.columnModel) {
            this.columnModel = [];
            this.updateColumnModel(this.columns);
        }
        this.isPreparedFrozenColumns = true;
        if (this.enablePersistence) {
            this.notify(events.columnsPrepared, {});
        }
        this.getMediaColumns();
        setColumnIndex(this.columns);
        if (this.isFrozenGrid() && !this.mergedColumns) {
            this.setInitialFrozenColumnIndex(this.columns);
        }
        this.checkLockColumns(this.columns);
        this.getColumns();
        this.processModel();
        this.gridRender();
        this.wireEvents();
        this.addListener();
        this.updateDefaultCursor();
        this.updateStackedFilter();
        if (this.loadingIndicator.indicatorType === 'Spinner') {
            this.showSpinner();
        }
        this.notify(events.initialEnd, {});
        if (this.loadingIndicator.indicatorType === 'Shimmer') {
            this.refreshMaskRow();
        }
        if (this.refreshing) {
            this.trigger('created');
        }
    }
    setInitialFrozenColumnIndex(columns) {
        for (let i = 0; i < columns.length; i++) {
            const column = columns[parseInt(i.toString(), 10)];
            column[`${literals.initialFrozenColumnIndex}`] = column.index;
            if (column.columns) {
                this.setInitialFrozenColumnIndex(column.columns);
            }
        }
    }
    /**
     * By default, grid shows the spinner for all its actions. You can use this method to show spinner at your needed time.
     *
     * @returns {void}
     */
    showSpinner() {
        if (!this.isExportGrid) {
            showSpinner(this.element);
        }
    }
    /**
     * By default, grid shows the spinner for all its actions. You can use this method to show spinner at your needed time.
     *
     * @returns {void}
     */
    hideSpinner() {
        if (!this.isExportGrid) {
            hideSpinner(this.element);
        }
    }
    showMaskRow(axisDirection, dialogElement) {
        if (isNullOrUndefined(this.headerModule) || isNullOrUndefined(this.contentModule)) {
            return;
        }
        const gridHeader = this.getHeaderContent().firstChild;
        const gridContent = this.getContent().firstChild;
        const gridFooter = this.getFooterContent();
        if (dialogElement) {
            const dialogHolder = dialogElement.querySelector('.e-checkboxlist');
            if (!isNullOrUndefined(dialogHolder)) {
                const maskRowCount = Math.floor(dialogHolder.getBoundingClientRect().height / this.getRowHeight());
                const maskTemplate = '<div class="e-ftrchk e-mask-ftrchk">'
                    + '<div class="e-checkbox-wrapper"><input class="e-chk-hidden">'
                    + this.getShimmerTemplate() + this.getShimmerTemplate() + '</div></div>';
                dialogHolder.innerHTML = '';
                for (let i = 0; i < maskRowCount; i++) {
                    dialogHolder.innerHTML += maskTemplate;
                    dialogHolder.querySelector('.e-ftrchk.e-mask-ftrchk').style.width = '100%';
                    dialogHolder.querySelector('.e-checkbox-wrapper').style.width = '100%';
                    const maskSpan = [].slice.call(dialogHolder
                        .querySelectorAll('.e-mask:not(.e-mask-checkbox-filter-intent):not(.e-mask-checkbox-filter-span-intent)'));
                    maskSpan[0].classList.add('e-mask-checkbox-filter-intent');
                    maskSpan[1].classList.add('e-mask-checkbox-filter-span-intent');
                }
            }
            return;
        }
        if ((!this.enableRtl && !this.getHeaderContent().style.paddingRight)
            || (this.enableRtl && !this.getHeaderContent().style.paddingLeft)) {
            gridContent.style.overflowY = 'hidden';
        }
        if (!this.isInitialLoad && !this.getColumns().length) {
            const contentHeight = gridContent.getBoundingClientRect().height;
            const maskTableHeight = contentHeight === 0 ? this.allowPaging ? this.pageSettings.pageSize * this.getRowHeight()
                : window.innerHeight : contentHeight;
            const contentRowCount = Math.ceil(maskTableHeight / this.getRowHeight());
            if (this.rowRenderingMode !== 'Vertical') {
                this.headerMaskTable = this.createEmptyMaskTable(gridHeader, 1);
            }
            this.contentMaskTable = this.createEmptyMaskTable(gridContent, contentRowCount);
            return;
        }
        this.maskRowContentScroll = (this.enableVirtualization || this.enableColumnVirtualization) && axisDirection ? true : false;
        if (!this.contentMaskTable) {
            let content = gridContent;
            if (this.enableVirtualization || this.enableColumnVirtualization) {
                content = content.querySelector('.e-virtualtable');
            }
            if (!isNullOrUndefined(content.querySelector('tbody'))) {
                this.contentMaskTable = this.createMaskTable(content, this.getContentMaskColumns(), axisDirection);
            }
        }
        if (!this.headerMaskTable && ((this.isFrozenGrid() && !this.isRowPinned && !this.pinnedTopRowModels.length) || (this.enableColumnVirtualization && axisDirection === 'X'))) {
            let content = gridHeader;
            if (this.enableColumnVirtualization && axisDirection === 'X') {
                content = content.querySelector('.e-virtualtable');
            }
            this.headerMaskTable = this.createMaskTable(content, this.getContentMaskColumns(), axisDirection);
        }
        if (gridFooter && gridFooter.querySelector('.e-summaryrow')) {
            const gridFooterContent = gridFooter.firstChild;
            if (!this.footerContentMaskTable) {
                const footerContent = gridFooterContent;
                this.footerContentMaskTable = this.createMaskTable(footerContent);
            }
        }
        if (!(this.enableVirtualization && axisDirection)) {
            EventHandler.add(gridContent, 'scroll', this.translateMaskRow, this);
        }
    }
    getContentMaskColumns() {
        return this.getColumns();
    }
    createEmptyMaskTable(maskElement, rowCount) {
        const table = this.createElement('table', { className: 'e-table e-masked-table' });
        const tbody = this.createElement('tbody', { className: 'e-masked-tbody' });
        const row = this.createElement('tr', { className: 'e-masked-row e-row' });
        row.style.height = `${this.getRowHeight()}px`;
        const cell = this.createElement('td', { className: 'e-masked-cell e-rowcell' });
        cell.innerHTML = this.getShimmerTemplate();
        row.appendChild(cell);
        for (let i = 0; i < rowCount; i++) {
            tbody.appendChild(row.cloneNode(true));
        }
        table.appendChild(tbody);
        maskElement.appendChild(table);
        return table;
    }
    createFrozenMaskRow(td, columns) {
        for (let i = 0; i < td.length; i++) {
            if (i < this.frozenLeftCount) {
                if (this.frozenLeftCount - 1 === i) {
                    td[parseInt(i.toString(), 10)].classList.add('e-freezeleftborder');
                }
                td[parseInt(i.toString(), 10)].classList.add('e-leftfreeze');
                td[parseInt(i.toString(), 10)].setAttribute('aria-colindex', (i + 1).toString());
                td[parseInt(i.toString(), 10)].style.left = (columns[parseInt(i.toString(), 10)].valueX -
                    this.translateX) + 'px';
            }
            else if ((td.length - this.frozenRightCount) <= i && columns[parseInt(i.toString(), 10)]) {
                if ((td.length - this.frozenRightCount) === i) {
                    td[parseInt(i.toString(), 10)].classList.add('e-freezerightborder');
                }
                td[parseInt(i.toString(), 10)].classList.add('e-rightfreeze');
                td[parseInt(i.toString(), 10)].setAttribute('aria-colindex', (i + 1).toString());
                td[parseInt(i.toString(), 10)].style.right = (this.translateX +
                    columns[parseInt(i.toString(), 10)].valueX) + 'px';
            }
        }
    }
    createMaskTable(element, columns, axisDirection) {
        const parentElement = element;
        const header = closest(parentElement, '.e-gridheader') ? true : false;
        const content = closest(parentElement, '.e-gridcontent') ? true : false;
        const footer = closest(parentElement, '.e-gridfooter') ? true : false;
        const gridContent = this.getContent().firstChild;
        const gridContentScrollHeight = gridContent.scrollHeight;
        const table = parentElement.querySelector('table');
        const maskTable = table.cloneNode();
        maskTable.removeAttribute('role');
        maskTable.removeAttribute('id');
        updateCSSText(maskTable, `position: absolute; z-index: 5; width: ${table.getBoundingClientRect().width}px;`);
        if (header && !(this.enableColumnVirtualization && axisDirection === 'X')) {
            maskTable.style.transform = 'translate(0px,'
                + table.querySelector('thead').getBoundingClientRect().height + 'px)';
        }
        maskTable.setAttribute('class', 'e-table e-masked-table');
        const maskColgroup = table.querySelector('colgroup').cloneNode(true);
        maskColgroup.removeAttribute('id');
        maskColgroup.setAttribute('class', 'e-masked-colgroup');
        maskTable.appendChild(maskColgroup);
        if (header && this.enableColumnVirtualization && axisDirection === 'X') {
            const row = this.createMaskRow(maskColgroup, columns);
            if (this.isFrozenGrid()) {
                const frozenTd = [].slice.call(row.querySelectorAll('.e-rowcell'));
                this.createFrozenMaskRow(frozenTd, columns);
            }
            const thead = table.querySelector('thead');
            const rows = [].slice.call(thead.querySelectorAll('tr'));
            const maskTHead = thead.cloneNode();
            maskTHead.removeAttribute('role');
            maskTHead.setAttribute('class', 'e-masked-thead');
            const rowCount = rows.length;
            for (let i = 0; i < rowCount; i++) {
                maskTHead.appendChild(row.cloneNode(true));
                maskTHead.childNodes[parseInt(i.toString(), 10)].style
                    .height = rows[parseInt(i.toString(), 10)].getBoundingClientRect().height + 'px';
            }
            maskTable.appendChild(maskTHead);
        }
        const maskTBody = table.querySelector('tbody').cloneNode();
        maskTBody.removeAttribute('role');
        maskTBody.setAttribute('class', 'e-masked-tbody');
        const tbody = table.querySelector('tbody');
        if (content || header) {
            const rowCountElement = gridContent;
            let rowCount = Math.ceil(rowCountElement.getBoundingClientRect().height / this.getRowHeight());
            if (this.allowPaging && this.pageSettings.pageSize !== this.currentViewData.length &&
                this.pagerModule.pagerObj.totalPages !== this.pageSettings.currentPage) {
                const row = this.createMaskRow(maskColgroup, columns);
                const altRow = row.cloneNode(true);
                altRow.classList.add('e-altrow');
                for (let i = 0; i < this.pageSettings.pageSize - this.currentViewData.length; i++) {
                    maskTBody.appendChild((i % 2 === 1) ? altRow.cloneNode(true) : row.cloneNode(true));
                }
            }
            if (tbody.querySelector('.e-emptyrow') || !tbody.childNodes.length || (content && this.childGrid)) {
                const row = this.createMaskRow(maskColgroup, columns);
                const altRow = row.cloneNode(true);
                altRow.classList.add('e-altrow');
                for (let i = 0; i < rowCount; i++) {
                    const altNumber = 1;
                    maskTBody.appendChild((i + altNumber) % 2 === 0 ? altRow.cloneNode(true) : row.cloneNode(true));
                }
            }
            else {
                let rowsQuery = 'tr:not(.e-hide):not([style*="display:none"]):not([style*="display: none"])';
                if (this.isTreeGrid) {
                    rowsQuery = 'tr:not(.e-hide):not([style*="display:none"]):not([style*="display: none"]):not(.e-childrow-hidden)';
                }
                const rows = [].slice.call(tbody.querySelectorAll(rowsQuery));
                const addEditRow = tbody.querySelector('.e-addedrow, .e-editedrow');
                let addEditRowIndex;
                if (addEditRow) {
                    addEditRowIndex = rows.indexOf(addEditRow);
                    if (this.isFrozenGrid() && this.enableColumnVirtualization) {
                        const frzTd = [].slice.call(rows[addEditRowIndex + 1].querySelectorAll('.e-rowcell'));
                        for (let i = 0; i < frzTd.length; i++) {
                            if (i < this.frozenLeftCount) {
                                frzTd[parseInt(i.toString(), 10)].classList.add('e-leftfreeze');
                                frzTd[parseInt(i.toString(), 10)].setAttribute('aria-colindex', (i + 1).toString());
                                frzTd[parseInt(i.toString(), 10)].style.left = (columns[parseInt(i.toString(), 10)].valueX - this.translateX) + 'px';
                            }
                            else if ((frzTd.length - this.frozenRightCount) <= i && columns[parseInt(i.toString(), 10)]) {
                                frzTd[parseInt(i.toString(), 10)].classList.add('e-rightfreeze');
                                frzTd[parseInt(i.toString(), 10)].setAttribute('aria-colindex', (i + 1).toString());
                                frzTd[parseInt(i.toString(), 10)].style.right = (this.translateX +
                                    columns[parseInt(i.toString(), 10)].valueX) + 'px';
                            }
                        }
                    }
                    if (addEditRow.classList.contains('e-addedrow')) {
                        rows.splice(addEditRowIndex, 2);
                    }
                    else {
                        rows.splice(addEditRowIndex, 1);
                    }
                }
                rowCount = (this.enableVirtualization || this.enableColumnVirtualization) && axisDirection ? rows.length
                    : rowCount <= rows.length ? rowCount : rows.length;
                for (let i = 0; i < rowCount; i++) {
                    const maskTBodyRow = this.applyMaskRow(rows[parseInt(i.toString(), 10)].cloneNode(true), rows[parseInt(i.toString(), 10)].getBoundingClientRect().height);
                    if (this.enableColumnVirtualization && axisDirection === 'X' && this.isFrozenGrid()) {
                        const frozenTd = [].slice.call(maskTBodyRow.querySelectorAll('.e-masked-cell'));
                        this.createFrozenMaskRow(frozenTd, columns);
                    }
                    maskTBody.appendChild(maskTBodyRow);
                }
                if (addEditRow && addEditRow.classList.contains('e-editedrow') && addEditRowIndex < rowCount) {
                    const addEditMaskRow = maskTBody.childNodes[parseInt(addEditRowIndex.toString(), 10)];
                    addEditMaskRow.style.height = this.getRowHeight() + 'px';
                    addEditMaskRow.classList.add('e-row');
                    if (addEditRow.classList.contains('e-altrow')) {
                        addEditMaskRow.classList.add('e-altrow');
                    }
                }
            }
        }
        maskTable.appendChild(maskTBody);
        if (footer) {
            const tfoot = table.querySelector('tfoot');
            const maskTFoot = tfoot.cloneNode();
            maskTFoot.setAttribute('class', 'e-masked-tfoot');
            const rows = [].slice.call(tfoot.querySelectorAll('tr'));
            for (let i = 0; i < rows.length; i++) {
                maskTFoot.appendChild(this.applyMaskRow(rows[parseInt(i.toString(), 10)].cloneNode(true), rows[parseInt(i.toString(), 10)].getBoundingClientRect().height));
            }
            maskTable.appendChild(maskTFoot);
        }
        if (header && this.isFrozenGrid() && !this.enableColumnVirtualization) {
            this.getHeaderContent().querySelector('.' + literals.headerContent).style.position = 'relative';
        }
        parentElement.insertBefore(maskTable, parentElement.firstChild);
        if (content && !(this.enableVirtualization && axisDirection)) {
            let minScrollTop = gridContentScrollHeight - maskTable.getBoundingClientRect().height;
            minScrollTop = minScrollTop < 0 ? 0 : minScrollTop;
            let scrollTop = gridContent.scrollTop <= minScrollTop ? gridContent.scrollTop : minScrollTop;
            if (this.enableVirtualization) {
                scrollTop -= getTransformValues(closest(parentElement, '.e-virtualtable')).height;
            }
            maskTable.style.transform = 'translate(0px,' + scrollTop + 'px)';
        }
        return maskTable;
    }
    applyMaskRow(row, rowHeight) {
        const maskRow = row;
        maskRow.removeAttribute('role');
        maskRow.removeAttribute('aria-rowindex');
        maskRow.removeAttribute('data-uid');
        maskRow.classList.add('e-masked-row');
        maskRow.style.height = rowHeight + 'px';
        const maskCells = [].slice.call(maskRow.childNodes);
        for (let i = 0; i < maskCells.length; i++) {
            const maskCell = maskCells[parseInt(i.toString(), 10)];
            const displayAsCheckBoxCell = maskCell.firstChild && maskCell.firstChild.classList
                && maskCell.firstChild.classList.contains('e-checkbox-wrapper');
            maskCell.removeAttribute('role');
            maskCell.removeAttribute('tabindex');
            maskCell.removeAttribute('aria-label');
            if (this.enableColumnVirtualization && maskCell.classList.contains('e-fixedfreeze')) {
                removeClass([maskCell], ['e-fixedfreeze', 'e-freezeleftborder', 'e-freezerightborder']);
                addClass([maskCell], ['e-unfreeze']);
            }
            maskCell.removeAttribute('aria-colindex');
            maskCell.removeAttribute('data-index');
            maskCell.removeAttribute('data-mappingname');
            maskCell.removeAttribute('data-mappingvalue');
            maskCell.removeAttribute('data-mappinguid');
            maskCell.removeAttribute('aria-expanded');
            maskCell.classList.add('e-masked-cell');
            maskCell.innerHTML = this.getShimmerTemplate();
            if (maskCell.classList.contains('e-recordplusexpand') || maskCell.classList.contains('e-recordpluscollapse')) {
                maskCell.firstChild.classList.add('e-mask-group-intent');
            }
            else if (maskCell.classList.contains('e-gridchkbox') || displayAsCheckBoxCell) {
                maskCell.firstChild.classList.add('e-mask-checkbox-intent');
            }
            else if (maskCell.classList.contains('e-rowdragdrop')) {
                maskCell.firstChild.classList.add('e-mask-drag-intent');
            }
            else if (maskCell.classList.contains('e-indentcell')) {
                maskCell.innerHTML = '';
            }
        }
        return maskRow;
    }
    createMaskRow(refColgroup, refColumns) {
        const colgroup = refColgroup;
        const columns = refColumns;
        const row = this.createElement('tr', { className: 'e-masked-row e-row' });
        if (this.rowRenderingMode !== 'Vertical') {
            row.style.height = this.getRowHeight() + 'px';
        }
        const td = this.createElement('td', { className: 'e-masked-cell e-rowcell' });
        for (let i = 0, colIndex = 0; i < colgroup.childNodes.length; i++) {
            const col = colgroup.childNodes[parseInt(i.toString(), 10)];
            const localTD = td.cloneNode();
            localTD.innerHTML = this.getShimmerTemplate();
            if (!(col.classList.contains('e-group-intent') || col.classList.contains('e-detail-intent')
                || col.classList.contains('e-drag-intent'))) {
                if (this.rowRenderingMode === 'Vertical' && columns[parseInt(colIndex.toString(), 10)]) {
                    localTD.setAttribute('data-cell', columns[parseInt(colIndex.toString(), 10)].headerText ?
                        columns[parseInt(colIndex.toString(), 10)].headerText : columns[parseInt(colIndex.toString(), 10)].field);
                }
                if (col.style.display === 'none') {
                    localTD.classList.add('e-hide');
                }
                else {
                    localTD.style.textAlign = columns[parseInt(colIndex.toString(), 10)]
                        && columns[parseInt(colIndex.toString(), 10)].textAlign ?
                        columns[parseInt(colIndex.toString(), 10)].textAlign.toLowerCase()
                        : this.enableRtl ? 'right' : 'left';
                    if (columns[parseInt(colIndex.toString(), 10)] && (columns[parseInt(colIndex.toString(), 10)].type === 'checkbox'
                        || columns[parseInt(colIndex.toString(), 10)].displayAsCheckBox)) {
                        localTD.firstChild.classList.add('e-mask-checkbox-intent');
                    }
                }
                colIndex++;
            }
            else {
                if (col.classList.contains('e-group-intent')) {
                    localTD.firstChild.classList.add('e-mask-group-intent');
                }
                else if (col.classList.contains('e-detail-intent')) {
                    localTD.firstChild.classList.add('e-mask-detail-intent');
                }
                else if (col.classList.contains('e-drag-intent')) {
                    localTD.firstChild.classList.add('e-mask-drag-intent');
                }
            }
            row.appendChild(localTD);
        }
        return row;
    }
    getShimmerTemplate() {
        if (this.maskRowContentScroll) {
            return '<span class="e-mask e-skeleton e-skeleton-text"></span>';
        }
        return '<span class="e-mask e-skeleton e-skeleton-text e-shimmer-wave"></span>';
    }
    addShimmerEffect() {
        this.maskRowContentScroll = false;
        const maskSpan = [].slice.call(this.element.querySelectorAll('.e-mask:not(.e-shimmer-wave)'));
        for (let i = 0; i < maskSpan.length; i++) {
            if (maskSpan[parseInt(i.toString(), 10)]) {
                maskSpan[parseInt(i.toString(), 10)].classList.add('e-shimmer-wave');
            }
        }
    }
    translateMaskRow(e) {
        const target = e.target;
        const maskTables = target.querySelectorAll('.e-masked-table');
        for (let i = 0; i < maskTables.length; i++) {
            const maskTable = maskTables[parseInt(i.toString(), 10)];
            if (maskTable) {
                let minScrollTop = target.scrollHeight - maskTable.getBoundingClientRect().height;
                minScrollTop = minScrollTop < 0 ? 0 : minScrollTop;
                let scrollTop = target.scrollTop <= minScrollTop ? target.scrollTop : minScrollTop;
                if (this.enableVirtualization) {
                    scrollTop -= getTransformValues(closest(maskTable, '.e-virtualtable')).height;
                }
                maskTable.style.transform = 'translate(0px,' + scrollTop + 'px)';
            }
        }
    }
    removeMaskRow() {
        if (!isNullOrUndefined(this.contentModule)) {
            const gridContent = this.getContent().firstChild;
            EventHandler.remove(gridContent, 'scroll', this.translateMaskRow);
        }
        if (this.headerMaskTable && this.isFrozenGrid() && !this.enableColumnVirtualization) {
            this.getHeaderContent().querySelector('.' + literals.headerContent).style.position = '';
        }
        const maskTables = [this.headerMaskTable,
            this.contentMaskTable, this.footerContentMaskTable];
        for (let i = 0; i < maskTables.length; i++) {
            const maskTable = maskTables[parseInt(i.toString(), 10)];
            if (maskTable) {
                remove(maskTable);
            }
        }
        this.headerMaskTable = null;
        this.contentMaskTable = null;
        this.footerContentMaskTable = null;
    }
    refreshMaskRow() {
        const gridContent = this.getContent().firstChild;
        if (!this.isInitialLoad && !this.getColumns().length) {
            return;
        }
        if (this.contentMaskTable && gridContent.querySelector('.e-masked-table')) {
            let content = gridContent;
            if (this.enableVirtualization) {
                content = content.querySelector('.e-virtualtable');
            }
            this.refreshMaskRowColgroupWidth(content);
        }
    }
    refreshMaskRowColgroupWidth(content) {
        const table = content.querySelector('table:not(.e-masked-table)');
        const colgroup = table.querySelector(literals.colGroup).cloneNode(true);
        const maskTable = content.querySelector('.e-masked-table');
        colgroup.removeAttribute('id');
        colgroup.setAttribute('class', 'e-masked-colgroup');
        for (let i = 0; i < colgroup.childNodes.length; i++) {
            colgroup.childNodes[parseInt(i.toString(), 10)].removeAttribute('class');
        }
        remove(maskTable.querySelector('.e-masked-colgroup'));
        maskTable.insertBefore(colgroup, maskTable.firstChild);
        maskTable.style.width = table.getBoundingClientRect().width + 'px';
    }
    updateStackedFilter() {
        if (this.allowFiltering && this.filterSettings.type === 'FilterBar' &&
            this.getHeaderContent().getElementsByClassName('e-stackedheadercell').length) {
            this.getHeaderContent().classList.add('e-stackedfilter');
        }
        else {
            this.getHeaderContent().classList.remove('e-stackedfilter');
        }
    }
    getMediaColumns() {
        if (!this.enableColumnVirtualization) {
            const gcol = this.getColumns();
            this.getShowHideService = this.serviceLocator.getService('showHideService');
            if (!isNullOrUndefined(gcol)) {
                for (let index = 0; index < gcol.length; index++) {
                    if (!isNullOrUndefined(gcol[parseInt(index.toString(), 10)].hideAtMedia)
                        && (isNullOrUndefined(gcol[parseInt(index.toString(), 10)].visible)
                            || gcol[parseInt(index.toString(), 10)].visible)) {
                        this.pushMediaColumn(gcol[parseInt(index.toString(), 10)], index);
                    }
                }
            }
        }
        this.updateFrozenColumnsWidth();
    }
    pushMediaColumn(col, index) {
        this.mediaCol.push(col);
        this.media[col.uid] = window.matchMedia(col.hideAtMedia);
        this.mediaQueryUpdate(index, this.media[col.uid]);
        this.mediaBindInstance[parseInt(index.toString(), 10)] = this.mediaQueryUpdate.bind(this, index);
        this.media[col.uid].addListener(this.mediaBindInstance[parseInt(index.toString(), 10)]);
    }
    /**
     * @param {Column} col - specifies the column
     * @returns {void}
     * @hidden
     */
    updateMediaColumns(col) {
        if (!this.enableColumnVirtualization) {
            const index = this.getColumnIndexByUid(col.uid);
            for (let i = 0; i < this.mediaCol.length; i++) {
                if (col.uid === this.mediaCol[parseInt(i.toString(), 10)].uid) {
                    this.mediaCol.splice(i, 1);
                    return;
                }
            }
            this.pushMediaColumn(col, index);
        }
    }
    /**
     * @param {number} columnIndex - specifies the column index
     * @param {MediaQueryList} e - specifies the MediaQueryList
     * @returns {void}
     * @hidden
     */
    mediaQueryUpdate(columnIndex, e) {
        const col = this.getColumns()[parseInt(columnIndex.toString(), 10)];
        if (this.mediaCol.some((mediaColumn) => mediaColumn.uid === col.uid)) {
            col.visible = e.matches;
            if (this.isInitialLoad) {
                this.invokedFromMedia = true;
                if (col.visible) {
                    this.showHider.show(col.headerText, 'headerText');
                }
                else {
                    this.showHider.hide(col.headerText, 'headerText');
                }
            }
        }
    }
    refreshMediaCol() {
        this.isInitialLoad = true;
        const footerContent = this.element.querySelector('.' + literals.gridFooter);
        if (this.aggregates.length && this.element.scrollHeight > parseInt(this.height.toString(), 10) && footerContent) {
            addClass([footerContent], ['e-footerpadding']);
        }
        const columns = this.enableColumnVirtualization ? this.columns : this.getColumns();
        const checkboxColumn = columns.filter((col) => col.type === 'checkbox');
        if (checkboxColumn.length === 0 || checkboxColumn.length && this.selectionSettings.checkboxMode === 'ResetOnRowClick') {
            this.isCheckBoxSelection = false;
        }
        if (this.rowRenderingMode === 'Vertical') {
            if (this.enableHover) {
                this.setProperties({ enableAdaptiveUI: true, enableHover: false }, true);
                removeClass([this.element], 'e-gridhover');
            }
        }
        if (this.enableAdaptiveUI && this.scrollModule) {
            this.scrollModule.refresh();
        }
        if (this.isFrozenGrid() && this.isAutoGenerateColumns) {
            this.widthService.setWidthToColumns();
            this.isAutoGenerateColumns = false;
        }
    }
    removeMediaListener() {
        for (let i = 0; i < this.mediaCol.length; i++) {
            this.media[this.mediaCol[parseInt(i.toString(), 10)].uid]
                .removeListener(this.mediaBindInstance[this.mediaCol[parseInt(i.toString(), 10)].index]);
        }
    }
    /**
     * For internal use only - Initialize the event handler
     *
     * @returns {void}
     * @private
     */
    eventInitializer() {
        //eventInitializer
    }
    /**
     * Destroys the component (detaches/removes all event handlers, attributes, classes, and empties the component element).
     *
     * @function destroy
     * @returns {void}
     */
    destroy() {
        const gridElement = this.element;
        if (!gridElement) {
            return;
        }
        const hasGridChild = gridElement.querySelector('.' + literals.gridHeader) &&
            gridElement.querySelector('.' + literals.gridContent) ? true : false;
        if (hasGridChild) {
            this.unwireEvents();
        }
        this.removeListener();
        this.removeMediaListener();
        this.notify(events.destroy, {});
        this.destroyDependentModules();
        if (this.isReact) {
            this.destroyTemplate(['template']);
        }
        if (this.isVue) {
            this.destroyTemplate();
        }
        if (hasGridChild) {
            super.destroy();
        }
        this.toolTipObj.destroy();
        if (this.isReact && !Browser.isIE) {
            this.element.innerHTML = '';
        }
        const modules = ['renderModule', 'headerModule', 'contentModule', 'valueFormatterService',
            'serviceLocator', 'ariaService', 'keyboardModule', 'widthService', 'searchModule', 'showHider',
            'scrollModule', 'printModule', 'clipboardModule', 'focusModule'];
        for (let i = 0; i < modules.length; i++) {
            if (this[modules[parseInt(i.toString(), 10)]]) {
                this[modules[parseInt(i.toString(), 10)]] = null;
            }
        }
        this.element.innerHTML = '';
        classList(this.element, [], ['e-rtl', 'e-gridhover', 'e-responsive', 'e-default', 'e-device', 'e-grid-min-height']);
    }
    destroyDependentModules() {
        const gridElement = this.element;
        if (!gridElement || (!gridElement.querySelector('.' + literals.gridHeader) && !gridElement.querySelector('.' + literals.gridContent))) {
            return;
        }
        this.scrollModule.destroy();
        this.keyboardModule.destroy();
        this.focusModule.destroy();
        this.clipboardModule.destroy();
        this.printModule.destroy();
    }
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} returns the module name
     * @private
     */
    getModuleName() {
        return 'grid';
    }
    enableBoxSelection() {
        if (this.enableAutoFill) {
            this.selectionSettings.cellSelectionMode = 'BoxWithBorder';
            this.element.classList.add('e-afenabled');
        }
        else {
            this.element.classList.remove('e-afenabled');
            this.notify(events.destroyAutoFillElements, {});
        }
    }
    setCSSClass(oldCSSClass) {
        if (this.cssClass) {
            addClass([this.element], this.cssClass.split(' '));
        }
        if (oldCSSClass) {
            removeClass([this.element], oldCSSClass.split(' '));
        }
    }
    /**
     * Called internally if any of the property value changed.
     *
     * @param {GridModel} newProp - Defines new properties
     * @param {GridModel} oldProp - Defines old properties
     * @returns {void}
     * @hidden
     */
    onPropertyChanged(newProp, oldProp) {
        let requireRefresh = false;
        let requireGridRefresh = false;
        let freezeRefresh = false;
        let checkCursor;
        const args = { requestType: 'refresh' };
        let childGridParent = null;
        let parentInstance = null;
        if (this.isDestroyed) {
            return;
        }
        this.log('module_missing');
        if (this.isEllipsisTooltip()) {
            this.toolTipObj.close();
        }
        const properties = Object.keys(newProp);
        if (properties.indexOf('columns') > -1) {
            if (this.enableColumnVirtualization) {
                this.columnModel = [];
            }
            this.updateColumnObject();
            requireGridRefresh = true;
        }
        for (const prop of properties) {
            switch (prop) {
                case 'allowPaging':
                    this.notify(events.uiUpdate, { module: 'pager', enable: this.allowPaging });
                    requireRefresh = true;
                    if (this.height === '100%') {
                        this.scrollModule.refresh();
                    }
                    this.getDataModule().clearCache();
                    break;
                case 'pageSettings':
                    if (this.pageTemplateChange) {
                        this.pageTemplateChange = false;
                        this.notify(events.inBoundModelChanged, { module: 'pager', properties: newProp.pageSettings });
                        break;
                    }
                    if (this.pagerModule && this.pagerModule.isCancel) {
                        this.pagerModule.isCancel = false;
                        return;
                    }
                    this.notify(events.inBoundModelChanged, { module: 'pager', properties: newProp.pageSettings });
                    if (isNullOrUndefined(newProp.pageSettings.currentPage) && isNullOrUndefined(newProp.pageSettings.pageSize)
                        && isNullOrUndefined(newProp.pageSettings.totalRecordsCount)
                        || !isNullOrUndefined(oldProp.pageSettings) &&
                            ((newProp.pageSettings.currentPage !== oldProp.pageSettings.currentPage)
                                && !this.enableColumnVirtualization && !this.enableVirtualization && this.pageRequireRefresh
                                && this.pageSettings.totalRecordsCount <= this.pageSettings.pageSize)) {
                        requireRefresh = true;
                    }
                    if (!this.pageRequireRefresh) {
                        this.pageRequireRefresh = true;
                    }
                    if (this.pagerModule && this.pagerModule.isCancel) {
                        this.pagerModule.isCancel = false;
                    }
                    break;
                case 'allowSorting':
                    this.notify(events.uiUpdate, { module: 'sort', enable: this.allowSorting });
                    requireRefresh = true;
                    checkCursor = true;
                    break;
                case 'allowFiltering':
                    this.updateStackedFilter();
                    this.notify(events.uiUpdate, { module: 'filter', enable: this.allowFiltering });
                    requireRefresh = true;
                    if (this.filterSettings.type !== 'FilterBar' || (this.editSettings.showAddNewRow && this.filterSettings.type === 'FilterBar')) {
                        this.refreshHeader();
                    }
                    else {
                        if (this.height === '100%') {
                            this.scrollModule.refresh();
                        }
                    }
                    break;
                case 'height':
                case 'width':
                    this.notify(events.uiUpdate, { module: 'scroll', properties: { width: newProp.width, height: newProp.height } });
                    if (this.allowPaging) {
                        this.pagerModule.refresh();
                    }
                    break;
                case 'allowReordering':
                    this.headerModule.refreshUI();
                    checkCursor = true;
                    break;
                case 'allowRowDragAndDrop':
                    this.notify(events.uiUpdate, { module: 'rowDragAndDrop', enable: this.allowRowDragAndDrop });
                    this.renderModule.refresh();
                    this.headerModule.refreshUI();
                    break;
                case 'allowSelection':
                    this.notify(events.uiUpdate, { module: 'selection', enable: this.allowSelection });
                    this.renderModule.refresh();
                    break;
                case 'cssClass':
                    this.setCSSClass(oldProp.cssClass);
                    break;
                case 'enableAutoFill':
                    if (this.selectionModule) {
                        this.enableBoxSelection();
                        this.selectionModule.updateAutoFillPosition();
                    }
                    break;
                case 'rowTemplate':
                    this.rowTemplateFn = templateCompiler(this.rowTemplate);
                    requireRefresh = true;
                    break;
                case 'emptyRecordTemplate':
                    this.emptyRecordTemplateFn = templateCompiler(this.emptyRecordTemplate);
                    requireRefresh = true;
                    break;
                case 'detailTemplate':
                    this.detailTemplateFn = templateCompiler(this.detailTemplate);
                    requireRefresh = true;
                    break;
                case 'allowGrouping':
                    this.notify(events.uiUpdate, { module: 'group', enable: this.allowGrouping });
                    this.headerModule.refreshUI();
                    requireRefresh = true;
                    checkCursor = true;
                    if (this.height === '100%') {
                        this.scrollModule.refresh();
                    }
                    break;
                case 'enableInfiniteScrolling':
                case 'childGrid':
                    requireRefresh = true;
                    childGridParent = this.parentDetails ? document.querySelector(`#${this.parentDetails.parentID}`) : null;
                    parentInstance = childGridParent ? childGridParent.ej2_instances[0] : null;
                    if (this.childGrid && parentInstance && isNullOrUndefined(parentInstance.childGrid.childGrid)) {
                        const childGridObject = Object.assign({}, parentInstance.childGrid, { childGrid: newProp.childGrid });
                        parentInstance.setProperties({ childGrid: childGridObject }, true);
                        while (!isNullOrUndefined(parentInstance.parentDetails)) {
                            const currentParent = document.querySelector(`#${parentInstance.parentDetails.parentID}`);
                            const currentParentInstance = currentParent ? currentParent.ej2_instances[0] : null;
                            if (currentParentInstance) {
                                const currentChildObject = Object.assign({}, currentParentInstance.childGrid);
                                currentChildObject.childGrid = parentInstance.childGrid;
                                currentParentInstance.setProperties({ childGrid: currentChildObject }, true);
                            }
                            parentInstance = currentParentInstance;
                        }
                    }
                    this.headerModule.refreshUI();
                    break;
                case 'toolbar':
                    this.notify(events.uiUpdate, { module: 'toolbar' });
                    if (this.height === '100%') {
                        this.scrollModule.refresh();
                    }
                    break;
                case 'groupSettings':
                    this.notify(events.inBoundModelChanged, {
                        module: 'group', properties: newProp.groupSettings,
                        oldProperties: oldProp.groupSettings
                    });
                    break;
                case 'aggregates':
                    if (!this.aggregates.length && this.allowGrouping && this.groupSettings.columns.length) {
                        requireRefresh = true;
                    }
                    this.notify(events.uiUpdate, { module: 'aggregate', properties: newProp });
                    if (this.height === '100%') {
                        this.scrollModule.refresh();
                    }
                    break;
                case 'frozenColumns':
                case 'frozenRows':
                case 'enableVirtualization':
                case 'enableColumnVirtualization':
                case 'currencyCode':
                case 'locale':
                    if (this.isFrozenGrid()) {
                        this.log('frozen_rows_columns');
                    }
                    freezeRefresh = true;
                    requireGridRefresh = true;
                    this.addNewRowFocus = true;
                    break;
                case 'query':
                    if (!this.getDataModule().isQueryInvokedFromData) {
                        requireRefresh = true;
                    }
                    this.getDataModule().isQueryInvokedFromData = false;
                    break;
                case 'autoFit':
                    if (this.autoFit) {
                        this.preventAdjustColumns();
                    }
                    else {
                        this.restoreAdjustColumns();
                    }
                    break;
                default:
                    this.extendedPropertyChange(prop, newProp, requireGridRefresh);
            }
        }
        if (checkCursor) {
            this.updateDefaultCursor();
        }
        if (requireGridRefresh) {
            if (freezeRefresh || this.getFrozenColumns() || this.frozenRows
                || (this.frozenLeftColumns.length || this.frozenRightColumns.length)) {
                this.freezeRefresh();
            }
            else {
                this.refresh();
            }
        }
        else if (requireRefresh) {
            this.notify(events.modelChanged, args);
            requireRefresh = false;
            this.maintainSelection(newProp.selectedRowIndex);
        }
    }
    extendedPropertyChange(prop, newProp, requireGridRefresh) {
        switch (prop) {
            case 'enableRtl':
                this.updateRTL();
                if (this.allowPaging) {
                    this.element.querySelector('.e-gridpager').ej2_instances[0].enableRtl = newProp.enableRtl;
                    this.element.querySelector('.e-gridpager').ej2_instances[0].dataBind();
                }
                if (this.height !== 'auto') {
                    this.scrollModule.removePadding(!newProp.enableRtl);
                    this.scrollModule.setPadding();
                }
                if (this.toolbar && this.toolbarModule) {
                    this.toolbarModule.getToolbar().ej2_instances[0].enableRtl = newProp.enableRtl;
                    this.toolbarModule.getToolbar().ej2_instances[0].dataBind();
                }
                if (this.contextMenuItems && this.contextMenuModule) {
                    this.contextMenuModule.getContextMenu().ej2_instances[0].enableRtl = newProp.enableRtl;
                    this.contextMenuModule.getContextMenu().ej2_instances[0].dataBind();
                }
                if (this.showColumnMenu && this.columnMenuModule && !this.enableAdaptiveUI) {
                    this.columnMenuModule.getColumnMenu().ej2_instances[0].enableRtl = newProp.enableRtl;
                    this.columnMenuModule.getColumnMenu().ej2_instances[0].dataBind();
                }
                if (this.filterSettings.type === 'FilterBar' && this.filterSettings.showFilterBarOperator) {
                    this.refreshHeader();
                }
                this.notify(events.rtlUpdated, {});
                break;
            case 'enableAltRow':
                this.renderModule.refresh();
                break;
            case 'allowResizing':
                if (this.resizeModule) {
                    this.resizeModule.render();
                }
                this.headerModule.refreshUI();
                this.updateResizeLines();
                break;
            case 'rowHeight':
                if (this.rowHeight) {
                    addClass([this.element], 'e-grid-min-height');
                }
                else {
                    removeClass([this.element], 'e-grid-min-height');
                }
                this.renderModule.refresh();
                this.headerModule.refreshUI();
                break;
            case 'gridLines':
                this.updateGridLines();
                break;
            case 'showColumnMenu':
                this.headerModule.refreshUI();
                this.notify(events.uiUpdate, { module: 'columnMenu', enable: true });
                break;
            case 'columnMenuItems':
                this.notify(events.uiUpdate, { module: 'columnMenu', enable: this.columnMenuItems });
                break;
            case 'contextMenuItems':
                this.notify(events.uiUpdate, { module: 'contextMenu', enable: this.contextMenuItems });
                break;
            case 'showColumnChooser':
                if (this.toolbarModule) {
                    this.toolbarModule.refreshToolbarItems();
                }
                this.notify(events.uiUpdate, { module: 'columnChooser', enable: this.showColumnChooser });
                break;
            case 'columnChooserSettings':
                this.notify(events.inBoundModelChanged, { module: 'columnChooser' });
                break;
            case 'filterSettings':
                this.updateStackedFilter();
                this.notify(events.inBoundModelChanged, { module: 'filter', properties: newProp.filterSettings });
                break;
            case 'searchSettings':
                this.notify(events.inBoundModelChanged, { module: 'search', properties: newProp.searchSettings });
                break;
            case 'sortSettings':
                this.notify(events.inBoundModelChanged, { module: 'sort' });
                break;
            case 'selectionSettings':
                this.notify(events.inBoundModelChanged, { module: 'selection', properties: newProp.selectionSettings });
                break;
            case 'editSettings':
                this.notify(events.inBoundModelChanged, { module: 'edit', properties: newProp.editSettings });
                break;
            case 'allowTextWrap':
            case 'textWrapSettings':
                if (this.allowTextWrap) {
                    this.applyTextWrap();
                }
                else {
                    this.removeTextWrap();
                }
                this.notify(events.freezeRender, { case: 'textwrap', isModeChg: (prop === 'textWrapSettings') });
                this.refreshHeader();
                if (this.height === '100%') {
                    this.scrollModule.refresh();
                }
                break;
            case 'dataSource':
                // eslint-disable-next-line no-case-declarations
                const requestPendingState = this.getDataModule().getState();
                if (this.allowPaging && this.pageSettings.pageSizes && !this.getDataModule().isRemote()
                    && !(requestPendingState && requestPendingState.isPending)) {
                    if (this.pagerModule.pagerObj.isAllPage) {
                        const count = this.dataSource instanceof DataManager ? this.dataSource.dataSource.json.length :
                            'result' in this.dataSource ? this.dataSource.count : this.dataSource.length;
                        const isAllPage = Array.isArray(this.pageSettings.pageSizes) &&
                            this.pageSettings.pageSizes.indexOf('All') > -1 ? true : this.pageSettings.pageSizes;
                        if (!isAllPage && this.pageSettings.pageSize !== count) {
                            this.pagerModule.pagerObj.isAllPage = false;
                        }
                        else {
                            this.setProperties({ pageSettings: { pageSize: count } }, true);
                            this.pagerModule.pagerObj.setProperties({ pageSize: count }, true);
                        }
                    }
                }
                if (this.allowSelection && this.isPersistSelection && !(requestPendingState && requestPendingState.isPending)) {
                    this.clearSelection();
                }
                this.partialSelectedRecords = [];
                this.partialSelectedIndexes = [];
                this.disableSelectedRecords = [];
                this.renderModule.selectableDataKey = {};
                this.renderModule.nonselectableDataKey = {};
                if (!isNullOrUndefined(this.dataSource) && this.dataSource.result) {
                    this.isVirtualAdaptive = false;
                }
                if (Object.getPrototypeOf(newProp).deepWatch) {
                    const pKeyField = this.getPrimaryKeyFieldNames()[0];
                    for (let i = 0, props = Object.keys(newProp.dataSource); i < props.length; i++) {
                        this.setRowData(getValue(pKeyField, this.dataSource[props[parseInt(i.toString(), 10)]]), this.dataSource[props[parseInt(i.toString(), 10)]]);
                    }
                }
                else if (requestPendingState.isPending) {
                    let gResult = !isNullOrUndefined(this.dataSource) ? this.dataSource.result : [];
                    const names = (requestPendingState.group || []);
                    if (names.length && !this.groupSettings.enableLazyLoading && !(gResult.length && gResult[0].field)) {
                        for (let i = 0; i < names.length; i++) {
                            gResult = DataUtil.group(gResult, names[parseInt(i.toString(), 10)], requestPendingState.aggregates
                                || []);
                        }
                    }
                    this.dataSource = {
                        result: gResult, count: this.dataSource.count,
                        aggregates: this.dataSource.aggregates
                    };
                    this.getDataModule().setState({});
                    requestPendingState.resolver(this.dataSource);
                }
                else {
                    if ((!isNullOrUndefined(this.dataSource) && this.dataSource.result
                        && this.dataSource.count && this.groupSettings.columns.length)) {
                        let gResult = this.dataSource.result;
                        const names = this.groupSettings.columns;
                        if (names.length && !(gResult.length && gResult[0].field)) {
                            for (let i = 0; i < names.length; i++) {
                                gResult = DataUtil.group(gResult, names[parseInt(i.toString(), 10)]);
                            }
                        }
                        this.dataSource = {
                            result: gResult, count: this.dataSource.count
                        };
                    }
                    this.getDataModule().setState({ isDataChanged: false });
                    this.notify(events.dataSourceModified, {});
                    if (!requireGridRefresh) {
                        if (this.isRowSelectable && !this.isRemote()) {
                            const data = this.getDataModule().dataManager.executeLocal(this.getDataModule().generateQuery(true));
                            this.renderModule.setPartialRecord(data);
                        }
                        this.renderModule.refresh();
                        if (this.isCheckBoxSelection) {
                            this.notify(events.beforeRefreshOnDataChange, {});
                        }
                    }
                }
                this.scrollRefresh();
                break;
            case 'enableHover':
                // eslint-disable-next-line no-case-declarations
                const action = newProp.enableHover ? addClass : removeClass;
                action([this.element], 'e-gridhover');
                break;
            case 'selectedRowIndex':
                if (!this.isSelectedRowIndexUpdating) {
                    this.selectRow(newProp.selectedRowIndex);
                }
                this.isSelectedRowIndexUpdating = false;
                break;
            case 'resizeSettings':
                this.widthService.setWidthToTable();
                break;
            case 'enableAdaptiveUI':
                this.notify(events.setFullScreenDialog, {});
                break;
            case 'rowRenderingMode':
                this.enableVerticalRendering();
                this.notify(events.rowModeChange, {});
                this.refresh();
                break;
            case 'enableStickyHeader':
                this.scrollModule.addStickyListener(newProp.enableStickyHeader);
                break;
            case 'allowPdfExport':
                if (this.toolbarModule) {
                    this.toolbarModule.refreshToolbarItems();
                }
                break;
            case 'allowExcelExport':
                if (this.toolbarModule) {
                    this.toolbarModule.refreshToolbarItems();
                }
                break;
            case 'enableRowSpan':
            case 'enableColumnSpan':
                this.refreshColumns();
                break;
        }
    }
    maintainSelection(index) {
        if (index !== -1) {
            const fn = () => {
                this.selectRow(index);
                this.off(events.contentReady, fn);
            };
            this.on(events.contentReady, fn, this);
        }
    }
    /**
     * @param {Object} prop - Defines the property
     * @param {boolean} muteOnChange - Defines the mute on change
     * @returns {void}
     * @private
     */
    setProperties(prop, muteOnChange) {
        const previousGroupColumns = this.groupSettings.columns;
        super.setProperties(prop, muteOnChange);
        const filterSettings = 'filterSettings';
        const groupSettings = 'groupSettings';
        if (prop[`${filterSettings}`] && this.filterModule && muteOnChange) {
            this.filterModule.refreshFilter();
        }
        if (prop[`${groupSettings}`] && prop[`${groupSettings}`].columns && this.groupModule && muteOnChange) {
            if (!this.groupSettings.showGroupedColumn) {
                for (let i = 0; i < previousGroupColumns.length; i++) {
                    const column = this.getColumnByField(previousGroupColumns[parseInt(i.toString(), 10)]);
                    column.visible = true;
                }
            }
            for (let i = 0; i < this.sortSettings.columns.length; i++) {
                const idx = previousGroupColumns.indexOf(this.sortSettings.columns[parseInt(i.toString(), 10)].field);
                if (idx !== -1 && this.sortSettings.columns[parseInt(i.toString(), 10)].isFromGroup) {
                    this.sortSettings.columns.splice(i, 1);
                    i--;
                }
            }
            for (let i = 0; i < prop[`${groupSettings}`].columns.length; i++) {
                this.groupModule.groupAddSortingQuery(prop[`${groupSettings}`].columns[parseInt(i.toString(), 10)]);
                const column = this.getColumnByField(prop[`${groupSettings}`].columns[parseInt(i.toString(), 10)]);
                column.visible = this.groupSettings.showGroupedColumn;
            }
        }
    }
    /**
     * @hidden
     * @returns {number} - Returns the tables count
     */
    getTablesCount() {
        return this.tablesCount;
    }
    /**
     * @returns {boolean} - Returns whether the data source is remote or not
     * @hidden
     */
    isRemote() {
        return (this.getDataModule().isRemote() || (!isNullOrUndefined(this.dataSource)
            && !isNullOrUndefined(this.dataSource.result)));
    }
    /**
     * @hidden
     * @returns {void}
     */
    updateDefaultCursor() {
        const headerCells = [].slice.call(this.getHeaderContent().querySelectorAll('.e-headercell:not(.e-stackedheadercell)'));
        const stdHdrCell = [].slice.call(this.getHeaderContent().getElementsByClassName('e-stackedheadercell'));
        const cols = this.getColumns();
        for (let i = 0; i < headerCells.length; i++) {
            const cell = headerCells[parseInt(i.toString(), 10)];
            const column = cols[parseInt(i.toString(), 10)];
            if ((this.allowGrouping && column.allowGrouping) || (this.allowReordering && column.allowReordering)
                || (this.allowSorting && column.allowSorting)) {
                cell.classList.add('e-mousepointer');
            }
            else {
                cell.classList.add('e-defaultcursor');
            }
        }
        for (let count = 0; count < stdHdrCell.length; count++) {
            if (this.allowReordering) {
                stdHdrCell[parseInt(count.toString(), 10)].classList.add('e-mousepointer');
            }
        }
    }
    updateColumnModel(columns, isRecursion) {
        for (let i = 0, len = (!isNullOrUndefined(columns) ? columns.length : 0); i < len; i++) {
            if (columns[parseInt(i.toString(), 10)].columns) {
                this.updateColumnModel(columns[parseInt(i.toString(), 10)].columns, true);
            }
            else {
                this.columnModel.push(columns[parseInt(i.toString(), 10)]);
            }
        }
        if (isNullOrUndefined(isRecursion) || !isRecursion) {
            this.updateLockableColumns();
        }
    }
    getFrozenLeftCount() {
        return this.getFrozenColumns() || this.getFrozenLeftColumnsCount();
    }
    isFrozenGrid() {
        return this.getFrozenColumns() !== 0 || this.frozenLeftColumns.length !== 0 || this.frozenRightColumns.length !== 0 ||
            this.fixedColumns.length !== 0;
    }
    getFrozenMode() {
        return this.frozenName;
    }
    updateLockableColumns() {
        const cols = this.columnModel;
        let frozenCount = 0;
        let movableCount = 0;
        const frozenColumns = this.getFrozenColumns();
        for (let i = 0; i < cols.length; i++) {
            if (cols[parseInt(i.toString(), 10)].lockColumn) {
                if (i < frozenColumns) {
                    cols.splice(frozenCount, 0, cols.splice(i, 1)[0]);
                    frozenCount++;
                }
                else {
                    cols.splice(frozenColumns + movableCount, 0, cols.splice(i, 1)[0]);
                    movableCount++;
                }
            }
        }
    }
    checkLockColumns(cols) {
        for (let i = 0; i < cols.length; i++) {
            if (cols[parseInt(i.toString(), 10)].columns) {
                this.checkLockColumns(cols[parseInt(i.toString(), 10)].columns);
            }
            else if (cols[parseInt(i.toString(), 10)].lockColumn) {
                this.lockcolPositionCount++;
            }
        }
    }
    /**
     * @param {string} position - specifies position
     * @returns {number} returns the width
     * @hidden
     */
    leftrightColumnWidth(position) {
        const cols = position === 'left' ? this.getFrozenLeftColumns() : position === 'right' ? this.getFrozenRightColumns() : [];
        let width = 0;
        cols.filter((col) => {
            if (col.visible) {
                width += parseInt(col.width.toString(), 10);
            }
        });
        return width;
    }
    /**
     * Gets the columns from the Grid.
     *
     * @param {boolean} isRefresh - Defines the boolean whether to refresh
     * @returns {Column[]} - returns the column
     */
    getColumns(isRefresh) {
        const inview = this.inViewIndexes.map((v) => v - this.groupSettings.columns.length).filter((v) => v > -1);
        const vLen = inview.length;
        if (!this.enableColumnVirtualization || isNullOrUndefined(this.columnModel) || this.columnModel.length === 0 || isRefresh) {
            this.columnModel = [];
            this.updateColumnModel(this.columns);
        }
        const columns = vLen === 0 ? this.columnModel :
            this.getVisibleColumns().slice(inview[0], inview[vLen - 1] + 1);
        let left = [];
        let right = [];
        const movable = [];
        const isLeftRightFrozen = this.enableColumnVirtualization && this.isPreparedFrozenColumns && vLen === 0;
        if (isLeftRightFrozen) {
            this.frozenRightColumns = [];
            this.frozenLeftColumns = [];
        }
        for (let i = 0; i < columns.length; i++) {
            if (columns[parseInt(i.toString(), 10)].freeze === 'Left' || columns[parseInt(i.toString(), 10)].isFrozen) {
                left.push(columns[parseInt(i.toString(), 10)]);
                if (isLeftRightFrozen) {
                    this.frozenLeftColumns.push(columns[parseInt(i.toString(), 10)]);
                }
            }
            else if (columns[parseInt(i.toString(), 10)].freeze === 'Right') {
                right.push(columns[parseInt(i.toString(), 10)]);
                if (isLeftRightFrozen) {
                    this.frozenRightColumns.push(columns[parseInt(i.toString(), 10)]);
                }
            }
            else {
                movable.push(columns[parseInt(i.toString(), 10)]);
            }
        }
        if (this.enableColumnVirtualization && this.isFrozenGrid()) {
            if (this.frozenLeftColumns.length) {
                left = this.frozenLeftColumns;
            }
            if (this.frozenRightColumns.length) {
                right = this.frozenRightColumns;
            }
        }
        return left.concat(movable).concat(right);
    }
    /**
     * @private
     * @param {string} stackedHeader - Defines the stacked header
     * @param {Column[]} col - Defines the column
     * @returns {Column} Returns the Column
     */
    getStackedHeaderColumnByHeaderText(stackedHeader, col) {
        for (let i = 0; i < col.length; i++) {
            const individualColumn = col[parseInt(i.toString(), 10)];
            if (individualColumn.field === stackedHeader || individualColumn.headerText === stackedHeader) {
                this.stackedColumn = individualColumn;
                break;
            }
            else if (individualColumn.columns) {
                this.getStackedHeaderColumnByHeaderText(stackedHeader, individualColumn.columns);
            }
        }
        return this.stackedColumn;
    }
    /**
     * @private
     * @returns {number[]} Returns the column indexes
     */
    getColumnIndexesInView() {
        return this.inViewIndexes;
    }
    /**
     * @private
     * @returns {Query} - returns the query
     */
    getQuery() {
        return this.query;
    }
    /**
     * @private
     * @returns {object} - returns the locale constants
     */
    getLocaleConstants() {
        return this.defaultLocale;
    }
    /**
     * @param {number[]} indexes - specifies the indexes
     * @returns {void}
     * @private
     */
    setColumnIndexesInView(indexes) {
        this.inViewIndexes = indexes;
    }
    /**
     * Gets the visible columns from the Grid.
     *
     * @returns {Column[]} returns the column
     */
    getVisibleColumns() {
        return this.getCurrentVisibleColumns();
    }
    /**
     * Gets the header div of the Grid.
     *
     * @returns {Element} - Returns the element
     */
    getHeaderContent() {
        return this.headerModule.getPanel();
    }
    /**
     * Sets the header div of the Grid to replace the old header.
     *
     * @param  {Element} element - Specifies the Grid header.
     *
     * @returns {void}
     */
    setGridHeaderContent(element) {
        this.headerModule.setPanel(element);
    }
    /**
     * Gets the content table of the Grid.
     *
     * @returns {Element} - Returns the element
     */
    getContentTable() {
        return this.contentModule.getTable();
    }
    /**
     * Sets the content table of the Grid to replace the old content table.
     *
     * @param  {Element} element - Specifies the Grid content table.
     *
     * @returns {void}
     */
    setGridContentTable(element) {
        this.contentModule.setTable(element);
    }
    /**
     * Gets the content div of the Grid.
     *
     * @returns {Element} Returns the element
     */
    getContent() {
        return this.contentModule.getPanel();
    }
    /**
     * Sets the content div of the Grid to replace the old Grid content.
     *
     * @param  {Element} element - Specifies the Grid content.
     *
     * @returns {void}
     */
    setGridContent(element) {
        this.contentModule.setPanel(element);
    }
    /**
     * Gets the header table element of the Grid.
     *
     * @returns {Element} returns the element
     */
    getHeaderTable() {
        return this.headerModule.getTable();
    }
    /**
     * Sets the header table of the Grid to replace the old one.
     *
     * @param  {Element} element - Specifies the Grid header table.
     *
     * @returns {void}
     */
    setGridHeaderTable(element) {
        this.headerModule.setTable(element);
    }
    /**
     * Gets the footer div of the Grid.
     *
     * @returns {Element} returns the element
     */
    getFooterContent() {
        this.footerElement = this.element.getElementsByClassName(literals.gridFooter)[0];
        return this.footerElement;
    }
    /**
     * Gets the footer table element of the Grid.
     *
     * @returns {Element} returns the element
     */
    getFooterContentTable() {
        this.footerElement = this.element.getElementsByClassName(literals.gridFooter)[0];
        return this.footerElement.firstChild.firstChild;
    }
    /**
     * Gets the pager of the Grid.
     *
     * @returns {Element} returns the element
     */
    getPager() {
        return this.gridPager; //get element from pager
    }
    /**
     * Sets the pager of the Grid to replace the old pager.
     *
     * @param  {Element} element - Specifies the Grid pager.
     *
     * @returns {void}
     */
    setGridPager(element) {
        this.gridPager = element;
    }
    /**
     * Gets a row by index.
     *
     * @param  {number} index - Specifies the row index.
     *
     * @returns {Element} returns the element
     */
    getRowByIndex(index) {
        if (this.enableVirtualization && this.groupSettings.enableLazyLoading) {
            return this.lazyLoadRender.getRowByIndex(index);
        }
        else {
            return this.contentModule.getRowByIndex(index);
        }
    }
    /**
     * Gets a movable tables row by index.
     *
     * @param  {number} index - Specifies the row index.
     *
     * @returns {Element} returns the element
     * @deprecated This method has been marked as deprecated. It is recommended to utilize the `getRowByIndex()` method instead, and apply the `e-unfreeze` class to select the movable cell within the tr element.
     */
    getMovableRowByIndex(index) {
        return this.contentModule.getRowByIndex(index);
    }
    /**
     * Gets a frozen tables row by index.
     *
     * @param  {number} index - Specifies the row index.
     * @returns {Element} returns the element
     * @deprecated This method has been marked as deprecated. It is recommended to utilize the `getRowByIndex()` method instead, and apply the `e-leftfreeze` class to select the frozen cell within the tr element.
     */
    getFrozenRowByIndex(index) {
        return this.contentModule.getRowByIndex(index);
    }
    /**
     * Gets all the data rows of the Grid.
     *
     * @returns {Element[]} returns the element
     */
    getRows() {
        return this.contentModule.getRowElements();
    }
    /**
     * Gets a frozen right tables row element by index.
     *
     * @param  {number} index - Specifies the row index.
     * @returns {Element} returns the element
     * @deprecated This method has been marked as deprecated. It is recommended to utilize the `getRowByIndex()` method instead, and apply the `e-rightfreeze` class to select the frozen right cell within the tr element.
     */
    getFrozenRightRowByIndex(index) {
        return this.contentModule.getRowByIndex(index);
    }
    /**
     * Get a row information based on cell
     *
     * @param {Element | EventTarget} target - specifies the element
     *
     * @returns {RowInfo} returns the row info
     */
    getRowInfo(target) {
        const ele = target;
        let args = { target: target };
        if (!isNullOrUndefined(target) && isNullOrUndefined(parentsUntil(ele, 'e-detailrowcollapse')
            && isNullOrUndefined(parentsUntil(ele, 'e-recordplusexpand')))) {
            const cell = closest(ele, '.' + literals.rowCell);
            if (!cell) {
                const row = closest(ele, '.' + literals.row);
                if (!isNullOrUndefined(row) && !row.classList.contains('e-addedrow')) {
                    const rowObj = this.getRowObjectFromUID(row.getAttribute('data-uid'));
                    const rowIndex = parseInt(row.getAttribute(literals.ariaRowIndex), 10) - 1;
                    args = { row: row, rowData: rowObj.data, rowIndex: rowIndex };
                }
                return args;
            }
            const cellIndex = parseInt(cell.getAttribute(literals.ariaColIndex), 10) - 1;
            const row = closest(cell, '.' + literals.row);
            if (!isNullOrUndefined(cell) && !isNaN(cellIndex) && !isNullOrUndefined(row)) {
                const rowIndex = parseInt(row.getAttribute(literals.ariaRowIndex), 10) - 1;
                const rows = this.contentModule.getRows();
                const index = cellIndex + this.getIndentCount();
                let rowsObject = rows.filter((r) => r.uid === row.getAttribute('data-uid'));
                if (this.pinnedTopRowModels.length && !isNullOrUndefined(target) && parentsUntil(ele, 'e-headercontent')) {
                    rowsObject = this.pinnedTopRowModels.filter((r) => r.uid === row.getAttribute('data-uid'));
                }
                let rowData = {};
                let column;
                if (Object.keys(rowsObject).length) {
                    rowData = rowsObject[0].data;
                    column = rowsObject[0].cells[parseInt(index.toString(), 10)].column;
                }
                args = { cell: cell, cellIndex: cellIndex, row: row, rowIndex: rowIndex, rowData: rowData, column: column, target: target };
            }
        }
        return args;
    }
    /**
     * Gets the Grid's movable content rows from frozen grid.
     *
     * @returns {Element[]} returns the element
     * @deprecated This method has been marked as deprecated. It is recommended to utilize the `getRows()` method instead, and apply the `e-unfreeze` class to select the movable cell within the tr element.
     */
    getMovableRows() {
        return this.contentModule.getRowElements();
    }
    /**
     * Gets the Grid's frozen right content rows from frozen grid.
     *
     * @returns {Element[]} returns the element
     * @deprecated This method has been marked as deprecated. It is recommended to utilize the `getRows()` method instead, and apply the `e-rightfreeze` class to select the frozen right cell within the tr element.
     */
    getFrozenRightRows() {
        return this.contentModule.getRowElements();
    }
    /**
     * Gets all the Grid's data rows.
     *
     * @returns {Element[]} returns the element
     */
    getDataRows() {
        return this.getAllDataRows();
    }
    /**
     * @param {boolean} includeAdd - specifies includeAdd
     * @returns {Element[]} returns the element
     * @hidden
     */
    getAllDataRows(includeAdd) {
        if (isNullOrUndefined(this.getContentTable().querySelector(literals.tbody))) {
            return [];
        }
        const tbody = this.getContentTable().querySelector(literals.tbody);
        let rows = [].slice.call(tbody.children);
        if (this.editSettings.showAddNewRow) {
            if (rows[0].classList.contains('e-addedrow')) {
                rows.shift();
            }
            else if (rows[rows.length - 1].classList.contains('e-addedrow')) {
                rows.pop();
            }
        }
        if (this.frozenRows || this.pinnedTopRowModels.length) {
            const hdrTbody = this.getHeaderTable().querySelector(literals.tbody);
            const freezeRows = [].slice.call(hdrTbody.children);
            rows = this.addMovableRows(freezeRows, rows);
            if (this.editSettings.showAddNewRow && freezeRows[0].classList.contains('e-addedrow')) {
                freezeRows.shift();
            }
        }
        const dataRows = this.generateDataRows(rows, includeAdd);
        return dataRows;
    }
    /**
     * @param {HTMLElement[]} fRows - Defines the frozen Rows
     * @param {HTMLElement[]} mrows - Defines the movable Rows
     * @returns {HTMLElement[]} Returns the element
     * @hidden
     */
    addMovableRows(fRows, mrows) {
        for (let i = 0, len = mrows.length; i < len; i++) {
            fRows.push(mrows[parseInt(i.toString(), 10)]);
        }
        return fRows;
    }
    generateDataRows(rows, includAdd) {
        const dRows = [];
        for (let i = 0, len = rows.length; i < len; i++) {
            if (rows[parseInt(i.toString(), 10)].classList.contains(literals.row)
                && (!rows[parseInt(i.toString(), 10)].classList.contains('e-hiddenrow') || includAdd)) {
                if (this.isCollapseStateEnabled()) {
                    dRows[parseInt(rows[parseInt(i.toString(), 10)].getAttribute('aria-rowindex'), 10) - 1] = rows[parseInt(i.toString(), 10)];
                }
                else {
                    dRows.push(rows[parseInt(i.toString(), 10)]);
                }
            }
        }
        return dRows;
    }
    /**
     * Gets all the Grid's movable table data rows.
     *
     * @returns {Element[]} Returns the element
     * @deprecated This method has been marked as deprecated. It is recommended to utilize the `getDataRows()` method instead, and apply the `e-unfreeze` class to select the movable cell within the tr element.
     */
    getMovableDataRows() {
        return this.getAllMovableDataRows();
    }
    /**
     * @param {boolean} includeAdd Defines the include add in boolean
     * @returns {Element[]} Returns the element
     * @deprecated This method has been marked as deprecated. It is recommended to utilize the `getAllDataRows()` method instead, and apply the `e-unfreeze` class to select the movable cell within the tr element.
     * @hidden
     */
    getAllMovableDataRows(includeAdd) {
        return this.getAllDataRows(includeAdd);
    }
    /**
     * Gets all the Grid's frozen table data rows.
     *
     * @returns {Element[]} returns the element
     * @deprecated This method has been marked as deprecated. It is recommended to utilize the `getDataRows()` method instead, and apply the `e-leftfreeze` class to select the frozen cell within the tr element.
     */
    getFrozenDataRows() {
        return this.getAllFrozenDataRows();
    }
    /**
     * @param {boolean} includeAdd Defines the include add in boolean
     * @returns {Element[]} Returns the element
     * @deprecated This method has been marked as deprecated. It is recommended to utilize the `getAllDataRows()` method instead, and apply the `e-leftfreeze` class to select the frozen cell within the tr element.
     * @hidden
     */
    getAllFrozenDataRows(includeAdd) {
        return this.getAllDataRows(includeAdd);
    }
    /**
     * Gets all the Grid's frozen right table data rows.
     *
     * @returns {Element[]} Returns the Element
     * @deprecated This method has been marked as deprecated. It is recommended to utilize the `getDataRows()` method instead, and apply the `e-rightfreeze` class to select the frozen right cell within the tr element.
     */
    getFrozenRightDataRows() {
        return this.getAllFrozenRightDataRows();
    }
    /**
     * @param {boolean} includeAdd Defines the include add in boolean
     * @returns {Element[]} Returns the element
     * @deprecated This method has been marked as deprecated. It is recommended to utilize the `getAllDataRows()` method instead, and apply the `e-rightfreeze` class to select the frozen right cell within the tr element.
     * @hidden
     */
    getAllFrozenRightDataRows(includeAdd) {
        return this.getAllDataRows(includeAdd);
    }
    /**
     * Updates particular cell value based on the given primary key value.
     * > Primary key column must be specified using `columns.isPrimaryKey` property.
     *
     * @param {string| number} key - Specifies the PrimaryKey value of dataSource.
     * @param {string } field - Specifies the field name which you want to update.
     * @param {string | number | boolean | Date} value - To update new value for the particular cell.
     *
     * @returns {void}
     */
    setCellValue(key, field, value) {
        const cells = 'cells';
        const rowData = 'data';
        const rowIdx = 'index';
        const rowuID = 'uid';
        const pkName = this.getPrimaryKeyFieldNames()[0];
        const cell = new CellRenderer(this, this.serviceLocator);
        let fieldIdx = this.getColumnIndexByField(field);
        const col = this.getColumnByField(field);
        const rowObjects = this.contentModule.getRows();
        const selectedRow = rowObjects.filter((r) => getValue(pkName, r.data) === key)[0];
        const tr = selectedRow ? this.element.querySelector('[data-uid=' + selectedRow[`${rowuID}`] + ']') : null;
        if (!isNullOrUndefined(tr)) {
            if (typeof value === 'string') {
                value = this.sanitize(value);
            }
            setValue(field, value, selectedRow[`${rowData}`]);
            let td = this.enableVirtualization ? tr.children[parseInt(fieldIdx.toString(), 10)]
                : this.getCellFromIndex(selectedRow[`${rowIdx}`], fieldIdx);
            if (!isNullOrUndefined(td)) {
                const Idx = 0;
                if (this.groupSettings.columns.length) {
                    fieldIdx = fieldIdx + this.groupSettings.columns.length;
                }
                if (this.childGrid || this.detailTemplate) {
                    fieldIdx++;
                }
                if (this.isRowDragable()) {
                    fieldIdx++;
                }
                const sRow = selectedRow[`${cells}`][fieldIdx - Idx];
                cell.refreshTD(td, sRow, selectedRow[`${rowData}`], { index: selectedRow[`${rowIdx}`] });
                if (this.isReact) {
                    td = this.enableVirtualization ? tr.children[parseInt(fieldIdx.toString(), 10)]
                        : this.getCellFromIndex(selectedRow[`${rowIdx}`], fieldIdx);
                }
                if (this.aggregates.length > 0) {
                    this.notify(events.refreshFooterRenderer, {});
                    if (this.groupSettings.columns.length > 0) {
                        this.notify(events.groupAggregates, {});
                    }
                }
                /* tslint:disable:no-string-literal */
                if (!isNullOrUndefined(selectedRow) && !isNullOrUndefined(selectedRow['changes'])) {
                    selectedRow['changes'][`${field}`] = value;
                }
                /* tslint:disable:no-string-literal */
                this.trigger(events.queryCellInfo, {
                    cell: td, column: col, data: selectedRow[`${rowData}`]
                });
                if (this.isReact && td.getAttribute('tabindex') === '0' && td.classList.contains('e-focused')) {
                    td.focus();
                }
            }
        }
        else {
            return;
        }
    }
    /**
     * @param {string} columnUid - Defines column uid
     * @param {boolean} renderTemplates - Defines renderTemplates need to invoke
     * @returns {void}
     * @hidden
     */
    refreshReactColumnTemplateByUid(columnUid, renderTemplates) {
        if (this.isReact) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.clearTemplate(['columnTemplate'], undefined, () => {
                const isChildGrid = this.childGrid && this.element.querySelectorAll('.e-childgrid').length ? true : false;
                const rows = isChildGrid ? this.getContentTable().querySelectorAll('.e-row') :
                    this.getDataRows();
                this.refreshReactTemplateTD(rows, isChildGrid);
                if (renderTemplates) {
                    this.renderTemplates();
                }
            });
        }
    }
    /**
     * @param {Element[] | NodeListOf<Element>} rows - Defines the rows
     * @param {boolean} isChildGrid - Defines whether it is a Hierarchy Grid.
     * @param {boolean} isFrozen - Defines whether it is a Frozen Grid
     * @returns {void}
     * @hidden
     */
    refreshReactTemplateTD(rows, isChildGrid, isFrozen) {
        const cells = 'cells';
        const rowIdx = 'index';
        const indent = this.getIndentCount();
        let childIndent = 0;
        let isChildRow = false;
        for (let j = 0; j < rows.length; j++) {
            let rowsObj = this.getRowObjectFromUID(rows[parseInt(j.toString(), 10)].getAttribute('data-uid'));
            if (isChildGrid && !rowsObj && parentsUntil(rows[parseInt(j.toString(), 10)], 'e-childgrid')) {
                const gridObj = parentsUntil(rows[parseInt(j.toString(), 10)], 'e-childgrid').ej2_instances[0];
                rowsObj = gridObj.getRowObjectFromUID(rows[parseInt(j.toString(), 10)].getAttribute('data-uid'));
                childIndent = gridObj.getIndentCount();
                isChildRow = true;
            }
            if (rowsObj && rowsObj.isDataRow && !isNullOrUndefined(rowsObj.index) &&
                !rows[parseInt(j.toString(), 10)].classList.contains('e-editedrow')) {
                for (let i = 0; i < rowsObj[`${cells}`].length; i++) {
                    const cell = rowsObj[`${cells}`][parseInt(i.toString(), 10)];
                    if (cell.isTemplate) {
                        const cellRenderer = new CellRenderer(this, this.serviceLocator);
                        const td = isChildGrid ? rows[parseInt(j.toString(), 10)]
                            .children[cell.index + (isChildRow ? childIndent : indent)] : this.getCellFromIndex(j, isFrozen ? cell.index : i - indent);
                        cellRenderer.refreshTD(td, cell, rowsObj.data, { index: rowsObj[`${rowIdx}`] });
                    }
                }
            }
            isChildRow = false;
        }
    }
    /**
     * @returns {void}
     * @hidden
     */
    refreshGroupCaptionFooterTemplate() {
        const isChildGrid = this.childGrid && this.element.querySelectorAll('.e-childgrid').length ? true : false;
        const rows = this.getContentTable().querySelectorAll('.e-groupcaptionrow, .e-groupfooterrow');
        for (let i = 0; i < rows.length; i++) {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            let gridObj = this;
            let rowsObj = this.getRowObjectFromUID(rows[parseInt(i.toString(), 10)].getAttribute('data-uid'));
            if (isChildGrid && !rowsObj && parentsUntil(rows[parseInt(i.toString(), 10)], 'e-childgrid')) {
                gridObj = parentsUntil(rows[parseInt(i.toString(), 10)], 'e-childgrid').ej2_instances[0];
                rowsObj = gridObj.getRowObjectFromUID(rows[parseInt(i.toString(), 10)].getAttribute('data-uid'));
            }
            if (rowsObj) {
                const cells = rowsObj.cells.filter((cell) => cell.isDataCell);
                const args = { cells: cells, data: rowsObj.data, dataUid: rowsObj.uid };
                gridObj.notify(events.refreshAggregateCell, args);
            }
        }
    }
    /**
     * @param {string} columnUid - Defines column uid
     * @returns {void}
     * @hidden
     */
    refreshReactHeaderTemplateByUid(columnUid) {
        if (this.isReact) {
            const cells = 'cells';
            const rowsObj = this.headerModule.rows;
            const cellIndex = this.getNormalizedColumnIndex(columnUid);
            for (let j = 0; j < rowsObj.length; j++) {
                const cell = rowsObj[parseInt(j.toString(), 10)][`${cells}`][parseInt(cellIndex.toString(), 10)];
                if (cell && cell.column.uid === columnUid) {
                    const headerCellRenderer = new HeaderCellRenderer(this, this.serviceLocator);
                    const td = parentsUntil(this.element.querySelectorAll('[data-mappinguid=' + columnUid + ']')[0], 'e-templatecell');
                    headerCellRenderer.refresh(cell, td);
                    const cols = this.sortSettings.columns;
                    const columnIndex = cols.findIndex(function (col) {
                        return col.field === cell
                            .column.field;
                    });
                    if (columnIndex !== -1) {
                        const header = this.getColumnHeaderByField(cell.column.field);
                        this.ariaService.setSort(header, (cols[parseInt(columnIndex.toString(), 10)].direction).toLowerCase());
                        if (cols.length > 1) {
                            header.querySelector('.e-headercelldiv').insertBefore(this.createElement('span', { className: 'e-sortnumber', innerHTML: (columnIndex + 1).toString() }), header.querySelector('.e-headertext'));
                        }
                        const filterElement = header.querySelector('.e-sortfilterdiv');
                        if (cols[parseInt(columnIndex.toString(), 10)].direction === 'Ascending') {
                            classList(filterElement, ['e-ascending', 'e-icon-ascending'], []);
                        }
                        else {
                            classList(filterElement, ['e-descending', 'e-icon-descending'], []);
                        }
                    }
                }
            }
        }
    }
    /**
     * Updates and refresh the particular row values based on the given primary key value.
     * > Primary key column must be specified using `columns.isPrimaryKey` property.
     *
     * @param {string| number} key - Specifies the PrimaryKey value of dataSource.
     * @param {Object} rowData - To update new data for the particular row.
     *
     * @returns {void}
     */
    setRowData(key, rowData) {
        const rowuID = 'uid';
        let rowObjects = this.contentModule.getRows();
        const pkName = this.getPrimaryKeyFieldNames()[0];
        if (this.groupSettings.columns.length > 0 && this.aggregates.length > 0) {
            rowObjects = rowObjects.filter((row) => row.isDataRow);
        }
        const selectedRow = rowObjects.filter((r) => getValue(pkName, r.data) === key)[0];
        const selectRowEle = selectedRow ? [].slice.call(this.element.querySelectorAll('[data-uid=' + selectedRow[`${rowuID}`] + ']')) : undefined;
        if (!isNullOrUndefined(selectedRow) && selectRowEle.length) {
            selectedRow.changes = rowData;
            if (this.frozenRows) {
                const fRowTr = this.getRowsObject()[selectedRow.index];
                this.setFrozenRowData(fRowTr, rowData);
            }
            else {
                const rowElement = this.getRowElementByUID(selectedRow.uid);
                const isLastRowCell = rowElement && rowElement.querySelector('.e-lastrowcell') ? true : false;
                this.setFrozenRowData(selectedRow, rowData);
                if (isLastRowCell) {
                    this.scrollModule.setLastRowCell();
                }
            }
            if (this.aggregates.length > 0) {
                this.notify(events.refreshFooterRenderer, {});
                if (this.groupSettings.columns.length > 0) {
                    this.notify(events.groupAggregates, {});
                }
            }
        }
        else {
            return;
        }
    }
    setFrozenRowData(fTr, rowData) {
        const rowRenderer = new RowRenderer(this.serviceLocator, null, this);
        fTr.changes = rowData;
        refreshForeignData(fTr, this.getForeignKeyColumns(), fTr.changes);
        rowRenderer.refresh(fTr, this.getColumns(), true);
    }
    /**
     * Gets a cell by row and column index.
     *
     * @param  {number} rowIndex - Specifies the row index.
     * @param  {number} columnIndex - Specifies the column index.
     *
     * @returns {Element} Returns the Element
     */
    getCellFromIndex(rowIndex, columnIndex) {
        const col = this.getColumnByIndex(columnIndex);
        return getCellByColAndRowIndex(this, col, rowIndex, columnIndex);
    }
    /**
     * Gets a movable table cell by row and column index.
     *
     * @param  {number} rowIndex - Specifies the row index.
     * @param  {number} columnIndex - Specifies the column index.
     *
     * @returns {Element} Returns the Element
     * @deprecated This method is deprecated. Use `getCellFromIndex()` method instead
     */
    getMovableCellFromIndex(rowIndex, columnIndex) {
        return this.getCellFromIndex(rowIndex, columnIndex);
    }
    /**
     * Gets a frozen right table cell by row and column index.
     *
     * @param  {number} rowIndex - Specifies the row index.
     * @param  {number} columnIndex - Specifies the column index.
     * @returns {Element} Returns the Element
     * @deprecated This method is deprecated. Use `getCellFromIndex()` method instead.
     */
    getFrozenRightCellFromIndex(rowIndex, columnIndex) {
        return this.getCellFromIndex(rowIndex, columnIndex);
    }
    /**
     * Gets a column header by column index.
     *
     * @param  {number} index - Specifies the column index.
     *
     * @returns {Element} Returns the Element
     */
    getColumnHeaderByIndex(index) {
        return this.getHeaderTable().getElementsByClassName('e-headercell')[parseInt(index.toString(), 10)];
    }
    /**
     * Gets a movable column header by column index.
     *
     * @param  {number} index - Specifies the column index.
     * @returns {Element} Returns the Element
     * @deprecated This method is deprecated. Use `getColumnHeaderByIndex()` method instead.
     */
    getMovableColumnHeaderByIndex(index) {
        return this.getColumnHeaderByIndex(index);
    }
    /**
     * Gets a frozen right column header by column index.
     *
     * @param  {number} index - Specifies the column index.
     * @returns {Element} Returns the Element
     * @deprecated This method is deprecated. Use `getColumnHeaderByIndex()` method instead.
     */
    getFrozenRightColumnHeaderByIndex(index) {
        return this.getColumnHeaderByIndex(index);
    }
    /**
     * Gets a frozen left column header by column index.
     *
     * @param  {number} index - Specifies the column index.
     * @returns {Element} Returns the Element
     * @deprecated This method is deprecated. Use `getColumnHeaderByIndex()` method instead.
     */
    getFrozenLeftColumnHeaderByIndex(index) {
        return this.getColumnHeaderByIndex(index);
    }
    /**
     * @param {string} uid - Defines the uid
     * @returns {Row<Column>} Returns the row object
     * @hidden
     */
    getRowObjectFromUID(uid) {
        const rows = this.contentModule.getRows();
        let row = this.rowObject(rows, uid);
        if (isNullOrUndefined(row) && this.pinnedTopRowModels.length) {
            const rows = this.pinnedTopRowModels;
            row = this.rowObject(rows, uid);
            if (!isNullOrUndefined(row)) {
                return row;
            }
        }
        if (isNullOrUndefined(row) && this.enableVirtualization && this.groupSettings.columns.length > 0) {
            row = this.rowObject(this.vRows, uid);
            return row;
        }
        return row;
    }
    rowObject(rows, uid) {
        if (rows) {
            for (const row of rows) {
                if (row.uid === uid) {
                    return row;
                }
            }
        }
        return null;
    }
    /**
     * Get an array of row objects.
     *
     * @returns {Row<Column>[]} Returns the Row object
     */
    getRowsObject() {
        return this.contentModule.getRows();
    }
    /**
     * @hidden
     * @returns {Row<Column>[]} Returns the Row object
     * @deprecated  This method is deprecated. Use `getRowsObject()` method instead.
     */
    getMovableRowsObject() {
        return this.contentModule.getRows();
    }
    /**
     * @hidden
     * @returns {Row<Column>[]} Returns the Row object
     * @deprecated This method is deprecated. Use `getRowsObject()` method instead.
     */
    getFrozenRightRowsObject() {
        return this.contentModule.getRows();
    }
    /**
     * Gets a column header by column name.
     *
     * @param  {string} field - Specifies the column name.
     *
     * @returns {Element} - Returns the element
     */
    getColumnHeaderByField(field) {
        const column = this.getColumnByField(field);
        return column ? this.getColumnHeaderByUid(column.uid) : undefined;
    }
    /**
     * Gets a column header by UID.
     *
     * @param {string} uid - Specifies the column uid.
     *
     * @returns {Element} - Returns the element
     */
    getColumnHeaderByUid(uid) {
        const element = this.getHeaderContent().querySelector('[data-mappinguid=' + uid + ']');
        return element ? closest(element, 'th') : undefined;
    }
    /**
     * @hidden
     * @param {number} index - Defines the index
     * @returns {Column} Returns the column
     */
    getColumnByIndex(index) {
        let column;
        this.getColumns().some((col, i) => {
            column = col;
            return i === index;
        });
        return column;
    }
    /**
     * Gets a Column by column name.
     *
     * @param  {string} field - Specifies the column name.
     *
     * @returns {Column} Returns the column
     */
    getColumnByField(field) {
        return iterateArrayOrObject(this.getColumns(), (item) => {
            if (item.field === field) {
                return item;
            }
            return undefined;
        })[0];
    }
    /**
     * Gets a column index by column name.
     *
     * @param  {string} field - Specifies the column name.
     *
     * @returns {number} Returns the index by field
     */
    getColumnIndexByField(field) {
        const cols = this.getColumns();
        for (let i = 0; i < cols.length; i++) {
            if (cols[parseInt(i.toString(), 10)].field === field) {
                return i;
            }
        }
        return -1;
    }
    /**
     * Gets a column by UID.
     *
     * @param  {string} uid - Specifies the column UID.
     * @param  {boolean} isColumns - Defines the all columns.
     *
     * @returns {Column} Returns the column
     */
    getColumnByUid(uid, isColumns) {
        const cols = isColumns ? this.columns : this.getColumns();
        return iterateArrayOrObject([...cols, ...this.getStackedColumns(this.columns)], (item) => {
            if (item.uid === uid) {
                return item;
            }
            return undefined;
        })[0];
    }
    /**
     * @param {Column[]} columns - Defines the columns
     * @param {Column[]} stackedColumn - Defines the stacked columns
     * @returns {Column[]} Returns the columns
     * @hidden
     */
    getStackedColumns(columns, stackedColumn = []) {
        for (const column of columns) {
            if (column.columns) {
                stackedColumn.push(column);
                this.getStackedColumns(column.columns, stackedColumn);
            }
        }
        return stackedColumn;
    }
    /**
     * Gets a column index by UID.
     *
     * @param  {string} uid - Specifies the column UID.
     *
     * @returns {number} Returns the column by index
     */
    getColumnIndexByUid(uid) {
        const index = iterateArrayOrObject(this.getColumns(), (item, index) => {
            if (item.uid === uid) {
                return index;
            }
            return undefined;
        })[0];
        return !isNullOrUndefined(index) ? index : -1;
    }
    /**
     * Gets UID by column name.
     *
     * @param  {string} field - Specifies the column name.
     *
     * @returns {string} Returns the column by field
     */
    getUidByColumnField(field) {
        return iterateArrayOrObject(this.getColumns(), (item) => {
            if (item.field === field) {
                return item.uid;
            }
            return undefined;
        })[0];
    }
    /**
     * Gets column index by column uid value.
     *
     * @private
     * @param  {string} uid - Specifies the column uid.
     * @returns {number} Returns the column by field
     */
    getNormalizedColumnIndex(uid) {
        const index = this.getColumnIndexByUid(uid);
        return index + this.getIndentCount();
    }
    /**
     * Gets indent cell count.
     *
     * @private
     * @returns {number} Returns the indent count
     */
    getIndentCount() {
        let index = 0;
        if (this.allowGrouping) {
            index += this.groupSettings.columns.length;
        }
        if (this.isDetail()) {
            index++;
        }
        if (this.isRowDragable() && isNullOrUndefined(this.rowDropSettings.targetID)) {
            index++;
        }
        /**
         * TODO: index normalization based on the stacked header, grouping and detailTemplate
         * and frozen should be handled here
         */
        return index;
    }
    /**
     * Gets the collection of column fields.
     *
     * @returns {string[]} Returns the Field names
     */
    getColumnFieldNames() {
        const columnNames = [];
        let column;
        for (let i = 0, len = this.getColumns().length; i < len; i++) {
            column = this.getColumns()[parseInt(i.toString(), 10)];
            if (column.visible) {
                columnNames.push(column.field);
            }
        }
        return columnNames;
    }
    /**
     * Gets a compiled row template.
     *
     * @returns {Function} Returns the row TEmplate
     * @private
     */
    getRowTemplate() {
        return this.rowTemplateFn;
    }
    /**
     * Gets a compiled empty Record template.
     *
     * @returns {Function} Returns the empty Record template
     * @private
     */
    getEmptyRecordTemplate() {
        return this.emptyRecordTemplateFn;
    }
    /**
     * Gets a compiled detail row template.
     *
     * @private
     * @returns {Function} Returns the Detail template
     */
    getDetailTemplate() {
        return this.detailTemplateFn;
    }
    /**
     * Gets a compiled dialog edit template.
     *
     * @private
     * @returns {Function} Returns the Edit template
     */
    getEditTemplate() {
        return this.editTemplateFn;
    }
    /**
     * Gets a compiled dialog edit header template.
     *
     * @private
     * @returns {Function} returns template function
     */
    getEditHeaderTemplate() {
        return this.editHeaderTemplateFn;
    }
    /**
     * Gets a compiled dialog edit footer template.
     *
     * @private
     * @returns {Function} Returns the Footer template
     */
    getEditFooterTemplate() {
        return this.editFooterTemplateFn;
    }
    /**
     * Gets a compiled column chooser template.
     *
     * @private
     * @returns {Function} Returns the template
     */
    getColumnChooserTemplate() {
        return this.columnChooserTemplateFn;
    }
    /**
     * Gets a compiled column chooser header template.
     *
     * @private
     * @returns {Function} returns the header template
     */
    getColumnChooserHeaderTemplate() {
        return this.columnChooserHeaderTemplateFn;
    }
    /**
     * Gets a compiled column chooser footer template.
     *
     * @private
     * @returns {Function} Returns the Footer template
     */
    getColumnChooserFooterTemplate() {
        return this.columnChooserFooterTemplateFn;
    }
    /**
     * Get the names of the primary key columns of the Grid.
     *
     * @returns {string[]} Returns the field names
     */
    getPrimaryKeyFieldNames() {
        const keys = [];
        for (let k = 0; k < this.columnModel.length; k++) {
            if (this.columnModel[parseInt(k.toString(), 10)].isPrimaryKey) {
                keys.push(this.columnModel[parseInt(k.toString(), 10)].field);
            }
        }
        return keys;
    }
    /**
     * Refreshes the Grid header and content.
     *
     * @returns {void}
     */
    refresh() {
        if (!this.isDestroyed) {
            this.isManualRefresh = true;
            if (this.allowGrouping && this.groupModule && this.groupSettings.showDropArea) {
                this.groupModule.refreshDropArea();
            }
            this.headerModule.refreshUI();
            this.updateStackedFilter();
            this.renderModule.refresh();
        }
    }
    /**
     * Refreshes the Grid header.
     *
     * @returns {void}
     */
    refreshHeader() {
        this.headerModule.refreshUI();
    }
    /**
     * Gets the collection of selected rows.
     *
     * @returns {Element[]} Returns the element
     */
    getSelectedRows() {
        return this.selectionModule ? this.selectionModule.selectedRecords : [];
    }
    /**
     * Gets the collection of selected row indexes.
     *
     * @returns {number[]} Returns the Selected row indexes
     */
    getSelectedRowIndexes() {
        return this.selectionModule ? this.selectionModule.selectedRowIndexes : [];
    }
    /**
     * Gets the collection of selected row and cell indexes.
     *
     * @returns {number[]} Returns the Selected row cell indexes
     */
    getSelectedRowCellIndexes() {
        return this.selectionModule ? this.selectionModule.selectedRowCellIndexes : [];
    }
    /**
     * Gets the collection of selected records.
     *
     * @returns {Object[]} Returns the selected records
     * @isGenericType true
     */
    getSelectedRecords() {
        return this.selectionModule ? this.selectionModule.getSelectedRecords() : [];
    }
    /**
     * Gets the collection of selected columns uid.
     *
     * @returns {string[]} Returns the selected column uid
     * @isGenericType true
     */
    getSelectedColumnsUid() {
        const uid = [];
        if (this.selectionModule) {
            this.selectionModule.selectedColumnsIndexes.filter((i) => uid.push(this.getColumns()[parseInt(i.toString(), 10)].uid));
        }
        return uid;
    }
    /**
     * Returns the data module used by the grid.
     *
     * Use this to access the current applied queries and data related configuration settings for the grid.
     *
     * @returns {Data} The data module currently used by the grid.
     */
    getDataModule() {
        return this.renderModule.data;
    }
    /**
     * Shows a column by its column name.
     *
     * @param  {string|string[]} keys - Defines a single or collection of column names.
     * @param  {string} showBy - Defines the column key either as field name or header text.
     *
     * @returns {void}
     */
    showColumns(keys, showBy) {
        showBy = showBy ? showBy : 'headerText';
        this.showHider.show(keys, showBy);
    }
    /**
     * Hides a column by column name.
     *
     * @param  {string|string[]} keys - Defines a single or collection of column names.
     * @param  {string} hideBy - Defines the column key either as field name or header text.
     *
     * @returns {void}
     */
    hideColumns(keys, hideBy) {
        hideBy = hideBy ? hideBy : 'headerText';
        this.showHider.hide(keys, hideBy);
    }
    /**
     * @hidden
     * @returns {number} Returns the Frozen column
     */
    getFrozenColumns() {
        return this.frozenColumns + this.getFrozenCount(this.columns, 0, 0);
    }
    /**
     * @hidden
     * @returns {number} Returns the Frozen Right column count
     */
    getFrozenRightColumnsCount() {
        return this.frozenRightCount || this.rightcount;
    }
    /**
     * @hidden
     * @returns {number} Returns the Frozen Left column
     */
    getFrozenLeftColumnsCount() {
        return this.frozenLeftCount || this.leftcount;
    }
    /**
     * @hidden
     * @returns {number} Returns the movable column count
     */
    getMovableColumnsCount() {
        return this.movableCount || this.movablecount;
    }
    updateFrozenColumnsWidth() {
        if (this.isFrozenGrid() && !this.enableColumnVirtualization) {
            const gcol = this.getColumns();
            let isAutoWidth = true;
            let autoCol = 0;
            let difference = 0;
            let autoWidth = 0;
            const isFrozenAuto = gcol.some((data) => {
                return (data.freeze === 'Left' || data.freeze === 'Right'
                    || data.freeze === 'Fixed' || data.isFrozen) && data.width === 'auto';
            });
            for (let i = 0; i < gcol.length; i++) {
                const col = gcol[parseInt(i.toString(), 10)];
                if (isNullOrUndefined(col.width) && (col.freeze === 'Left' || col.freeze === 'Right' || col.freeze === 'Fixed' || col.isFrozen)) {
                    col.width = Math.max(200, col.minWidth ? parseFloat(col.minWidth.toString()) : 0);
                    if (!isNullOrUndefined(col.maxWidth) && parseFloat(col.maxWidth.toString()) < col.width) {
                        col.width = col.maxWidth;
                    }
                }
                if (col.width === 'auto' && isFrozenAuto) {
                    let tWidth = 0;
                    if (isAutoWidth) {
                        gcol.filter((cols) => {
                            if (cols.visible) {
                                if (cols.width === 'auto') {
                                    autoCol++;
                                }
                                if (cols.width !== 'auto') {
                                    const width = !isNullOrUndefined(cols.width) ? parseFloat(cols.width.toString()) :
                                        Math.max(200, cols.minWidth ? parseFloat(cols.minWidth.toString()) : 0);
                                    tWidth += width;
                                }
                            }
                        });
                        const gWidth = this.isPercentageWidthGrid() || this.width === 'auto' ? this.element.getBoundingClientRect().width :
                            parseFloat(this.width.toString());
                        difference = this.height === 'auto' ? gWidth - tWidth : ((gWidth - tWidth) - getScrollBarWidth());
                        if (difference < 0) {
                            difference = 0;
                        }
                        autoWidth = parseFloat((difference / autoCol).toString());
                        gcol.filter((col) => {
                            if (col.visible) {
                                if (col.minWidth && parseFloat(col.minWidth.toString()) > autoWidth) {
                                    difference = difference - parseFloat(col.minWidth.toString());
                                    autoCol--;
                                }
                            }
                        });
                        isAutoWidth = false;
                    }
                    if (col.minWidth && parseFloat(col.minWidth.toString()) > autoWidth) {
                        col.width = parseFloat(col.minWidth.toString());
                    }
                    else {
                        col.width = difference / autoCol;
                    }
                }
            }
        }
    }
    refreshSplitFrozenColumn() {
        this.splitFrozenCount(this.columns);
        this.updateFrozenColumnsWidth();
        this.isAutoGenerateColumns = true;
    }
    /**
     * @hidden
     * @returns {void}
     */
    setFrozenCount() {
        this.frozenLeftCount = this.frozenRightCount = this.movableCount = 0;
        this.visibleFrozenLeft = this.visibleFrozenRight = this.visibleMovable = 0;
        this.frozenLeftColumns = [];
        this.frozenRightColumns = [];
        this.movableColumns = [];
        this.fixedColumns = [];
        this.splitFrozenCount(this.columns);
        this.leftcount = this.frozenLeftCount;
        this.rightcount = this.frozenRightCount;
        this.movablecount = this.movableCount;
        // if (this.frozenColumns && (this.frozenLeftCount || this.frozenRightCount)) {
        //     this.setProperties({ frozenColumns: 0 }, true);
        // }
        if (this.frozenLeftCount && !this.frozenRightCount) {
            this.frozenName = 'Left';
        }
        else if (this.frozenRightCount && !this.frozenLeftCount) {
            this.frozenName = 'Right';
        }
        else if (this.frozenLeftCount && this.frozenRightCount) {
            this.frozenName = 'Left-Right';
        }
        else if (this.frozenColumns || this.frozenRows) {
            this.frozenName = 'Left';
        }
        else {
            this.frozenName = undefined;
        }
    }
    /**
     * @hidden
     * @returns {number} Returns the visible Frozen left count
     */
    getVisibleFrozenLeftCount() {
        return this.visibleFrozenLeft;
    }
    /**
     * @hidden
     * @returns {number} Returns the visible Frozen Right count
     */
    getVisibleFrozenRightCount() {
        return this.visibleFrozenRight;
    }
    /**
     * @hidden
     * @returns {number} Returns the visible movable count
     */
    getVisibleMovableCount() {
        return this.visibleMovable;
    }
    /**
     * @hidden
     * @returns {Column[]} Returns the column
     */
    getFrozenRightColumns() {
        return this.frozenRightColumns;
    }
    /**
     * @hidden
     * @returns {Column[]} Returns the column
     */
    getFrozenLeftColumns() {
        return this.frozenLeftColumns;
    }
    /**
     * @hidden
     * @returns {Column[]} Returns the column
     */
    getMovableColumns() {
        return this.movableColumns;
    }
    splitStackedColumns(columns) {
        for (let i = 0; i < columns.length; i++) {
            if (columns[parseInt(i.toString(), 10)].columns) {
                this.splitStackedColumns(columns[parseInt(i.toString(), 10)].columns);
            }
            else {
                if (columns[parseInt(i.toString(), 10)].freeze === 'Left' || columns[parseInt(i.toString(), 10)].isFrozen) {
                    if (columns[parseInt(i.toString(), 10)].visible !== false) {
                        this.visibleFrozenLeft++;
                    }
                    this.leftcount++;
                }
                else if (columns[parseInt(i.toString(), 10)].freeze === 'Right') {
                    if (columns[parseInt(i.toString(), 10)].visible !== false) {
                        this.visibleFrozenRight++;
                    }
                    this.rightcount++;
                }
                else if (columns[parseInt(i.toString(), 10)].freeze === 'Fixed') {
                    if (columns[parseInt(i.toString(), 10)].visible !== false) {
                        this.visibleFrozenFixed++;
                    }
                    this.fixedcount++;
                }
                else {
                    if (columns[parseInt(i.toString(), 10)].visible !== false) {
                        this.visibleMovable++;
                    }
                    this.movablecount++;
                }
            }
        }
    }
    pushStackedColumns(columns, index, arr, col, stackedcol) {
        arr[parseInt(index.toString(), 10)] = { headerText: col.headerText };
        if (col.textAlign) {
            arr[parseInt(index.toString(), 10)].textAlign = col.textAlign;
        }
        if (col.customAttributes) {
            arr[parseInt(index.toString(), 10)].customAttributes = col.customAttributes;
        }
        for (let i = 0; i < columns.length; i++) {
            if (columns[parseInt(i.toString(), 10)].columns) {
                index = index + 1;
                this.pushStackedColumns(columns[parseInt(i.toString(), 10)].columns, index, arr, columns[parseInt(i.toString(), 10)], stackedcol);
                index = index - 1;
            }
            else {
                let stockCol = [];
                stockCol = [...arr].slice(0, index + 1);
                if (columns[parseInt(i.toString(), 10)].freeze === 'Left' || columns[parseInt(i.toString(), 10)].isFrozen) {
                    this.stackedLeft.push(stockCol);
                    this.stackedarrayLeft.push(columns[parseInt(i.toString(), 10)]);
                }
                else if (columns[parseInt(i.toString(), 10)].freeze === 'Right') {
                    this.stackedRight.push(stockCol);
                    this.stackedarrayRight.push(columns[parseInt(i.toString(), 10)]);
                }
                else if (columns[parseInt(i.toString(), 10)].freeze === 'Fixed') {
                    this.stackedFixed.push(stockCol);
                    this.stackedarrayFixed.push(columns[parseInt(i.toString(), 10)]);
                }
                else {
                    this.stackedMovable.push(stockCol);
                    this.stackedarrayMovable.push(columns[parseInt(i.toString(), 10)]);
                }
            }
        }
    }
    pushallcol(text, text1, col, columns, isTrue) {
        if (col.headerText === text1.headerText) {
            if (isTrue) {
                col.columns.push(columns);
            }
            else {
                const newColumn = { headerText: text.headerText, columns: [] };
                if (text.textAlign) {
                    newColumn.textAlign = text.textAlign;
                }
                if (text.customAttributes) {
                    newColumn.customAttributes = text.customAttributes;
                }
                col.columns.push(newColumn);
            }
        }
        else {
            if (col.columns && col.columns.length) {
                for (let i = 0; i < col.columns.length; i++) {
                    this.pushallcol(text, text1, col.columns[parseInt(i.toString(), 10)], columns, isTrue);
                }
            }
        }
    }
    resetStackedColumns(headercol, gridcolumns, freeze) {
        let col = {};
        const tempHead = [];
        for (let i = 1; i <= headercol.length; i++) {
            const firstcol = headercol[i - 1];
            for (let j = 0; j < firstcol.length; j++) {
                if (!col.columns && i === 1) {
                    col = { headerText: firstcol[parseInt(j.toString(), 10)].headerText,
                        textAlign: firstcol[parseInt(j.toString(), 10)].textAlign,
                        customAttributes: firstcol[parseInt(j.toString(), 10)].customAttributes, columns: [] };
                    tempHead.push(firstcol[parseInt(j.toString(), 10)]);
                }
                else {
                    if (tempHead.indexOf(firstcol[parseInt(j.toString(), 10)]) === -1) {
                        this.pushallcol(firstcol[parseInt(j.toString(), 10)], firstcol[j - 1], col);
                        tempHead.push(firstcol[parseInt(j.toString(), 10)]);
                    }
                }
                if (j === firstcol.length - 1) {
                    this.pushallcol(null, firstcol[parseInt(j.toString(), 10)], col, gridcolumns[i - 1], true);
                    let count = 0;
                    while (count !== headercol.length - 1 && i !== headercol.length) {
                        const firstColHeaders = firstcol.map((col) => col.headerText).join(', ');
                        const headerColHeaders = headercol[parseInt(i.toString(), 10)].map((item) => item.headerText).join(', ');
                        if (firstColHeaders === headerColHeaders) {
                            i++;
                            this.pushallcol(null, firstcol[parseInt(j.toString(), 10)], col, gridcolumns[i - 1], true);
                        }
                        count++;
                    }
                }
            }
        }
        if (freeze === 'Left') {
            this.frozenLeftColumns.push(col);
        }
        else if (freeze === 'Right') {
            this.frozenRightColumns.push(col);
        }
        else {
            this.movableColumns.push(col);
        }
    }
    splitFrozenCount(columns) {
        if (this.frozenColumns || (this.changedProperties && this.changedProperties.frozenColumns === 0)) {
            const cols = !this.enableColumnVirtualization || (this.enableColumnVirtualization && this.isPreparedFrozenColumns) ?
                this.enableColumnVirtualization && this.columnModel && this.columnModel.length ? this.columnModel :
                    this.getColumns() : this.columns;
            if (!this.changedProperties || (this.changedProperties && !this.changedProperties.frozenColumns)) {
                for (let i = 0; i < cols.length; i++) {
                    if (this.frozenColumns > i) {
                        cols[parseInt(i.toString(), 10)].freeze = 'Left';
                    }
                    else if (cols[parseInt(i.toString(), 10)].freeze === 'Right' || cols[parseInt(i.toString(), 10)].freeze === 'Fixed') {
                        cols[parseInt(i.toString(), 10)].freeze = cols[parseInt(i.toString(), 10)].freeze;
                    }
                    else {
                        cols[parseInt(i.toString(), 10)].freeze = undefined;
                    }
                }
            }
        }
        for (let i = 0; i < (!isNullOrUndefined(columns) ? columns.length : 0); i++) {
            if (columns[parseInt(i.toString(), 10)].columns) {
                this.leftcount = 0;
                this.rightcount = 0;
                this.movablecount = 0;
                this.fixedcount = 0;
                const arr = [];
                this.splitStackedColumns(columns[parseInt(i.toString(), 10)].columns);
                if (this.leftcount && !this.rightcount && !this.movablecount && !this.fixedcount) {
                    this.frozenLeftCount += this.leftcount;
                    this.frozenLeftColumns.push(columns[parseInt(i.toString(), 10)]);
                }
                else if (this.rightcount && !this.leftcount && !this.movablecount && !this.fixedcount) {
                    this.frozenRightCount += this.rightcount;
                    this.frozenRightColumns.push(columns[parseInt(i.toString(), 10)]);
                }
                else if (this.movablecount && !this.leftcount && !this.rightcount && !this.fixedcount) {
                    this.movableCount += this.movablecount;
                    this.movableColumns.push(columns[parseInt(i.toString(), 10)]);
                }
                else if (this.fixedcount && !this.leftcount && !this.rightcount && !this.movablecount) {
                    this.fixedCount += this.fixedcount;
                    this.fixedColumns.push(columns[parseInt(i.toString(), 10)]);
                    this.movableCount += this.movablecount;
                    this.movableColumns.push(columns[parseInt(i.toString(), 10)]);
                }
                else {
                    this.frozenLeftCount += this.leftcount;
                    this.frozenRightCount += this.rightcount;
                    this.movableCount += this.movablecount;
                    this.fixedCount += this.fixedcount;
                    this.leftcount = 0;
                    this.rightcount = 0;
                    this.movablecount = 0;
                    this.fixedcount = 0;
                    this.stackedLeft = [];
                    this.stackedRight = [];
                    this.stackedFixed = [];
                    this.stackedMovable = [];
                    this.stackedarrayLeft = [];
                    this.stackedarrayRight = [];
                    this.stackedarrayFixed = [];
                    this.stackedarrayMovable = [];
                    this.pushStackedColumns(columns[parseInt(i.toString(), 10)].columns, 0, arr, columns[parseInt(i.toString(), 10)], { headerText: columns[parseInt(i.toString(), 10)].headerText,
                        textAlign: columns[parseInt(i.toString(), 10)].textAlign,
                        customAttributes: columns[parseInt(i.toString(), 10)].customAttributes, columns: [] });
                    if (this.stackedarrayLeft.length) {
                        this.resetStackedColumns(this.stackedLeft, this.stackedarrayLeft, 'Left');
                    }
                    if (this.stackedarrayRight.length) {
                        this.resetStackedColumns(this.stackedRight, this.stackedarrayRight, 'Right');
                    }
                    if (this.stackedarrayFixed.length) {
                        this.resetStackedColumns(this.stackedFixed, this.stackedarrayFixed, 'Fixed');
                    }
                    if (this.stackedarrayMovable.length) {
                        this.resetStackedColumns(this.stackedMovable, this.stackedarrayMovable, 'Movable');
                    }
                    this.stackedLeft = [];
                    this.stackedRight = [];
                    this.stackedMovable = [];
                    this.stackedFixed = [];
                    this.stackedarrayLeft = [];
                    this.stackedarrayRight = [];
                    this.stackedarrayMovable = [];
                    this.stackedarrayFixed = [];
                }
            }
            else {
                if (columns[parseInt(i.toString(), 10)].freeze === 'Right') {
                    if (columns[parseInt(i.toString(), 10)].visible !== false) {
                        this.visibleFrozenRight++;
                    }
                    this.frozenRightColumns.push(columns[parseInt(i.toString(), 10)]);
                    this.frozenRightCount++;
                }
                else if (columns[parseInt(i.toString(), 10)].freeze === 'Left' || columns[parseInt(i.toString(), 10)].isFrozen) {
                    if (columns[parseInt(i.toString(), 10)].visible !== false) {
                        this.visibleFrozenLeft++;
                    }
                    this.frozenLeftColumns.push(columns[parseInt(i.toString(), 10)]);
                    this.frozenLeftCount++;
                }
                else if (columns[parseInt(i.toString(), 10)].freeze === 'Fixed') {
                    this.fixedColumns.push(columns[parseInt(i.toString(), 10)]);
                    this.fixedCount++;
                    this.movableColumns.push(columns[parseInt(i.toString(), 10)]);
                    this.movableCount++;
                }
                else {
                    if (columns[parseInt(i.toString(), 10)].visible !== false) {
                        this.visibleMovable++;
                    }
                    this.movableColumns.push(columns[parseInt(i.toString(), 10)]);
                    this.movableCount++;
                }
            }
        }
        if (this.frozenLeftColumns.length) {
            const cols = this.frozenLeftColumns[this.frozenLeftColumns.length - 1];
            this.removeBorder(this.frozenLeftColumns);
            this.frozenLeftBorderColumns(cols instanceof Column ? this.lastVisibleLeftCol(this.frozenLeftColumns) : cols);
        }
        if (this.frozenRightColumns.length) {
            const cols = this.frozenRightColumns[0];
            this.removeBorder(this.frozenRightColumns);
            this.frozenRightBorderColumns(cols instanceof Column ? this.firstVisibleRightCol(this.frozenRightColumns) : cols);
        }
        if ((this.frozenLeftColumns.length || this.frozenRightColumns.length) && this.freezeColumnRefresh) {
            const cols = (this.frozenLeftColumns.concat(this.movableColumns)).concat(this.frozenRightColumns);
            this.setProperties({ columns: cols }, true);
            this.freezeColumnRefresh = false;
        }
    }
    removeBorder(columns) {
        for (let i = 0; i < columns.length; i++) {
            if (columns[parseInt(i.toString(), 10)].columns && columns[parseInt(i.toString(), 10)].columns.length) {
                if (columns[parseInt(i.toString(), 10)].border === 'Right' ||
                    columns[parseInt(i.toString(), 10)].border === 'Left') {
                    columns[parseInt(i.toString(), 10)].border = undefined;
                }
                this.removeBorder(columns[parseInt(i.toString(), 10)].columns);
            }
            else {
                if (columns[parseInt(i.toString(), 10)].border === 'Right' ||
                    columns[parseInt(i.toString(), 10)].border === 'Left') {
                    columns[parseInt(i.toString(), 10)].border = undefined;
                }
            }
        }
    }
    isVisibleColumns(column, arr) {
        if (column.columns && column.columns.length) {
            for (let i = 0; i < column.columns.length; i++) {
                this.isVisibleColumns(column.columns[parseInt(i.toString(), 10)], arr);
                if (column.columns[parseInt(i.toString(), 10)].visible &&
                    isNullOrUndefined(column.columns[parseInt(i.toString(), 10)].columns) &&
                    (!isNullOrUndefined(column.columns[parseInt(i.toString(), 10)].freeze) ||
                        column.columns[parseInt(i.toString(), 10)].isFrozen)) {
                    arr.push('true');
                }
            }
        }
        else {
            if (column.visible && (!isNullOrUndefined(column.freeze) || column.isFrozen)) {
                arr.push('true');
            }
        }
    }
    lastVisibleLeftCol(columns) {
        let column;
        for (let i = columns.length - 1; i >= 0; i--) {
            const arr = [];
            this.isVisibleColumns(columns[parseInt(i.toString(), 10)], arr);
            if (columns[parseInt(i.toString(), 10)].visible && arr.indexOf('true') !== -1) {
                column = columns[parseInt(i.toString(), 10)];
                break;
            }
        }
        return column;
    }
    firstVisibleRightCol(columns) {
        let column;
        for (let i = 0; i < columns.length; i++) {
            const arr = [];
            this.isVisibleColumns(columns[parseInt(i.toString(), 10)], arr);
            if (columns[parseInt(i.toString(), 10)].visible && arr.indexOf('true') !== -1) {
                column = columns[parseInt(i.toString(), 10)];
                break;
            }
        }
        return column;
    }
    frozenLeftBorderColumns(columns) {
        if (isNullOrUndefined(columns)) {
            return;
        }
        if (columns.columns && columns.columns.length) {
            columns.border = 'Left';
            const cols = columns.columns[columns.columns.length - 1];
            this.frozenLeftBorderColumns(cols instanceof Column && cols.columns ? this.lastVisibleLeftCol(columns.columns) : cols);
        }
        else {
            columns.border = 'Left';
        }
    }
    frozenRightBorderColumns(columns) {
        if (isNullOrUndefined(columns)) {
            return;
        }
        if (columns.columns && columns.columns.length) {
            columns.border = 'Right';
            const cols = columns.columns[0];
            this.frozenRightBorderColumns(cols instanceof Column && cols.columns ? this.firstVisibleRightCol(columns.columns) : cols);
        }
        else {
            columns.border = 'Right';
        }
    }
    /**
     * @hidden
     * @returns {number} Returns the visible frozen columns count
     */
    getVisibleFrozenColumns() {
        return this.getVisibleFrozenColumnsCount() + this.getVisibleFrozenCount(this.columns, 0);
    }
    /**
     * Pin the rows using the data
     *
     * @param  {Object[]} data - Defines the row data for frozen row.
     *
     * @returns {void}
     */
    pinRows(data) {
        const primaryKey = this.getPrimaryKeyFieldNames()[0];
        let isRefresh = false;
        for (let i = 0; i < data.length; i++) {
            const rowData = data[parseInt(i.toString(), 10)];
            if (!this.pinnedTopRowKeys[rowData[`${primaryKey}`]]) {
                this.pinnedTopRecords.push(rowData);
                this.pinnedTopRowKeys[rowData[`${primaryKey}`]] = true;
                isRefresh = true;
            }
        }
        if (isRefresh) {
            this.notify(events.modelChanged, { requestType: 'pin-row' });
        }
    }
    /**
     * Unpin the rows using data
     *
     * @param  {Object[]} data - Defines the row data for frozen row.
     *
     * @returns {void}
     */
    unpinRows(data) {
        const primaryKey = this.getPrimaryKeyFieldNames()[0];
        let isRefresh = false;
        for (let i = 0; i < data.length; i++) {
            const rowData = data[parseInt(i.toString(), 10)];
            const primaryKeyValue = rowData[`${primaryKey}`];
            const index = this.pinnedTopRecords.findIndex((row) => row[`${primaryKey}`] === primaryKeyValue);
            if (this.pinnedTopRowKeys[rowData[`${primaryKey}`]]) {
                this.pinnedTopRecords.splice(index, 1);
                this.pinnedTopRowKeys[rowData[`${primaryKey}`]] = false;
                isRefresh = true;
            }
        }
        if (isRefresh) {
            this.notify(events.modelChanged, { requestType: 'unpin-row' });
        }
    }
    /**
     * Get the current Filter operator and field.
     *
     * @returns {FilterUI} Returns the filter UI
     */
    getFilterUIInfo() {
        return this.filterModule ? this.filterModule.getFilterUIInfo() : {};
    }
    getVisibleFrozenColumnsCount() {
        let visibleFrozenColumns = 0;
        const columns = this.columnModel;
        for (let i = 0; i < this.frozenColumns; i++) {
            if (columns[parseInt(i.toString(), 10)].visible) {
                visibleFrozenColumns++;
            }
        }
        if ((this.frozenLeftCount || this.leftcount) || (this.frozenRightCount || this.rightcount)) {
            for (let i = 0; i < columns.length; i++) {
                if (columns[parseInt(i.toString(), 10)].visible && (columns[parseInt(i.toString(), 10)].freeze === 'Left'
                    || columns[parseInt(i.toString(), 10)].freeze === 'Right')) {
                    visibleFrozenColumns++;
                }
            }
        }
        return visibleFrozenColumns;
    }
    getVisibleFrozenCount(cols, cnt) {
        if ((!this.frozenLeftCount && !this.leftcount) && (!this.frozenRightCount || !this.rightcount)) {
            for (let i = 0, len = cols.length; i < len; i++) {
                if (cols[parseInt(i.toString(), 10)].columns) {
                    cnt = this.getVisibleFrozenCount(cols[parseInt(i.toString(), 10)].columns, cnt);
                }
                else {
                    if (cols[parseInt(i.toString(), 10)].isFrozen && cols[parseInt(i.toString(), 10)].visible) {
                        cnt++;
                    }
                }
            }
        }
        return cnt;
    }
    getFrozenCount(cols, cnt, index) {
        for (let i = 0, len = (!isNullOrUndefined(cols) ? cols.length : 0); i < len; i++) {
            if (cols[parseInt(i.toString(), 10)].columns) {
                cnt = this.getFrozenCount(cols[parseInt(i.toString(), 10)].columns, cnt, index);
            }
            else {
                if (cols[parseInt(i.toString(), 10)].isFrozen && index > this.frozenColumns - 1) {
                    cnt++;
                }
                index++;
            }
        }
        return cnt;
    }
    /**
     * Navigates to the specified target page.
     *
     * @param  {number} pageNo - Defines the page number to navigate.
     *
     * @returns {void}
     */
    goToPage(pageNo) {
        if (this.pagerModule) {
            this.pagerModule.goToPage(pageNo);
        }
    }
    /**
     * Defines the text of external message.
     *
     * @param  {string} message - Defines the message to update.
     *
     * @returns {void}
     */
    updateExternalMessage(message) {
        if (this.pagerModule && !this.pagerTemplate) {
            this.pagerModule.updateExternalMessage(message);
        }
    }
    /**
     * Sorts a column with the given options.
     *
     * @param {string} columnName - Defines the column name to be sorted.
     * @param {SortDirection} direction - Defines the direction of sorting field.
     * @param {boolean} isMultiSort - Specifies whether the previous sorted columns are to be maintained.
     *
     * @returns {void}
     */
    sortColumn(columnName, direction, isMultiSort) {
        if (this.sortModule) {
            this.sortModule.sortColumn(columnName, direction, isMultiSort);
        }
    }
    /**
     * Remove the existing columns along with the grid actions like sorting, filtering, searching, grouping, aggregate, etc., and grid will refresh with new columns based on the updated new data source.
     * > * If no columns are specified while changing the data source, then the columns are auto generated in the Grid based on the list of columns in the updated data source.
     *
     * @param {Object | DataManager | DataResult} dataSource -  Assign the new datasource.
     * @param {Column[] | string[] | ColumnModel[]} columns - Defines columns.
     * @returns {void}
     *
     *
     * ```typescript
     * <button id="btn">change dataSource </button>
     * <div id="Grid"></div>
     * <script>
     * let gridObj: Grid = new Grid({
     *     dataSource: employeeData,  // you can define the datamanager here if you are binding a data through datamanager
     *     columns: [
     *         { field: 'OrderID', headerText: 'Order ID', width:100 },
     *         { field: 'EmployeeID', headerText: 'Employee ID' }],
     * });
     * gridObj.appendTo('#Grid');
     * document.getElementById('btn').addEventListener("click", function(){
     * let newColumn: [
     *     { field: 'CustomerID', headerText: 'Customer ID', width:100 },
     *     { field: 'FirstName', headerText: 'Name' }];
     * gridObj.changeDataSource(customerData, newColumn);
     * });
     * </script>
     * ```
     *
     */
    changeDataSource(dataSource, columns) {
        this.isChangeDataSourceCall = true;
        this.setProperties({ sortSettings: { columns: [] } }, true);
        this.setProperties({ filterSettings: { columns: [] } }, true);
        this.setProperties({ searchSettings: { key: '' } }, true);
        if (this.allowGrouping) {
            this.setProperties({ groupSettings: { columns: [] } }, true);
        }
        if (columns && columns.length) {
            this.setProperties({ columns: columns }, true);
        }
        if (dataSource) {
            if (isNullOrUndefined(columns)) {
                this.setProperties({ columns: [] }, true);
            }
            this.setProperties({ dataSource: dataSource }, true);
        }
        this.freezeRefresh();
        this.isChangeDataSourceCall = false;
    }
    /**
     * Clears all the sorted columns of the Grid.
     *
     * @returns {void}
     */
    clearSorting() {
        if (this.sortModule) {
            this.sortModule.clearSorting();
        }
    }
    /**
     * Remove sorted column by field name.
     *
     * @param {string} field - Defines the column field name to remove sort.
     * @returns {void}
     * @hidden
     */
    removeSortColumn(field) {
        if (this.sortModule) {
            this.sortModule.removeSortColumn(field);
        }
    }
    /**
     * @hidden
     * @returns {void}
     */
    clearGridActions() {
        this.setProperties({ sortSettings: { columns: [] } }, true);
        this.setProperties({ filterSettings: { columns: [] } }, true);
        this.setProperties({ searchSettings: { key: '' } }, true);
        if (this.allowGrouping) {
            this.setProperties({ groupSettings: { columns: [] } }, false);
        }
        else {
            this.freezeRefresh();
        }
    }
    /**
     * Filters grid row by column name with the given options.
     *
     * @param  {string} fieldName - Defines the field name of the column.
     * @param  {string} filterOperator - Defines the operator to filter records.
     * @param  {string | number | Date | boolean} filterValue - Defines the value used to filter records.
     * @param  {string} predicate - Defines the relationship between one filter query and another by using AND or OR predicate.
     * @param  {boolean} matchCase - If match case is set to true, the grid filters the records with exact match. if false, it filters case
     * insensitive records (uppercase and lowercase letters treated the same).
     * @param  {boolean} ignoreAccent - If ignoreAccent set to true,
     * then filter ignores the diacritic characters or accents while filtering.
     * @param  {string} actualFilterValue - Defines the actual filter value for the filter column.
     * @param  {string} actualOperator - Defines the actual filter operator for the filter column.
     *
     * @returns {void}
     */
    filterByColumn(fieldName, filterOperator, filterValue, predicate, matchCase, ignoreAccent, actualFilterValue, actualOperator) {
        if (this.filterModule) {
            this.filterModule.filterByColumn(fieldName, filterOperator, filterValue, predicate, matchCase, ignoreAccent, actualFilterValue, actualOperator);
        }
    }
    /**
     * Clears all the filtered rows of the Grid.
     *
     * @param {string[]} fields - Defines the Fields
     * @returns {void}
     */
    clearFiltering(fields) {
        if (this.filterModule) {
            this.filterModule.clearFiltering(fields);
        }
    }
    /**
     * Removes filtered column by field name.
     *
     * @param  {string} field - Defines column field name to remove filter.
     * @param  {boolean} isClearFilterBar -  Specifies whether the filter bar value needs to be cleared.
     * @returns {void}
     * @hidden
     */
    removeFilteredColsByField(field, isClearFilterBar) {
        if (this.filterModule) {
            this.filterModule.removeFilteredColsByField(field, isClearFilterBar);
        }
    }
    /**
     * Selects a row by given index.
     *
     * @param  {number} index - Defines the row index.
     * @param  {boolean} isToggle - If set to true, then it toggles the selection.
     *
     * @returns {void}
     */
    selectRow(index, isToggle) {
        if (this.selectionModule) {
            this.selectionModule.selectRow(index, isToggle);
        }
    }
    /**
     * Selects a collection of rows by indexes.
     *
     * @param  {number[]} rowIndexes - Specifies the row indexes.
     *
     * @returns {void}
     */
    selectRows(rowIndexes) {
        if (this.selectionModule) {
            this.selectionModule.selectRows(rowIndexes);
        }
    }
    /**
     * Deselects the current selected rows and cells.
     *
     * @returns {void}
     */
    clearSelection() {
        if (this.selectionModule) {
            this.selectionModule.clearSelection();
        }
    }
    /**
     * Selects a cell by the given index.
     *
     * @param  {IIndex} cellIndex - Defines the row and column indexes.
     * @param  {boolean} isToggle - If set to true, then it toggles the selection.
     *
     * @returns {void}
     */
    selectCell(cellIndex, isToggle) {
        if (this.selectionModule) {
            this.selectionModule.selectCell(cellIndex, isToggle);
        }
    }
    /**
     * Selects a range of cells from start and end indexes.
     *
     * @param  {IIndex} startIndex - Specifies the row and column's start index.
     * @param  {IIndex} endIndex - Specifies the row and column's end index.
     *
     * @returns {void}
     */
    selectCellsByRange(startIndex, endIndex) {
        this.selectionModule.selectCellsByRange(startIndex, endIndex);
    }
    /**
     * Searches Grid records using the given key.
     * You can customize the default search option by using the
     * [`searchSettings`](./#searchsettings/).
     *
     * @param  {string} searchString - Defines the key.
     *
     * @returns {void}
     */
    search(searchString) {
        if (this.searchModule) {
            this.searchModule.search(searchString);
        }
    }
    /**
     * By default, prints all the pages of the Grid and hides the pager.
     * > You can customize print options using the
     * [`printMode`](./#printmode).
     *
     * @returns {void}
     */
    print() {
        if (this.printModule) {
            this.printModule.print();
        }
    }
    /**
     * Delete a record with Given options. If fieldname and data is not given then grid will delete the selected record.
     * > `editSettings.allowDeleting` should be true.
     *
     * @param {string} fieldname - Defines the primary key field, 'Name of the column'.
     * @param {Object} data - Defines the JSON data of the record to be deleted.
     * @returns {void}
     */
    deleteRecord(fieldname, data) {
        if (this.editModule) {
            this.editModule.deleteRecord(fieldname, data);
        }
    }
    /**
     * Starts edit the selected row. At least one row must be selected before invoking this method.
     * `editSettings.allowEditing` should be true.
     * {% codeBlock src='grid/startEdit/index.md' %}{% endcodeBlock %}
     *
     * @returns {void}
     */
    startEdit() {
        if (this.editModule) {
            this.editModule.startEdit();
        }
    }
    /**
     * If Grid is in editable state, you can save a record by invoking endEdit.
     *
     * @returns {void}
     */
    endEdit() {
        if (this.editModule) {
            this.editModule.endEdit();
        }
    }
    /**
     * Cancels edited state.
     *
     * @returns {void}
     */
    closeEdit() {
        if (this.editModule) {
            this.editModule.closeEdit();
        }
    }
    /**
     * Adds a new record to the Grid. Without passing parameters, it adds empty rows.
     * > `editSettings.allowEditing` should be true.
     *
     * @param {Object} data - Defines the new add record data.
     * @param {number} index - Defines the row index to be added
     * @returns {void}
     */
    addRecord(data, index) {
        if (this.editModule) {
            this.editModule.addRecord(data, index);
        }
    }
    /**
     * Delete any visible row by TR element.
     *
     * @param {HTMLTableRowElement} tr - Defines the table row element.
     * @returns {void}
     */
    deleteRow(tr) {
        if (this.editModule) {
            this.editModule.deleteRow(tr);
        }
    }
    /**
     * Changes a particular cell into edited state based on the row index and field name provided in the `batch` mode.
     *
     * @param {number} index - Defines row index to edit a particular cell.
     * @param {string} field - Defines the field name of the column to perform batch edit.
     *
     * @returns {void}
     */
    editCell(index, field) {
        if (this.editModule) {
            this.editModule.editCell(index, field);
        }
    }
    /**
     * Saves the cell that is currently edited. It does not save the value to the DataSource.
     *
     * @returns {void}
     * {% codeBlock src='grid/saveCell/index.md' %}{% endcodeBlock %}
     */
    saveCell() {
        if (this.editModule) {
            this.editModule.saveCell();
        }
    }
    /**
     * To update the specified cell by given value without changing into edited state.
     *
     * @param {number} rowIndex Defines the row index.
     * @param {string} field Defines the column field.
     * @param {string | number | boolean | Date} value - Defines the value to be changed.
     *
     * @returns {void}
     */
    updateCell(rowIndex, field, value) {
        if (this.editModule) {
            this.editModule.updateCell(rowIndex, field, value);
        }
    }
    /**
     * To update the specified row by given values without changing into edited state.
     *
     * {% codeBlock src='grid/updateRow/index.md' %}{% endcodeBlock %}
     *
     * @param {number} index Defines the row index.
     * @param {Object} data Defines the data object to be updated.
     *
     * @returns {void}
     */
    updateRow(index, data) {
        if (this.editModule) {
            this.editModule.updateRow(index, data);
        }
    }
    /**
     * Gets the added, edited,and deleted data before bulk save to the DataSource in batch mode.
     *
     * @returns {Object} Returns the batch changes
     */
    getBatchChanges() {
        if (this.editModule) {
            return this.editModule.getBatchChanges();
        }
        return {};
    }
    /**
     * Enables or disables ToolBar items.
     *
     * @param {string[]} items - Defines the collection of itemID of ToolBar items.
     * @param {boolean} isEnable - Defines the items to be enabled or disabled.
     *
     * @returns {void}
     */
    enableToolbarItems(items, isEnable) {
        if (this.toolbarModule) {
            this.toolbarModule.enableItems(items, isEnable);
        }
    }
    /**
     * Copy the selected rows or cells data into clipboard.
     *
     * @param {boolean} withHeader - Specifies whether the column header text needs to be copied along with rows or cells.
     * @returns {void}
     */
    copy(withHeader) {
        if (this.clipboardModule) {
            this.clipboardModule.copy(withHeader);
        }
    }
    /**
     * @hidden
     * @returns {void}
     */
    recalcIndentWidth() {
        if (!this.getHeaderTable().querySelector('.e-emptycell')) {
            return;
        }
        if ((!this.groupSettings.columns.length && !this.isDetail() && !this.isRowDragable()) ||
            this.getHeaderTable().querySelector('.e-emptycell.e-indentRefreshed') ||
            !this.getContentTable()) {
            return;
        }
        let indentWidth = this.getHeaderTable().querySelector('.e-emptycell').parentElement.offsetWidth;
        const headerCol = [].slice.call(this.getHeaderTable().querySelector(literals.colGroup).childNodes);
        const contentCol = [].slice.call(this.getContentTable().querySelector(literals.colGroup).childNodes);
        const perPixel = indentWidth / 30;
        let i = this.getFrozenMode() === 'Right' ? this.groupSettings.columns.length + this.getColumns().length : 0;
        const parentOffset = this.element.offsetWidth;
        const applyWidth = (index, width) => {
            if (ispercentageWidth(this)) {
                const newWidth = (width / parentOffset * 100).toFixed(1) + '%';
                headerCol[parseInt(index.toString(), 10)].style.width = newWidth;
                contentCol[parseInt(index.toString(), 10)].style.width = newWidth;
            }
            else {
                headerCol[parseInt(index.toString(), 10)].style.width = width + 'px';
                contentCol[parseInt(index.toString(), 10)].style.width = width + 'px';
            }
            this.notify(events.columnWidthChanged, { index: index, width: width });
        };
        if (perPixel >= 1) {
            indentWidth = (30 / perPixel);
        }
        if (indentWidth < 1) {
            indentWidth = 1;
        }
        if (this.enableColumnVirtualization || this.isAutoGen || (this.columns.length === this.groupSettings.columns.length)) {
            indentWidth = 30;
        }
        while (i < this.groupSettings.columns.length) {
            applyWidth(i, indentWidth);
            i++;
        }
        if (this.isDetail()) {
            applyWidth(i, indentWidth);
            i++;
        }
        if (this.isRowDragable()) {
            applyWidth(i, indentWidth);
        }
        this.isAutoGen = false;
        this.getHeaderTable().querySelector('.e-emptycell').classList.add('e-indentRefreshed');
    }
    /**
     * @hidden
     * @returns {void}
     */
    resetIndentWidth() {
        if (this.isDestroyed) {
            return;
        }
        if (ispercentageWidth(this)) {
            this.getHeaderTable().querySelector('.e-emptycell').classList.remove('e-indentRefreshed');
            this.widthService.setWidthToColumns();
            this.recalcIndentWidth();
            if (this.autoFit) {
                this.preventAdjustColumns();
            }
        }
        if ((this.width === 'auto' || typeof (this.width) === 'string' && this.width.indexOf('%') !== -1)
            && this.getColumns().filter((col) => (!col.width || col.width === 'auto') && col.minWidth).length > 0) {
            const tgridWidth = this.widthService.getTableWidth(this.getColumns(), true);
            this.widthService.setMinwidthBycalculation(tgridWidth);
        }
        if (this.isFrozenGrid() && this.enableColumnVirtualization && this.widthService) {
            this.widthService.refreshFrozenScrollbar();
        }
        if (this.allowTextWrap && this.textWrapSettings.wrapMode !== 'Content') {
            this.notify(events.refreshHandlers, {});
        }
        if ((this.frozenRows || this.pinnedTopRowModels.length) && this.scrollModule) {
            this.scrollModule.resizeFrozenRowBorder();
        }
        if (this.enableStickyHeader) {
            this.scrollModule.makeStickyHeader();
        }
        if (this.enableAutoFill && this.selectionSettings.type === 'Multiple' &&
            this.selectionSettings.mode === 'Cell' && this.selectionModule.selectedRowCellIndexes.length) {
            this.selectionModule.updateAutoFillPosition();
            this.selectionModule.drawBorders();
        }
    }
    /**
     * @hidden
     * @returns {boolean} Returns isRowDragable
     */
    isRowDragable() {
        return this.allowRowDragAndDrop && !this.rowDropSettings.targetID;
    }
    /**
     * Changes the Grid column positions by field names.
     *
     * @param  {string} fromFName - Defines the origin field name.
     * @param  {string} toFName - Defines the destination field name.
     *
     * @returns {void}
     */
    reorderColumns(fromFName, toFName) {
        if (this.reorderModule) {
            this.reorderModule.reorderColumns(fromFName, toFName);
        }
    }
    /**
     * Reorders a column in the Grid using column models.
     *
     * Moves the specified column (fromColumn) before the target column (toColumn),
     * supporting both standard and stacked header columns.
     *
     * @param {Column} fromColumn - The column model to be moved.
     * @param {Column} toColumn - The target column model before which the source column will be placed.
     *
     * @returns {void}
     */
    reorderColumnByModel(fromColumn, toColumn) {
        if (this.reorderModule) {
            this.reorderModule.reorderColumnByModel(fromColumn, toColumn);
        }
    }
    /**
     * Changes the Grid column positions by field index. If you invoke reorderColumnByIndex multiple times,
     * then you won't get the same results every time.
     *
     * @param  {number} fromIndex - Defines the origin field index.
     * @param  {number} toIndex - Defines the destination field index.
     *
     * @returns {void}
     */
    reorderColumnByIndex(fromIndex, toIndex) {
        if (this.reorderModule) {
            this.reorderModule.reorderColumnByIndex(fromIndex, toIndex);
        }
    }
    /**
     * Changes the Grid column positions by field index. If you invoke reorderColumnByTargetIndex multiple times,
     * then you will get the same results every time.
     *
     * @param  {string} fieldName - Defines the field name.
     * @param  {number} toIndex - Defines the destination field index.
     *
     * @returns {void}
     */
    reorderColumnByTargetIndex(fieldName, toIndex) {
        if (this.reorderModule) {
            this.reorderModule.reorderColumnByTargetIndex(fieldName, toIndex);
        }
    }
    /**
     * Changes the Grid Row position with given indexes.
     *
     * @param  {number} fromIndexes - Defines the origin Indexes.
     * @param  {number} toIndex - Defines the destination Index.
     *
     * @returns {void}
     */
    reorderRows(fromIndexes, toIndex) {
        if (this.rowDragAndDropModule) {
            this.rowDragAndDropModule.reorderRows(fromIndexes, toIndex);
        }
    }
    /**
     * @param {ReturnType} e - Defines the Return type
     * @returns {void}
     * @hidden
     */
    refreshDataSource(e) {
        this.notify('refreshdataSource', e);
    }
    /**
     * @param {boolean} enable -Defines the enable
     * @returns {void}
     * @hidden
     */
    disableRowDD(enable) {
        const headerTable = this.getHeaderTable();
        const contentTable = this.getContentTable();
        const headerRows = headerTable.querySelectorAll('th.e-rowdragheader, th.e-mastercell');
        const rows = this.getRows();
        const disValue = enable ? 'none' : '';
        setStyleAttribute(headerTable.querySelector(literals.colGroup).childNodes[0], { 'display': disValue });
        setStyleAttribute(contentTable.querySelector(literals.colGroup).childNodes[0], { 'display': disValue });
        for (let i = 0; i < this.getRows().length; i++) {
            const ele = rows[parseInt(i.toString(), 10)].firstElementChild;
            if (enable) {
                addClass([ele], 'e-hide');
            }
            else {
                removeClass([ele], ['e-hide']);
            }
        }
        for (let j = 0; j < headerTable.querySelectorAll('th.e-rowdragheader, th.e-mastercell').length; j++) {
            const ele = headerRows[parseInt(j.toString(), 10)];
            if (enable) {
                addClass([ele], 'e-hide');
            }
            else {
                removeClass([ele], ['e-hide']);
            }
        }
    }
    /**
     * Changes the column width to automatically fit its content to ensure that the width shows the content without wrapping/hiding.
     * > * This method ignores the hidden columns.
     * > * Uses the `autoFitColumns` method in the `dataBound` event to resize at initial rendering.
     * > * By specifying the start row index and end row index, providing the range within which the maximum width for that column should be considered when applying `autoFitColumns`.
     * > * The width of header rows is always calculated. If the width of a header row exceeds the specified range, its width will be allocated to the specific content rows.
     *
     * @param  {string |string[]} fieldNames - Defines the column names.
     * @param  {number} startRowIndex - Specifies the start index of the content row.
     * @param  {number} endRowIndex - Specifies the end index of content row.
     * @returns {void}
     *
     *
     * ```typescript
     * <div id="Grid"></div>
     * <script>
     * let gridObj: Grid = new Grid({
     *     dataSource: employeeData,
     *     columns: [
     *         { field: 'OrderID', headerText: 'Order ID', width:100 },
     *         { field: 'EmployeeID', headerText: 'Employee ID' }],
     *     dataBound: () => gridObj.autoFitColumns('EmployeeID');
     * });
     * gridObj.appendTo('#Grid');
     * </script>
     * ```
     *
     */
    autoFitColumns(fieldNames, startRowIndex, endRowIndex) {
        const injectedModules = this.getInjectedModules();
        const resize = injectedModules.find(function (item) {
            if (typeof item === 'function' && !isNullOrUndefined(item.prototype)) {
                return item.prototype.getModuleName() === 'resize';
            }
            else {
                return item.name === 'Resize';
            }
        });
        if (!this.resizeModule && resize) {
            this.autoFitColumnsResize = true;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.injectModules();
        }
        if (this.resizeModule) {
            this.resizeModule.autoFitColumns(fieldNames, startRowIndex, endRowIndex);
        }
    }
    /**
     * @returns {void}
     * @hidden
     */
    preventAdjustColumns() {
        if ((this.enableAdaptiveUI && this.rowRenderingMode === 'Vertical')
            || (this.allowResizing && this.resizeSettings.mode === 'Auto')) {
            return;
        }
        const columns = this.getColumns();
        const headerTable = this.getHeaderTable();
        let tableWidth = 0;
        for (let i = 0; i < columns.length; i++) {
            if (columns[parseInt(i.toString(), 10)].visible) {
                if (this.groupSettings.columns.length
                    && this.groupSettings.columns.indexOf(columns[parseInt(i.toString(), 10)].field) > -1) {
                    const headerCol = [].slice.call(headerTable.querySelector('colgroup')
                        .querySelectorAll(':not(.e-group-intent):not(.e-detail-intent):not(.e-drag-intent)'));
                    if (headerCol[parseInt(i.toString(), 10)].style.display === 'none') {
                        continue;
                    }
                }
                if (columns[parseInt(i.toString(), 10)].width) {
                    tableWidth += parseFloat(columns[parseInt(i.toString(), 10)].width.toString());
                }
                else {
                    tableWidth = 0;
                    break;
                }
            }
        }
        if (tableWidth) {
            const percentageWidth = this.isPercentageWidthGrid();
            const unit = this.widthUnit(percentageWidth);
            const contentTable = this.getContentTable();
            if (this.groupSettings.columns.length || this.isDetail() || this.isRowDragable()) {
                const indentWidth = this.defaultIndentWidth(percentageWidth);
                const indentWidthUnitFormat = indentWidth.toString() + unit;
                const headerIndentCol = [].slice.call(headerTable.querySelector('colgroup')
                    .querySelectorAll('.e-group-intent, .e-detail-intent, .e-drag-intent'));
                const contentIndentCol = [].slice.call(contentTable.querySelector('colgroup')
                    .querySelectorAll('.e-group-intent, .e-detail-intent, .e-drag-intent'));
                for (let i = 0; i < headerIndentCol.length; i++) {
                    headerIndentCol[parseInt(i.toString(), 10)].style.setProperty('width', indentWidthUnitFormat);
                    contentIndentCol[parseInt(i.toString(), 10)].style.setProperty('width', indentWidthUnitFormat);
                    tableWidth += indentWidth;
                }
            }
            if ((percentageWidth && tableWidth < 100)
                || (!percentageWidth && tableWidth < contentTable.parentElement.clientWidth)) {
                if (!isNullOrUndefined(contentTable.querySelector('.e-emptyrow'))) {
                    addClass([headerTable], ['e-tableborder']);
                    removeClass([contentTable], ['e-tableborder']);
                }
                else {
                    addClass([headerTable, contentTable], ['e-tableborder']);
                }
            }
            const tableWidthUnitFormat = tableWidth.toString() + unit;
            headerTable.style.setProperty('width', tableWidthUnitFormat);
            contentTable.style.setProperty('width', tableWidthUnitFormat);
        }
        else {
            this.restoreAdjustColumns();
        }
    }
    restoreAdjustColumns() {
        if ((this.enableAdaptiveUI && this.rowRenderingMode === 'Vertical')
            || (this.allowResizing && this.resizeSettings.mode === 'Auto')) {
            return;
        }
        const headerTable = this.getHeaderTable();
        const contentTable = this.getContentTable();
        removeClass([headerTable, contentTable], ['e-tableborder']);
        headerTable.style.removeProperty('width');
        contentTable.style.removeProperty('width');
        if (this.groupSettings.columns.length || this.isDetail() || this.isRowDragable()) {
            const percentageWidth = this.isPercentageWidthGrid();
            const indentWidthUnitFormat = this.defaultIndentWidth(percentageWidth).toString() + this.widthUnit(percentageWidth);
            const headerIndentCol = [].slice.call(headerTable.querySelector('colgroup')
                .querySelectorAll('.e-group-intent, .e-detail-intent, .e-drag-intent'));
            headerIndentCol.forEach((element) => {
                element.style.setProperty('width', indentWidthUnitFormat);
            });
            headerTable.querySelector('.e-emptycell').classList.remove('e-indentRefreshed');
            this.recalcIndentWidth();
        }
    }
    widthUnit(percentageWidth) {
        return percentageWidth ? '%' : 'px';
    }
    defaultIndentWidth(percentageWidth) {
        return percentageWidth ? parseFloat((30 / this.element.offsetWidth * 100).toFixed(1)) : 30;
    }
    isPercentageWidthGrid() {
        const column = this.getColumns().find((col) => { return !isNullOrUndefined(col.width); });
        return column ? column.width.toString().indexOf('%') > -1 : false;
    }
    /**
     * @param {number} x - Defines the number
     * @param {number} y - Defines the number
     * @param {Element} target - Defines the Element
     * @returns {void}
     * @hidden
     */
    createColumnchooser(x, y, target) {
        if (this.columnChooserModule) {
            this.columnChooserModule.renderColumnChooser(x, y, target);
        }
    }
    initializeServices() {
        this.serviceLocator.register('widthService', this.widthService = new ColumnWidthService(this));
        this.serviceLocator.register('cellRendererFactory', new CellRendererFactory);
        this.serviceLocator.register('rendererFactory', new RendererFactory);
        this.serviceLocator.register('localization', this.localeObj = new L10n(this.getModuleName(), this.defaultLocale, this.locale));
        this.serviceLocator.register('valueFormatter', this.valueFormatterService = new ValueFormatter(this.locale));
        this.serviceLocator.register('showHideService', this.showHider = new ShowHide(this));
        this.serviceLocator.register('ariaService', this.ariaService = new AriaService());
        this.serviceLocator.register('focus', this.focusModule = new FocusStrategy(this));
    }
    processModel() {
        const gCols = this.groupSettings.columns;
        const sCols = this.sortSettings.columns;
        let flag;
        let j;
        if (this.allowGrouping) {
            for (let i = 0, len = gCols.length; i < len; i++) {
                flag = false;
                j = 0;
                for (let sLen = sCols.length; j < sLen; j++) {
                    if (sCols[parseInt(j.toString(), 10)].field === gCols[parseInt(i.toString(), 10)]) {
                        flag = true;
                        break;
                    }
                }
                if (!flag) {
                    sCols.push({ field: gCols[parseInt(i.toString(), 10)], direction: 'Ascending', isFromGroup: true });
                }
                else {
                    if (this.allowSorting) {
                        this.sortedColumns.push(sCols[parseInt(j.toString(), 10)].field);
                    }
                    else {
                        sCols[parseInt(j.toString(), 10)].direction = 'Ascending';
                    }
                }
                if (!this.groupSettings.showGroupedColumn) {
                    const column = this.enableColumnVirtualization ?
                        this.columns.filter((c) => c.field === gCols[parseInt(i.toString(), 10)])[0]
                        : this.getColumnByField(gCols[parseInt(i.toString(), 10)]);
                    if (column) {
                        column.visible = false;
                    }
                    else {
                        this.log('initial_action', { moduleName: 'group', columnName: gCols[parseInt(i.toString(), 10)] });
                    }
                }
            }
        }
        if (!gCols.length) {
            for (let i = 0; i < sCols.length; i++) {
                this.sortedColumns.push(sCols[parseInt(i.toString(), 10)].field);
            }
        }
        this.rowTemplateFn = templateCompiler(this.rowTemplate);
        this.emptyRecordTemplateFn = templateCompiler(this.emptyRecordTemplate);
        this.detailTemplateFn = templateCompiler(this.detailTemplate);
        this.editTemplateFn = templateCompiler(this.editSettings.template);
        this.editHeaderTemplateFn = templateCompiler(this.editSettings.headerTemplate);
        this.editFooterTemplateFn = templateCompiler(this.editSettings.footerTemplate);
        this.columnChooserTemplateFn = templateCompiler(this.columnChooserSettings.template);
        this.columnChooserHeaderTemplateFn = templateCompiler(this.columnChooserSettings.headerTemplate);
        this.columnChooserFooterTemplateFn = templateCompiler(this.columnChooserSettings.footerTemplate);
        if (!isNullOrUndefined(this.parentDetails)) {
            const value = isNullOrUndefined(this.parentDetails.parentKeyFieldValue) ? 'undefined' :
                this.parentDetails.parentKeyFieldValue;
            this.query.where(this.queryString, 'equal', value, true);
        }
        this.initForeignColumn();
    }
    initForeignColumn() {
        if (this.isForeignKeyEnabled(this.getColumns())) {
            this.notify(events.initForeignKeyColumn, this.getForeignKeyColumns());
        }
    }
    enableVerticalRendering() {
        if (this.rowRenderingMode === 'Vertical') {
            this.element.classList.add('e-row-responsive');
        }
        else {
            this.element.classList.remove('e-row-responsive');
        }
    }
    gridRender() {
        this.updateRTL();
        if (this.rowRenderingMode === 'Vertical') {
            this.element.classList.add('e-row-responsive');
        }
        if (this.enableHover) {
            this.element.classList.add('e-gridhover');
        }
        if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent) || Browser.isSafari()) {
            this.element.classList.add('e-mac-safari');
        }
        if (Browser.isDevice) {
            this.element.classList.add('e-device');
            if (this.adaptiveUIMode === 'Desktop' && !(this.rowRenderingMode === 'Vertical')) {
                this.enableAdaptiveUI = false;
            }
        }
        if (this.adaptiveUIMode === 'Mobile' && !(Browser.isDevice || this.rowRenderingMode === 'Vertical')) {
            this.enableAdaptiveUI = false;
        }
        if (this.rowHeight) {
            this.element.classList.add('e-grid-min-height');
        }
        if (this.cssClass) {
            if (this.cssClass.indexOf(' ') !== -1) {
                this.element.classList.add(...this.cssClass.split(' '));
            }
            else {
                this.element.classList.add(this.cssClass);
            }
        }
        // If the below if statement is removed, then drag and drop between grids will not work in firefox browser.
        if (this.allowRowDragAndDrop && this.rowDropSettings.targetID && Browser.info.name === 'mozilla') {
            this.element.classList.add('e-disableuserselect');
        }
        if (this.editSettings.showAddNewRow && (this.enableVirtualization || this.enableInfiniteScrolling)) {
            this.editSettings.newRowPosition = 'Top';
        }
        classList(this.element, ['e-responsive', 'e-default'], []);
        const rendererFactory = this.serviceLocator.getService('rendererFactory');
        this.headerModule = rendererFactory.getRenderer(RenderType.Header);
        this.contentModule = rendererFactory.getRenderer(RenderType.Content);
        this.printModule = new Print(this, this.scrollModule);
        this.clipboardModule = new Clipboard(this, this.serviceLocator);
        this.renderModule.render();
        this.eventInitializer();
        this.createGridPopUpElement();
        this.widthService.setWidthToColumns();
        this.updateGridLines();
        this.applyTextWrap();
        this.createTooltip(); //for clip mode ellipsis
        this.enableBoxSelection();
    }
    dataReady() {
        this.scrollModule.setWidth();
        this.scrollModule.setHeight();
        if (this.height !== 'auto') {
            this.scrollModule.setPadding();
        }
    }
    updateRTL() {
        if (this.enableRtl) {
            this.element.classList.add('e-rtl');
        }
        else {
            this.element.classList.remove('e-rtl');
        }
    }
    createGridPopUpElement() {
        const popup = this.createElement('div', { className: 'e-gridpopup' });
        popup.style.display = 'none';
        const content = this.createElement('div', { className: literals.content, attrs: { tabIndex: '-1' } });
        append([content, this.createElement('div', { className: 'e-uptail e-tail' })], popup);
        content.appendChild(this.createElement('span'));
        append([content, this.createElement('div', { className: 'e-downtail e-tail' })], popup);
        this.element.appendChild(popup);
    }
    updateGridLines() {
        classList(this.element, [], ['e-verticallines', 'e-horizontallines', 'e-hidelines', 'e-bothlines']);
        switch (this.gridLines) {
            case 'Horizontal':
                this.element.classList.add('e-horizontallines');
                break;
            case 'Vertical':
                this.element.classList.add('e-verticallines');
                break;
            case 'None':
                this.element.classList.add('e-hidelines');
                break;
            case 'Both':
                this.element.classList.add('e-bothlines');
                break;
        }
        this.updateResizeLines();
    }
    updateResizeLines() {
        if (this.allowResizing &&
            !(this.gridLines === 'Vertical' || this.gridLines === 'Both')) {
            this.element.classList.add('e-resize-lines');
        }
        else {
            this.element.classList.remove('e-resize-lines');
        }
    }
    /**
     * The function is used to apply text wrap
     *
     * @returns {void}
     * @hidden
     */
    applyTextWrap() {
        if (this.allowTextWrap) {
            const headerRows = [].slice.call(this.element.getElementsByClassName('e-columnheader'));
            switch (this.textWrapSettings.wrapMode) {
                case 'Header':
                    wrap(this.element, false);
                    wrap(this.getContent(), false);
                    wrap(headerRows, true);
                    break;
                case 'Content':
                    wrap(this.getContent(), true);
                    wrap(this.element, false);
                    wrap(headerRows, false);
                    break;
                default:
                    wrap(this.element, true);
                    wrap(this.getContent(), false);
                    wrap(headerRows, false);
            }
            if (this.textWrapSettings.wrapMode !== 'Content') {
                this.notify(events.refreshHandlers, {});
            }
        }
    }
    /**
     * The function is used to remove text wrap
     *
     * @returns {void}
     * @hidden
     */
    removeTextWrap() {
        wrap(this.element, false);
        const headerRows = [].slice.call(this.element.getElementsByClassName('e-columnheader'));
        wrap(headerRows, false);
        wrap(this.getContent(), false);
        if (this.textWrapSettings.wrapMode !== 'Content') {
            this.notify(events.refreshHandlers, {});
        }
    }
    /**
     * The function is used to add Tooltip to the grid cell that has ellipsiswithtooltip clip mode.
     *
     * @returns {void}
     * @hidden
     */
    createTooltip() {
        this.toolTipObj = new Tooltip({
            opensOn: 'custom',
            content: '',
            cssClass: this.cssClass ? this.cssClass : null
        }, this.element);
    }
    /**
     * Initiates a complete refresh of the Grid's column and layout.
     *
     * This method forces a full re-render of the Grid, ensuring that any dynamic
     * changes to columns or layout are immediately reflected.
     *
     * @returns {void}
     */
    freezeRefresh() {
        if (this.enableVirtualization || this.enableInfiniteScrolling) {
            this.pageSettings.currentPage = 1;
        }
        this.componentRefresh();
    }
    getTooltipStatus(element) {
        const headerTable = this.getHeaderTable();
        const headerDivTag = this.enableAdaptiveUI && this.rowRenderingMode === 'Vertical' ? 'e-gridcontent' : 'e-gridheader';
        const htable = this.createTable(headerTable, headerDivTag, 'header');
        const ctable = this.createTable(headerTable, headerDivTag, 'content');
        const table = element.classList.contains('e-headercell') ? htable : ctable;
        const ele = element.classList.contains('e-headercell') ? 'th' : 'tr';
        table.querySelector(ele).className = element.className;
        const targetElement = table.querySelector(ele);
        targetElement.innerHTML = '';
        Array.from(element.childNodes).forEach((child) => {
            targetElement.appendChild(child.cloneNode(true));
        });
        const width = table.querySelector(ele).getBoundingClientRect().width;
        document.body.removeChild(htable);
        document.body.removeChild(ctable);
        if ((width > element.getBoundingClientRect().width && !element.classList.contains('e-editedbatchcell')) ||
            (this.enableAdaptiveUI && this.rowRenderingMode === 'Vertical' &&
                width > (element.getBoundingClientRect().width * 0.55) - (this.height !== 'auto' ? 16 : 0))) {
            // 0.55 - defines the width of adaptive content cell, 16 - defines the scrollbar width
            return true;
        }
        return false;
    }
    mouseMoveHandler(e) {
        if (this.isEllipsisTooltip()) {
            const element = parentsUntil(e.target, 'e-ellipsistooltip');
            if (e.type === 'mouseout' && (this.prevElement !== element || element !== parentsUntil(e.relatedTarget, 'e-ellipsistooltip'))) {
                this.toolTipObj.close();
                this.toolTipObj['clear']();
                this.prevElement = null;
            }
            const tagName = e.target.tagName;
            const elemNames = ['A', 'BUTTON', 'INPUT'];
            if (element && e.type !== 'mouseout' && !(Browser.isDevice && elemNames.indexOf(tagName) !== -1)) {
                if (this.getTooltipStatus(element)) {
                    const col = this.getColumns()[parseInt(element.getAttribute(literals.ariaColIndex), 10) - 1];
                    const domSetter = col && col.disableHtmlEncode ? 'innerText' : 'innerHTML';
                    const contentDiv = this.createElement('div');
                    if (element.getElementsByClassName('e-headertext').length) {
                        const innerElement = element.getElementsByClassName('e-headertext')[0];
                        contentDiv[`${domSetter}`] = this.sanitize(innerElement.innerText);
                        this.toolTipObj.content = contentDiv;
                    }
                    else {
                        contentDiv[`${domSetter}`] = this.sanitize(element.innerText);
                        this.toolTipObj.content = contentDiv;
                    }
                    if (this.enableHtmlSanitizer) {
                        this.toolTipObj.enableHtmlSanitizer = true;
                    }
                    if (col && col.disableHtmlEncode) {
                        this.toolTipObj.enableHtmlParse = false;
                    }
                    if (element !== this.prevElement) {
                        this.toolTipObj['open'](element);
                    }
                    this.prevElement = element;
                }
            }
        }
    }
    isEllipsisTooltip() {
        const cols = this.getColumns();
        if (this.clipMode === 'EllipsisWithTooltip') {
            return true;
        }
        for (let i = 0; i < cols.length; i++) {
            if (cols[parseInt(i.toString(), 10)].clipMode === 'EllipsisWithTooltip') {
                return true;
            }
        }
        return false;
    }
    scrollHandler() {
        if (this.isEllipsisTooltip()) {
            this.toolTipObj.close();
        }
    }
    /**
     * To create table for ellipsiswithtooltip
     *
     * @param {Element} table - Defines the table
     * @param {string} tag - Defines the tag
     * @param {string} type - Defines the type
     * @returns {HTMLDivElement} Returns the HTML div ELement
     * @hidden
     */
    createTable(table, tag, type) {
        const myTableDiv = this.createElement('div');
        myTableDiv.className = this.element.className;
        myTableDiv.style.cssText = 'display: inline-block;visibility:hidden;position:absolute';
        const mySubDiv = this.createElement('div');
        mySubDiv.className = tag;
        const myTable = this.createElement('table');
        myTable.className = table.className;
        myTable.style.cssText = 'table-layout: auto;width: auto';
        const ele = (type === 'header') ? 'th' : 'td';
        const myTr = this.createElement('tr', { attrs: { role: 'row' } });
        const mytd = this.createElement(ele);
        myTr.appendChild(mytd);
        myTable.appendChild(myTr);
        mySubDiv.appendChild(myTable);
        myTableDiv.appendChild(mySubDiv);
        document.body.appendChild(myTableDiv);
        return myTableDiv;
    }
    onKeyPressed(e) {
        if (e.action === 'tab' || e.action === 'shiftTab') {
            this.toolTipObj.close();
        }
    }
    /**
     * Binding events to the element while component creation.
     *
     * @hidden
     * @returns {void}
     */
    wireEvents() {
        EventHandler.add(this.element, 'click', this.mouseClickHandler, this);
        EventHandler.add(this.element, 'touchend', this.mouseClickHandler, this);
        EventHandler.add(this.element, 'focusout', this.focusOutHandler, this);
        EventHandler.add(this.element, 'dblclick', this.dblClickHandler, this);
        EventHandler.add(this.element, 'keydown', this.keyPressHandler, this);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        EventHandler.add(window, 'resize', this.resetIndentWidth, this);
        if (this.allowKeyboard) {
            this.element.tabIndex = this.element.tabIndex === -1 ? 0 : this.element.tabIndex;
        }
        this.keyboardModule = new KeyboardEvents(this.element, {
            keyAction: this.keyActionHandler.bind(this),
            keyConfigs: this.keyConfigs,
            eventName: 'keydown'
        });
        EventHandler.add(this.getContent().firstElementChild, 'scroll', this.scrollHandler, this);
        EventHandler.add(this.element, 'mouseover', this.mouseMoveHandler, this);
        EventHandler.add(this.element, 'mouseout', this.mouseMoveHandler, this);
        EventHandler.add(this.getContent(), 'touchstart', this.tapEvent, this);
        EventHandler.add(document.body, 'keydown', this.keyDownHandler, this);
    }
    /**
     * Unbinding events from the element while component destroy.
     *
     * @hidden
     * @returns {void}
     */
    unwireEvents() {
        EventHandler.remove(this.element, 'click', this.mouseClickHandler);
        EventHandler.remove(this.element, 'touchend', this.mouseClickHandler);
        EventHandler.remove(this.element, 'focusout', this.focusOutHandler);
        EventHandler.remove(this.element, 'dblclick', this.dblClickHandler);
        EventHandler.remove(this.getContent().firstElementChild, 'scroll', this.scrollHandler);
        EventHandler.remove(this.element, 'mouseover', this.mouseMoveHandler);
        EventHandler.remove(this.element, 'mouseout', this.mouseMoveHandler);
        EventHandler.remove(this.element, 'keydown', this.keyPressHandler);
        EventHandler.remove(this.getContent(), 'touchstart', this.tapEvent);
        EventHandler.remove(document.body, 'keydown', this.keyDownHandler);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        EventHandler.remove(window, 'resize', this.resetIndentWidth);
    }
    /**
     * @hidden
     * @returns {void}
     */
    addListener() {
        if (this.isDestroyed) {
            return;
        }
        this.on(events.dataReady, this.dataReady, this);
        this.on(events.contentReady, this.recalcIndentWidth, this);
        this.on(events.headerRefreshed, this.recalcIndentWidth, this);
        this.on(events.refreshFrozenPosition, this.refreshFrozenPosition, this);
        this.on(events.refreshSplitFrozenColumn, this.refreshSplitFrozenColumn, this);
        this.dataBoundFunction = this.refreshMediaCol.bind(this);
        this.addEventListener(events.dataBound, this.dataBoundFunction);
        this.on(events.keyPressed, this.onKeyPressed, this);
    }
    /**
     * @hidden
     * @returns {void}
     */
    removeListener() {
        if (this.isDestroyed) {
            return;
        }
        this.off(events.dataReady, this.dataReady);
        this.off(events.contentReady, this.recalcIndentWidth);
        this.off(events.headerRefreshed, this.recalcIndentWidth);
        this.on(events.refreshFrozenPosition, this.refreshFrozenPosition, this);
        this.on(events.refreshSplitFrozenColumn, this.refreshSplitFrozenColumn, this);
        this.removeEventListener(events.dataBound, this.dataBoundFunction);
        this.off(events.keyPressed, this.onKeyPressed);
    }
    /**
     * Get current visible data of grid.
     *
     * @returns {Object[]} Returns the current view records
     *
     * @isGenericType true
     */
    getCurrentViewRecords() {
        if (isGroupAdaptive(this)) {
            return isNullOrUndefined(this.currentViewData.records) ?
                this.currentViewData : this.currentViewData.records;
        }
        if (this.groupSettings.enableLazyLoading) {
            return this.currentViewData;
        }
        return (this.allowGrouping && this.groupSettings.columns.length && this.currentViewData.length
            && this.currentViewData.records) ? this.currentViewData.records
            : this.currentViewData;
    }
    mouseClickHandler(e) {
        if (this.isChildGrid(e) || (parentsUntil(e.target, 'e-gridpopup') && e.touches) ||
            this.element.getElementsByClassName('e-cloneproperties').length || this.checkEdit(e)) {
            return;
        }
        if (((!this.allowRowDragAndDrop && (parentsUntil(e.target, literals.gridContent) ||
            e.target.tagName === 'TD')) || (parentsUntil(e.target, 'e-headercell') &&
            parentsUntil(e.target, 'e-headercell').querySelector('.e-checkselectall')) ||
            (!(this.allowGrouping || this.allowReordering) && parentsUntil(e.target, 'e-gridheader'))) &&
            e.touches) {
            return;
        }
        if (parentsUntil(e.target, 'e-gridheader') && this.allowRowDragAndDrop &&
            !(parentsUntil(e.target, 'e-filterbarcell')) && (e.target &&
            ['A', 'BUTTON', 'INPUT'].indexOf(e.target.tagName) === -1)) {
            e.preventDefault();
        }
        if (this.allowRowDragAndDrop && parentsUntil(e.target, 'e-rowcell')
            && !parentsUntil(e.target, 'e-rowdragdrop') && e.touches) {
            return;
        }
        const args = this.getRowInfo(e.target);
        args.event = e;
        const cancel = 'cancel';
        args[`${cancel}`] = false;
        let isDataRow = false;
        const tr = closest(e.target, 'tr');
        if (tr && tr.getAttribute('data-uid')) {
            const rowObj = this.getRowObjectFromUID(tr.getAttribute('data-uid'));
            isDataRow = rowObj ? rowObj.isDataRow : false;
        }
        if (isDataRow) {
            this.trigger(events.recordClick, args);
        }
        this.notify(events.click, e);
    }
    checkEdit(e) {
        const tr = parentsUntil(e.target, literals.row);
        const isEdit = this.editSettings.mode !== 'Batch' &&
            this.isEdit && tr && (tr.classList.contains(literals.editedRow) || (tr.classList.contains(literals.addedRow)) &&
            !this.editSettings.showAddNewRow);
        return !parentsUntil(e.target, 'e-unboundcelldiv') && (isEdit || (parentsUntil(e.target, literals.rowCell) &&
            parentsUntil(e.target, literals.rowCell).classList.contains('e-editedbatchcell')));
    }
    dblClickHandler(e) {
        const grid = parentsUntil(e.target, 'e-grid');
        if (isNullOrUndefined(grid) || grid.id !== this.element.id || closest(e.target, '.e-unboundcelldiv')) {
            return;
        }
        let dataRow = false;
        const tr = closest(e.target, 'tr');
        if (tr && tr.getAttribute('data-uid')) {
            const rowObj = this.getRowObjectFromUID(tr.getAttribute('data-uid'));
            dataRow = rowObj ? rowObj.isDataRow : false;
        }
        const args = this.getRowInfo(e.target);
        args.target = e.target;
        args.event = e;
        if (dataRow) {
            this.trigger(events.recordDoubleClick, args);
        }
        this.notify(events.dblclick, e);
    }
    focusOutHandler(e) {
        if (this.isChildGrid(e)) {
            return;
        }
        if (!parentsUntil(e.target, 'e-grid')) {
            this.element.querySelector('.e-gridpopup').style.display = 'None';
        }
        const filterClear = this.element.querySelector('.e-cancel:not(.e-hide)');
        if (filterClear && !filterClear.parentElement.classList.contains('e-tbar-btn')) {
            filterClear.classList.add('e-hide');
        }
        const relatedTarget = e.relatedTarget;
        const ariaOwns = relatedTarget ? relatedTarget.getAttribute('aria-owns') : null;
        if ((!relatedTarget || (!parentsUntil(relatedTarget, 'e-grid') &&
            (!isNullOrUndefined(ariaOwns) &&
                (ariaOwns)) !== e.target.getAttribute('aria-owns')))
            && !this.keyPress && this.isEdit && !Browser.isDevice) {
            if (this.editSettings.mode === 'Batch' && !(((parentsUntil(relatedTarget, 'e-ddl') || parentsUntil(relatedTarget, 'e-ddt')) &&
                (parentsUntil(relatedTarget, 'e-multi-select-list-wrapper') || parentsUntil(relatedTarget, 'e-input-filter'))) &&
                parentsUntil(relatedTarget, 'e-input-group')) && (parentsUntil(relatedTarget, 'e-uploader') || (!(relatedTarget &&
                isNullOrUndefined(parentsUntil(relatedTarget, 'e-input-group'))) && !parentsUntil(e.target, 'edit-custom-template')))) {
                this.editModule.saveCell();
                this.notify(events.editNextValCell, {});
            }
            if (this.editSettings.mode === 'Normal' && !this.isWidgetsDestroyed) {
                this.editModule.editFormValidate();
            }
        }
        if (this.editSettings.showAddNewRow) {
            this.editModule.isShowAddedRowValidate = false;
        }
        this.keyPress = false;
    }
    isChildGrid(e) {
        const gridElement = parentsUntil(e.target, 'e-grid');
        if ((gridElement && gridElement.id !== this.element.id) || (parentsUntil(e.target, 'e-unboundcelldiv') &&
            isNullOrUndefined(gridElement))) {
            return true;
        }
        return false;
    }
    /**
     * @param {Object} persistedData - Defines the persisted data
     * @returns {void}
     * @hidden
     */
    mergePersistGridData(persistedData) {
        const data = this.getLocalData();
        if (!(isNullOrUndefined(data) || (data === '')) || !isNullOrUndefined(persistedData)) {
            const dataObj = !isNullOrUndefined(persistedData) ? persistedData : JSON.parse(data);
            const keys = Object.keys(dataObj);
            this.isProtectedOnChange = true;
            for (const key of keys) {
                if ((typeof this[`${key}`] === 'object') && !isNullOrUndefined(this[`${key}`])) {
                    if (Array.isArray(this[`${key}`]) && key === 'columns') {
                        this.setFrozenCount();
                        setColumnIndex(this[`${key}`]);
                        this.mergeColumns(dataObj[`${key}`], this[`${key}`]);
                        this.mergedColumns = true;
                        this[`${key}`] = dataObj[`${key}`];
                    }
                    else {
                        extend(this[`${key}`], dataObj[`${key}`]);
                    }
                }
                else {
                    this[`${key}`] = dataObj[`${key}`];
                }
            }
            this.isProtectedOnChange = false;
        }
    }
    mergeColumns(storedColumn, columns) {
        const storedColumns = storedColumn;
        const isFrozenGrid = this.isFrozenGrid();
        for (let i = 0; i < storedColumns.length; i++) {
            let localCol = columns.filter((tCol) => isFrozenGrid ?
                tCol.index === storedColumns[parseInt(i.toString(), 10)][`${literals.initialFrozenColumnIndex}`] :
                tCol.index === storedColumns[parseInt(i.toString(), 10)].index)[0];
            if (!isNullOrUndefined(localCol)) {
                if (isFrozenGrid) {
                    localCol = extend({}, localCol, {}, true);
                    localCol.freeze = storedColumns[parseInt(i.toString(), 10)].freeze;
                }
                if (localCol.columns && localCol.columns.length) {
                    this.mergeColumns(storedColumns[parseInt(i.toString(), 10)].columns, localCol.columns);
                    storedColumns[parseInt(i.toString(), 10)] = extend(localCol, storedColumns[parseInt(i.toString(), 10)], {}, true);
                }
                else {
                    storedColumns[parseInt(i.toString(), 10)] = extend(localCol, storedColumns[parseInt(i.toString(), 10)], {}, true);
                }
            }
        }
    }
    /**
     * @hidden
     * @returns {boolean} Returns the isDetail
     */
    isDetail() {
        return !isNullOrUndefined(this.detailTemplate) || !isNullOrUndefined(this.childGrid);
    }
    isCommandColumn(columns) {
        return columns.some((col) => {
            if (col.columns) {
                return this.isCommandColumn(col.columns);
            }
            return !!(col.commands || col.commandsTemplate);
        });
    }
    isForeignKeyEnabled(columns) {
        return columns.some((col) => {
            if (col.columns) {
                return this.isForeignKeyEnabled(col.columns);
            }
            return !!(col.dataSource && col.foreignKeyValue);
        });
    }
    keyPressHandler(e) {
        const presskey = extend(e, { cancel: false });
        this.trigger('keyPressed', presskey);
        if (presskey.cancel === true || (this.isEdit && e && parentsUntil(e.target, 'e-gridform') &&
            parentsUntil(e.target, 'e-ddl') && e.action === 'open' && e.altKey === true && e.code === 'ArrowDown')) {
            e.stopImmediatePropagation();
        }
    }
    keyDownHandler(e) {
        if (e.altKey) {
            if (e.keyCode === 74) { //alt j
                if (this.keyA) { //alt A J
                    this.notify(events.groupCollapse, { target: e.target, collapse: false });
                    this.keyA = false;
                }
                else {
                    if (this.focusModule && this.focusModule.currentInfo && this.focusModule.currentInfo.element) {
                        removeClass([this.focusModule.currentInfo.element, this.focusModule.currentInfo.elementToFocus], ['e-focused', 'e-focus']);
                        this.focusModule.currentInfo.element.tabIndex = -1;
                    }
                    if (!this.element.classList.contains('e-childgrid')) {
                        this.element.focus();
                    }
                }
            }
            if (e.keyCode === 87) { //alt w
                const focusModule = this.focusModule;
                if (focusModule) {
                    if (!this.currentViewData.length) {
                        return;
                    }
                    if (this.element.getBoundingClientRect().width !== 0) {
                        focusModule.focusContent();
                    }
                    focusModule.addOutline();
                }
            }
            if (e.keyCode === 65) { //alt A
                this.keyA = true;
            }
            if (e.keyCode === 72 && this.keyA) { //alt A H
                this.notify(events.groupCollapse, { target: e.target, collapse: true });
                this.keyA = false;
            }
        }
        if (e.keyCode === 13) {
            this.notify(events.enterKeyHandler, e);
        }
    }
    keyActionHandler(e) {
        if (this.isChildGrid(e) ||
            (this.editModule && ((this.editModule.alertDObj && this.editModule.alertDObj.visible) ||
                (this.editModule.dialogObj && this.editModule.dialogObj.visible))) ||
            ((this.isEdit && (!this.editSettings.showAddNewRow || (this.editSettings.showAddNewRow &&
                this.element.querySelector(literals.editedRow)))) && e.action !== 'escape' && e.action !== 'enter'
                && e.action !== 'shiftEnter' && e.action !== 'tab' && e.action !== 'shiftTab')) {
            return;
        }
        else {
            this.keyPress = true;
        }
        if (this.allowKeyboard) {
            if (e.action === 'ctrlPlusP') {
                e.preventDefault();
                this.print();
            }
            this.notify(events.keyPressed, e);
        }
    }
    /**
     * @param {Function[]} modules - Defines the modules
     * @returns {void}
     * @hidden
     */
    setInjectedModules(modules) {
        this.injectedModules = modules;
    }
    updateColumnObject() {
        prepareColumns(this.columns, this.enableColumnVirtualization, this);
        setColumnIndex(this.columns);
        this.initForeignColumn();
        this.notify(events.autoCol, {});
    }
    refreshFrozenPosition(obj) {
        if (obj && obj.isModeChg) {
            this.refreshColumns();
            this.notify(events.refreshResizePosition, {});
        }
        else {
            this.refreshColumns();
        }
    }
    /**
     * Gets the foreign columns from Grid.
     *
     * @returns {Column[]} Returns Foreign key column
     */
    getForeignKeyColumns() {
        const cols = this.enableColumnVirtualization ? this.columns : this.getColumns();
        return cols.filter((col) => {
            return col instanceof Column && col.isForeignColumn();
        });
    }
    /**
     * @hidden
     * @param {boolean} accurateHeight - Defines the accurate row height
     * @returns {number} Returns row height
     */
    getRowHeight(accurateHeight) {
        return this.rowHeight ? this.rowHeight : getRowHeight(this.element, accurateHeight);
    }
    /**
     * Refreshes the Grid column changes.
     *
     * @returns {void}
     */
    refreshColumns() {
        this.freezeColumnRefresh = true;
        this.setFrozenCount();
        this.updateFrozenColumnsWidth();
        if (this.isFrozenGrid()) {
            this.isPreventScrollEvent = true;
        }
        this.updateColumnObject();
        this.checkLockColumns(this.getColumns());
        this.refresh();
        if (this.isFrozenGrid() && this.enableColumnVirtualization) {
            const left = this.getContent().querySelector('.e-movablescrollbar').scrollLeft;
            this.getHeaderContent().querySelector('.' + literals.headerContent).scrollLeft = left;
            this.getContent().querySelector('.' + literals.content).scrollLeft = left;
        }
    }
    /**
     * Export Grid data to Excel file(.xlsx).
     *
     * @param  {ExcelExportProperties} excelExportProperties - Defines the export properties of the Grid.
     * @param  {boolean} isMultipleExport - Define to enable multiple export.
     * @param  {Workbook} workbook - Defines the Workbook if multiple export is enabled.
     * @param  {boolean} isBlob - If 'isBlob' set to true, then it will be returned as blob data.
     * @returns {Promise<any>} Returns the excelexport
     */
    excelExport(excelExportProperties, isMultipleExport, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    workbook, isBlob) {
        if (this.exportGrids && this.exportGrids.length) {
            const gridIds = this.exportGrids.slice();
            return this.exportMultipleExcelGrids(gridIds, excelExportProperties, isMultipleExport, workbook, isBlob);
        }
        else {
            return this.excelExportModule ?
                this.excelExportModule.Map(this, excelExportProperties, isMultipleExport, workbook, false, isBlob) : null;
        }
    }
    /**
     * Export Grid data to CSV file.
     *
     * @param  {ExcelExportProperties} excelExportProperties - Defines the export properties of the Grid.
     * @param  {boolean} isMultipleExport - Define to enable multiple export.
     * @param  {Workbook} workbook - Defines the Workbook if multiple export is enabled.
     * @param  {boolean} isBlob - If 'isBlob' set to true, then it will be returned as blob data.
     * @returns {Promise<any>} Returns csv export
     */
    csvExport(excelExportProperties, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    isMultipleExport, workbook, isBlob) {
        return this.excelExportModule ?
            this.excelExportModule.Map(this, excelExportProperties, isMultipleExport, workbook, true, isBlob) : null;
    }
    /**
     * Export Grid data to PDF document.
     *
     * @param {pdfExportProperties} pdfExportProperties - Defines the export properties of the Grid.
     * @param {isMultipleExport} isMultipleExport - Define to enable multiple export.
     * @param {pdfDoc} pdfDoc - Defined the Pdf Document if multiple export is enabled.
     * @param {boolean} isBlob - If 'isBlob' set to true, then it will be returned as blob data.
     *
     * @returns {Promise<any>} Returns pdfexport
     */
    pdfExport(pdfExportProperties, isMultipleExport, pdfDoc, isBlob) {
        if (this.exportGrids && this.exportGrids.length) {
            const gridIds = this.exportGrids.slice();
            return this.exportMultiplePdfGrids(gridIds, pdfExportProperties, isMultipleExport, pdfDoc, isBlob);
        }
        else {
            return this.pdfExportModule ? this.pdfExportModule.Map(this, pdfExportProperties, isMultipleExport, pdfDoc, isBlob) : null;
        }
    }
    exportMultiplePdfGrids(gridIds, pdfExportProperties, isMultipleExport, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    pdfDoc, isBlob) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const _this = this;
        if (gridIds.length !== 0) {
            const currentGridId = gridIds.shift();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const currentGridInstance = document.getElementById(currentGridId).ej2_instances[0];
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const exportPromise = currentGridInstance.pdfExportModule ?
                currentGridInstance.pdfExportModule.Map(currentGridInstance, pdfExportProperties, isMultipleExport, pdfDoc, isBlob)
                : Promise.resolve();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return exportPromise.then(function (exportedGridResults) {
                isMultipleExport = gridIds.length === 1 ? false : true;
                return _this.exportMultiplePdfGrids(gridIds, pdfExportProperties, isMultipleExport, exportedGridResults, isBlob);
            });
        }
        return null;
    }
    exportMultipleExcelGrids(gridIds, excelExportProperties, isMultipleExport, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    workbook, isBlob) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const _this = this;
        if (gridIds.length !== 0) {
            const currentGridId = gridIds.shift();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const currentGridInstance = document.getElementById(currentGridId).ej2_instances[0];
            const exportPromise = currentGridInstance.excelExportModule ?
                currentGridInstance.excelExportModule.Map(currentGridInstance, excelExportProperties, isMultipleExport, workbook, false, isBlob) : null;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return exportPromise.then(function (exportedGridResults) {
                isMultipleExport = gridIds.length === 1 ? false : true;
                return _this.exportMultipleExcelGrids(gridIds, excelExportProperties, isMultipleExport, exportedGridResults, isBlob);
            });
        }
        return null;
    }
    /**
     * Groups a column by column name.
     *
     * @param  {string} columnName - Defines the column name to group.
     *
     * @returns {void}
     */
    groupColumn(columnName) {
        if (this.groupModule) {
            this.groupModule.groupColumn(columnName);
        }
    }
    /**
     * Expands all the grouped rows of the Grid.
     *
     * @returns {void}
     */
    groupExpandAll() {
        if (this.groupModule) {
            this.groupModule.expandAll();
        }
    }
    /**
     * Collapses all the grouped rows of the Grid.
     *
     * @returns {void}
     */
    groupCollapseAll() {
        if (this.groupModule) {
            this.groupModule.collapseAll();
        }
    }
    /**
     * Expands or collapses grouped rows by target element.
     *
     * @param  {Element} target - Defines the target element of the grouped row.
     * @returns {void}
     */
    // public expandCollapseRows(target: Element): void {
    //     if (this.groupModule) {
    //         this.groupModule.expandCollapseRows(target);
    //     }
    // }
    /**
     * Clears all the grouped columns of the Grid.
     *
     * @returns {void}
     */
    clearGrouping() {
        if (this.groupModule) {
            this.groupModule.clearGrouping();
        }
    }
    /**
     * Ungroups a column by column name.
     *
     * {% codeBlock src='grid/ungroupColumn/index.md' %}{% endcodeBlock %}
     *
     * @param  {string} columnName - Defines the column name to ungroup.
     *
     * @returns {void}
     */
    ungroupColumn(columnName) {
        if (this.groupModule) {
            this.groupModule.ungroupColumn(columnName);
        }
    }
    /**
     * Column chooser can be displayed on screen by given position(X and Y axis).
     *
     * @param {number} x - Defines the X axis.
     * @param {number} y - Defines the Y axis.
     *
     * @returns {void}
     */
    openColumnChooser(x, y) {
        if (this.columnChooserModule) {
            this.columnChooserModule.openColumnChooser(x, y);
        }
    }
    scrollRefresh() {
        const refresh = () => {
            this.scrollModule.refresh();
            this.off(events.contentReady, refresh);
        };
        this.on(events.contentReady, refresh, this);
    }
    /**
     * Collapses a detail row with the given target.
     *
     * @param  {Element} target - Defines the expanded element to collapse.
     * @returns {void}
     */
    // public detailCollapse(target: number | Element): void {
    //     if (this.detailRowModule) {
    //         this.detailRowModule.collapse(target);
    //     }
    // }
    /**
     * Collapses all the detail rows of the Grid.
     *
     * @returns {void}
     */
    detailCollapseAll() {
        if (this.detailRowModule) {
            this.detailRowModule.collapseAll();
        }
    }
    /**
     * Expands a detail row with the given target.
     *
     * @param  {Element} target - Defines the collapsed element to expand.
     * @returns {void}
     */
    // public detailExpand(target: number | Element): void {
    //     if (this.detailRowModule) {
    //         this.detailRowModule.expand(target);
    //     }
    // }
    /**
     * Expands all the detail rows of the Grid.
     *
     * @returns {void}
     */
    detailExpandAll() {
        if (this.detailRowModule) {
            this.detailRowModule.expandAll();
        }
    }
    /**
     * Deselects the currently selected cells.
     *
     * @returns {void}
     */
    clearCellSelection() {
        if (this.selectionModule) {
            this.selectionModule.clearCellSelection();
        }
    }
    /**
     * Deselects the currently selected rows.
     *
     * @returns {void}
     */
    clearRowSelection() {
        if (this.selectionModule) {
            this.selectionModule.clearRowSelection();
        }
    }
    /**
     * Selects a collection of cells by row and column indexes.
     *
     * @param  {ISelectedCell[]} rowCellIndexes - Specifies the row and column indexes.
     *
     * @returns {void}
     */
    selectCells(rowCellIndexes) {
        if (this.selectionModule) {
            this.selectionModule.selectCells(rowCellIndexes);
        }
    }
    /**
     * Selects a range of rows from start and end row indexes.
     *
     * @param  {number} startIndex - Specifies the start row index.
     * @param  {number} endIndex - Specifies the end row index.
     *
     * @returns {void}
     */
    selectRowsByRange(startIndex, endIndex) {
        if (this.selectionModule) {
            this.selectionModule.selectRowsByRange(startIndex, endIndex);
        }
    }
    /**
     * @hidden
     * @returns {boolean} Returns whether context menu is open or not
     */
    isContextMenuOpen() {
        return this.contextMenuModule && this.contextMenuModule.isOpen;
    }
    /**
     * @param {Function} module - Defines the module
     * @returns {boolean} return the injected modules
     * @hidden
     */
    ensureModuleInjected(module) {
        return this.getInjectedModules().indexOf(module) >= 0;
    }
    /**
     * Destroys the given template reference.
     *
     * @param {string[]} propertyNames - Defines the collection of template name.
     * @param {any} index - specifies the index
     * @param {Function} callback - Defines the callback function that is triggered after the template is cleared
     *
     * @returns {void}
     */
    // eslint-disable-next-line
    destroyTemplate(propertyNames, index, callback) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.clearTemplate(propertyNames, index, callback);
    }
    /**
     * @param {string | string[]} type - Defines the type
     * @param {Object} args - Defines the arguments
     * @returns {void}
     * @hidden
     * @private
     */
    log(type, args) {
        const injectedModules = this.getInjectedModules();
        const logger = injectedModules.find((item) => item.name === 'Logger');
        if (!logger) {
            Grid_1.Inject(Logger);
            this.enableLogger = true;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.injectModules();
        }
        // eslint-disable-next-line
        this.loggerModule ? this.loggerModule.log(type, args) : (() => 0)();
    }
    /**
     * @param {Element} element - Defines the element
     * @returns {void}
     * @hidden
     */
    applyBiggerTheme(element) {
        if (this.element.classList.contains('e-bigger')) {
            element.classList.add('e-bigger');
        }
    }
    /**
     * @hidden
     * @returns {Object} Returns the previous row data
     */
    getPreviousRowData() {
        const previousRowData = this.getRowsObject()[this.getRows().length - 1].data;
        return previousRowData;
    }
    /**
     * Hides the scrollbar placeholder of Grid content when grid content is not overflown.
     *
     * @returns {void}
     */
    hideScroll() {
        const content = this.getContent().querySelector('.' + literals.content);
        if (content.scrollHeight <= content.clientHeight) {
            this.scrollModule.removePadding();
            content.style.overflowY = 'auto';
        }
    }
    /**
     * Get row index by primary key or row data.
     *
     * @param  {string | Object} value - Defines the primary key value.
     *
     * @returns {number} Returns the index
     */
    getRowIndexByPrimaryKey(value) {
        const pkName = this.getPrimaryKeyFieldNames()[0];
        value = typeof value === 'object' ? value[`${pkName}`] : value;
        const rows = this.getRowsObject();
        for (let i = 0; i < rows.length; i++) {
            if (rows[parseInt(i.toString(), 10)].isDetailRow || rows[parseInt(i.toString(), 10)].isCaptionRow) {
                continue;
            }
            let pKvalue = rows[parseInt(i.toString(), 10)].data[`${pkName}`];
            if (pkName.split('.').length > 1) {
                pKvalue = performComplexDataOperation(pkName, rows[parseInt(i.toString(), 10)].data);
            }
            if (pKvalue === value) {
                return rows[parseInt(i.toString(), 10)].index;
            }
        }
        return -1;
    }
    /**
     * Get row index by primary key or row data.
     *
     * @param  {string | Object} value - Defines the primary key value.
     *
     * @returns {number} Returns the row object
     * @hidden
     */
    getPinnedRowObjectByKey(value) {
        const primarykey = this.getPrimaryKeyFieldNames()[0];
        value = typeof value === 'object' ? value[`${primarykey}`] : value;
        const rows = this.pinnedTopRowModels;
        for (let i = 0; i < rows.length; i++) {
            if (rows[parseInt(i.toString(), 10)].isDetailRow || rows[parseInt(i.toString(), 10)].isCaptionRow) {
                continue;
            }
            let primarykeyValue = rows[parseInt(i.toString(), 10)].data[`${primarykey}`];
            if (primarykey.split('.').length > 1) {
                primarykeyValue = performComplexDataOperation(primarykey, rows[parseInt(i.toString(), 10)].data);
            }
            if (primarykeyValue === value) {
                return rows[parseInt(i.toString(), 10)];
            }
        }
        return null;
    }
    /**
     * @param {string} field - Defines the field name
     * @param {boolean} isForeignKey - Defines the foreign key
     * @returns {Column} returns the column
     * @hidden
     */
    // Need to have all columns while filtering with ColumnVirtualization.
    grabColumnByFieldFromAllCols(field, isForeignKey) {
        let column;
        this.columnModel = [];
        this.updateColumnModel(this.columns);
        const gCols = this.columnModel;
        for (let i = 0; i < gCols.length; i++) {
            if ((!isForeignKey && field === gCols[parseInt(i.toString(), 10)].field) ||
                (isForeignKey && gCols[parseInt(i.toString(), 10)].isForeignColumn() &&
                    field === gCols[parseInt(i.toString(), 10)].foreignKeyValue)) {
                column = gCols[parseInt(i.toString(), 10)];
                break;
            }
        }
        return column;
    }
    /**
     * @param {string} uid - Defines the uid
     * @returns {Column} returns the column
     * @hidden
     */
    // Need to have all columns while filtering with ColumnVirtualization.
    grabColumnByUidFromAllCols(uid) {
        let column;
        this.columnModel = [];
        this.updateColumnModel(this.columns);
        const gCols = this.columnModel;
        for (let i = 0; i < gCols.length; i++) {
            if (uid === gCols[parseInt(i.toString(), 10)].uid) {
                column = gCols[parseInt(i.toString(), 10)];
            }
        }
        return column;
    }
    /**
     * Get all filtered records from the Grid and it returns array of objects for the local dataSource, returns a promise object if the Grid has remote data.
     *
     * @returns {Object[] | Promise<Object>} Returns the filtered records
     */
    getFilteredRecords() {
        if ((this.allowFiltering && this.filterSettings.columns.length) || this.searchSettings.key.length) {
            const query = this.renderModule.data.generateQuery(true);
            if (this.dataSource && this.renderModule.data.isRemote() && this.dataSource instanceof DataManager) {
                return this.renderModule.data.getData(this.dataSource, query);
            }
            else {
                if (this.dataSource instanceof DataManager) {
                    return this.dataSource.executeLocal(query);
                }
                else {
                    return new DataManager(this.dataSource, query).executeLocal(query);
                }
            }
        }
        return [];
    }
    getUserAgent() {
        const userAgent = Browser.userAgent.toLowerCase();
        return /iphone|ipod|ipad|macintosh/.test(userAgent);
    }
    /**
     * @param {TouchEventArgs} e - Defines the TouchEventArgs
     * @returns {void}
     * @hidden
     */
    // Need to have all columns while filtering with ColumnVirtualization.
    // eslint-disable-next-line
    tapEvent(e) {
        if (this.getUserAgent()) {
            if (!Global.timer) {
                Global.timer = setTimeout(() => {
                    Global.timer = null;
                }, 300);
            }
            else {
                clearTimeout(Global.timer);
                Global.timer = null;
                this.dblClickHandler(e);
                this.notify(events.doubleTap, e);
            }
        }
    }
    /**
     * @param {string} prefix - specifies the prefix
     * @returns {string} returns the row uid
     * @hidden
     */
    getRowUid(prefix) {
        return `${prefix}${this.rowUid++}`;
    }
    /**
     * @param {string} uid - specifies the uid
     * @returns {Element} returns the element
     * @hidden
     */
    getRowElementByUID(uid) {
        let rowEle;
        let rows = [];
        const cntRows = [].slice.call(this.getContent().querySelector(literals.tbody).children);
        if (this.frozenRows || this.pinnedTopRowModels.length) {
            rows = [].slice.call(this.getHeaderContent().querySelector(literals.tbody).children);
            rows = rows.concat(cntRows);
        }
        else {
            rows = cntRows;
        }
        for (const row of rows) {
            if (row.getAttribute('data-uid') === uid) {
                rowEle = row;
                break;
            }
        }
        return rowEle;
    }
    /**
     * Gets the hidden columns from the Grid.
     *
     * @returns {Column[]} Returns the Column
     */
    getHiddenColumns() {
        const cols = [];
        for (const col of this.columnModel) {
            if (col.visible === false) {
                cols.push(col);
            }
        }
        return cols;
    }
    /**
     * Calculates the page size by parent element height
     *
     * @param {number | string } containerHeight - specifies the container height
     * @returns {number} returns the page size
     */
    calculatePageSizeByParentHeight(containerHeight) {
        if (this.allowPaging) {
            if ((this.allowTextWrap && this.textWrapSettings.wrapMode === 'Header') || (!this.allowTextWrap)) {
                let pagesize = 0;
                if (typeof containerHeight === 'string' && containerHeight.indexOf('%') !== -1) {
                    containerHeight = parseInt(containerHeight, 10) / 100 * this.element.clientHeight;
                }
                const nonContentHeight = this.getNoncontentHeight() + this.getRowHeight();
                if (containerHeight > nonContentHeight) {
                    let contentHeight = 0;
                    contentHeight = containerHeight - this.getNoncontentHeight();
                    pagesize = (contentHeight / this.getRowHeight());
                }
                if (pagesize > 0) {
                    return Math.floor(pagesize);
                }
            }
        }
        return 0;
    }
    getNoncontentHeight() {
        let height = 0;
        if (this.getHeaderContent() && !isNullOrUndefined(this.getHeaderContent().clientHeight)) {
            height += this.getHeaderContent().clientHeight;
        }
        if (this.toolbar && !isNullOrUndefined(this.element.querySelector('.e-toolbar').clientHeight)) {
            height += this.element.querySelector('.e-toolbar').clientHeight;
        }
        if (this.allowPaging && !isNullOrUndefined(this.element.querySelector('.e-gridpager').clientHeight)) {
            height += this.element.querySelector('.e-gridpager').clientHeight;
        }
        if (this.showColumnChooser && !isNullOrUndefined(this.element.querySelector('.e-columnheader').clientHeight)) {
            height += this.element.querySelector('.e-columnheader').clientHeight;
        }
        if (this.allowGrouping && this.groupSettings.showDropArea && !isNullOrUndefined(this.element.querySelector('.e-groupdroparea').clientHeight)) {
            height += this.element.querySelector('.e-groupdroparea').clientHeight;
        }
        if (this.aggregates.length > 0 && !isNullOrUndefined(this.element.querySelector('.e-summaryrow').clientHeight)) {
            for (let i = 0; i < this.element.getElementsByClassName('e-summaryrow').length; i++) {
                height += this.element.getElementsByClassName('e-summaryrow')[parseInt(i.toString(), 10)].clientHeight;
            }
        }
        return height;
    }
    /**
     *To perform aggregate operation on a column.
     *
     * @param  {AggregateColumnModel} summaryCol - Pass Aggregate Column details.
     * @param  {Object} summaryData - Pass JSON Array for which its field values to be calculated.
     *
     * @returns {number} returns the summary values
     */
    getSummaryValues(summaryCol, summaryData) {
        return DataUtil.aggregates[summaryCol.type.toLowerCase()](summaryData, summaryCol.field);
    }
    /**
     * Sends a Post request to export Grid to Excel file in server side.
     *
     * @param  {string} url - Pass Url for server side excel export action.
     *
     * @param  {ExportHeaders} headers - The headers to include in the export request.
     *
     * @returns {void}
     */
    serverExcelExport(url, headers) {
        this.isExcel = true;
        this.exportGrid(url, headers);
    }
    /**
     * Sends a Post request to export Grid to Pdf file in server side.
     *
     * @param  {string} url - Pass Url for server side pdf export action.
     *
     * @param  {ExportHeaders} headers - The headers to include in the export request.
     *
     * @returns {void}
     */
    serverPdfExport(url, headers) {
        this.isExcel = false;
        this.exportGrid(url, headers);
    }
    /**
     * Sends a Post request to export Grid to CSV file in server side.
     *
     * @param  {string} url - Pass Url for server side csv export action.
     *
     * @param  {ExportHeaders} headers - The headers to include in the export request.
     *
     * @returns {void}
     */
    serverCsvExport(url, headers) {
        this.isExcel = true;
        this.exportGrid(url, headers);
    }
    /**
     * @param {string} url - Defines exporting url
     * @param {ExportHeaders} headers - The optional headers for the export request.
     * @returns {void}
     * @hidden
     */
    exportGrid(url, headers) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const grid = this;
        const query = grid.getDataModule().generateQuery(true);
        const state = new UrlAdaptor().processQuery(new DataManager({ url: '' }), query);
        const queries = JSON.parse(state.data);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const gridModel = JSON.parse(this.addOnPersist(['allowGrouping', 'allowPaging', 'pageSettings', 'sortSettings', 'allowPdfExport', 'allowExcelExport', 'aggregates',
            'filterSettings', 'groupSettings', 'columns', 'locale', 'searchSettings']));
        const include = ['field', 'headerText', 'type', 'format', 'visible', 'foreignKeyValue', 'foreignKeyField',
            'template', 'index', 'width', 'textAlign', 'headerTextAlign', 'columns'];
        gridModel.filterSettings.columns = queries.where;
        gridModel.searchSettings.fields = queries.search && queries.search[0]['fields'] || [];
        gridModel.sortSettings.columns = queries.sorted;
        gridModel.columns = this.setHeaderText(gridModel.columns, include);
        const form = this.createElement('form', { id: 'ExportForm' });
        form.style.display = 'none';
        const gridInput = this.createElement('input', { id: 'gridInput', attrs: { name: 'gridModel' } });
        gridInput.value = JSON.stringify(gridModel);
        form.method = 'POST';
        form.action = url;
        form.appendChild(gridInput);
        if (headers && headers.headers && Array.isArray(headers.headers)) {
            headers.headers.forEach((header) => {
                Object.keys(header).forEach((key) => {
                    const value = typeof header[`${key}`] === 'string' ? header[`${key}`] : JSON.stringify(header[`${key}`]);
                    const headerInput = this.createElement('input', { attrs: { name: key, value: value, type: 'hidden' } });
                    form.appendChild(headerInput);
                });
            });
        }
        document.body.appendChild(form);
        form.submit();
        form.remove();
    }
    /**
     * @param {Column[]} columns - Defines array of columns
     * @param {string[]} include - Defines array of sting
     * @returns {Column[]} returns array of columns
     * @hidden
     */
    setHeaderText(columns, include) {
        for (let i = 0; i < columns.length; i++) {
            const column = this.getColumnByUid(columns[parseInt(i.toString(), 10)].uid);
            columns[parseInt(i.toString(), 10)].headerText = column.headerText;
            if (!isNullOrUndefined(column.template)) {
                columns[parseInt(i.toString(), 10)].template = 'true';
            }
            if (columns[parseInt(i.toString(), 10)].format) {
                columns[parseInt(i.toString(), 10)].format = getNumberFormat(this.getFormat(columns[parseInt(i.toString(), 10)].format), columns[parseInt(i.toString(), 10)].type, false, defaultCurrencyCode);
                if (column.type === 'datetime' || column.type === 'date' || column.type === 'time') {
                    columns[parseInt(i.toString(), 10)].format = columns[parseInt(i.toString(), 10)].format.toString().replace('AM/PM', 'tt');
                }
            }
            if (columns[parseInt(i.toString(), 10)].columns) {
                this.setHeaderText(columns[parseInt(i.toString(), 10)].columns, include);
            }
            const keys = Object.keys(columns[parseInt(i.toString(), 10)]);
            for (let j = 0; j < keys.length; j++) {
                if (include.indexOf(keys[parseInt(j.toString(), 10)]) < 0) {
                    delete columns[parseInt(i.toString(), 10)][keys[parseInt(j.toString(), 10)]];
                }
            }
        }
        return columns;
    }
    getFormat(format) {
        return typeof (format) === 'object' ? !isNullOrUndefined(format.format) ?
            format.format : format.skeleton : format;
    }
    /**
     * @hidden
     * @returns {boolean} returns the isCollapseStateEnabled
     */
    isCollapseStateEnabled() {
        const isExpanded = 'isExpanded';
        return this[`${isExpanded}`] === false;
    }
    /**
     * @param {number} key - Defines the primary key value.
     * @param {Object} rowData - Defines the rowData
     * @returns {void}
     */
    updateRowValue(key, rowData) {
        const args = {
            requestType: 'save', data: rowData
        };
        this.showSpinner();
        this.notify(events.updateData, args);
        this.refresh();
    }
    /**
     * @hidden
     * @returns {void}
     */
    setForeignKeyData() {
        this.dataBind();
        const colpending = this.getDataModule().getForeignKeyDataState();
        if (colpending.isPending) {
            this.getDataModule().setForeignKeyDataState({});
            colpending.resolver();
        }
        else {
            this.getDataModule().setForeignKeyDataState({ isDataChanged: false });
            if (this.contentModule || this.headerModule) {
                this.renderModule.render();
            }
        }
    }
    /**
     * @param {string} field - specifies the field
     * @returns {void}
     * @hidden
     */
    resetFilterDlgPosition(field) {
        const header = this.getColumnHeaderByField(field);
        if (header) {
            const target = header.querySelector('.e-filtermenudiv');
            const filterDlg = this.element.querySelector('.e-filter-popup');
            if (target) {
                const gClient = this.element.getBoundingClientRect();
                const fClient = target.getBoundingClientRect();
                if (filterDlg) {
                    if ((filterDlg.offsetWidth + fClient.right) > gClient.right) {
                        filterDlg.style.left = ((fClient.right - filterDlg.offsetWidth) - gClient.left).toString() + 'px';
                    }
                    else {
                        filterDlg.style.left = (fClient.right - gClient.left).toString() + 'px';
                    }
                }
            }
        }
    }
    /**
     * @param {any} callBack - specifies the callBack method
     * @returns {void}
     * @hidden
     */
    // eslint-disable-next-line
    renderTemplates(callBack) {
        const isReactChild = this.parentDetails && this.parentDetails.parentInstObj && this.parentDetails.parentInstObj.isReact;
        const isReactPrintGrid = this.printGridParent && this.printGridParent.isReact;
        if ((isReactChild || isReactPrintGrid) && this['portals']) {
            const parentInstObj = isReactPrintGrid ? this.printGridParent : this.parentDetails.parentInstObj;
            parentInstObj['portals'] = parentInstObj['portals'].concat(this['portals']);
            parentInstObj.renderTemplates(callBack);
            this['portals'] = undefined;
        }
        else {
            const portals = 'portals';
            this.notify('reactTemplateRender', this[`${portals}`]);
            this.renderReactTemplates(callBack);
        }
    }
    /**
     * Apply the changes to the Grid without refreshing the rows.
     *
     * @param  {BatchChanges} changes - Defines changes to be updated.
     * @returns {void}
     */
    batchUpdate(changes) {
        this.processRowChanges(changes);
    }
    /**
     * Apply the changes to the Grid in one batch after 50ms without refreshing the rows.
     *
     * @param  {BatchChanges} changes - Defines changes to be updated.
     * @returns {void}
     */
    batchAsyncUpdate(changes) {
        this.processBulkRowChanges(changes);
    }
    processBulkRowChanges(changes) {
        if (!this.dataToBeUpdated) {
            this.dataToBeUpdated = Object.assign({ addedRecords: [], changedRecords: [], deletedRecords: [] }, changes);
            setTimeout(() => {
                this.processRowChanges(this.dataToBeUpdated);
                this.dataToBeUpdated = null;
            }, this.asyncTimeOut);
        }
        else {
            const loopstring = [literals.addedRecords, literals.changedRecords, literals.deletedRecords];
            const keyField = this.getPrimaryKeyFieldNames()[0];
            for (let i = 0; i < loopstring.length; i++) {
                if (changes[loopstring[parseInt(i.toString(), 10)]]) {
                    compareChanges(this, changes, loopstring[parseInt(i.toString(), 10)], keyField);
                }
            }
        }
    }
    processRowChanges(changes) {
        const keyField = this.getPrimaryKeyFieldNames()[0];
        changes = Object.assign({ addedRecords: [], changedRecords: [], deletedRecords: [] }, changes);
        const promise = this.getDataModule().saveChanges(changes, keyField, {}, this.getDataModule().generateQuery().requiresCount());
        if (this.getDataModule().isRemote()) {
            promise.then(() => {
                this.setNewData();
            });
        }
        else {
            this.setNewData();
        }
    }
    setNewData() {
        const oldValues = JSON.parse(JSON.stringify(this.getCurrentViewRecords()));
        const getData = this.getDataModule().getData({}, this.getDataModule().generateQuery().requiresCount());
        getData.then((e) => {
            this.bulkRefresh(e.result, oldValues, e.count);
        });
    }
    deleteRowElement(row) {
        const tr = this.getRowElementByUID(row.uid);
        remove(tr);
    }
    bulkRefresh(result, oldValues, count) {
        const rowObj = this.getRowsObject();
        const keyField = this.getPrimaryKeyFieldNames()[0];
        for (let i = 0; i < rowObj.length; i++) {
            if (!result.filter((e) => { return e[`${keyField}`] === rowObj[parseInt(i.toString(), 10)].data[`${keyField}`]; }).length) {
                this.deleteRowElement(rowObj[parseInt(i.toString(), 10)]);
                rowObj.splice(i, 1);
                i--;
            }
        }
        for (let i = 0; i < result.length; i++) {
            let isRowExist;
            oldValues.filter((e) => {
                if (e[`${keyField}`] === result[parseInt(i.toString(), 10)][`${keyField}`]) {
                    if (e !== result[parseInt(i.toString(), 10)]) {
                        this.setRowData(result[parseInt(i.toString(), 10)][`${keyField}`], result[parseInt(i.toString(), 10)]);
                    }
                    isRowExist = true;
                }
            });
            if (!isRowExist) {
                this.renderRowElement(result[parseInt(i.toString(), 10)], i);
            }
        }
        this.currentViewData = result;
        const rows = [].slice.call(this.getContentTable().getElementsByClassName(literals.row));
        resetRowIndex(this, this.getRowsObject(), rows);
        setRowElements(this);
        if (this.allowPaging) {
            this.notify(events.inBoundModelChanged, { module: 'pager', properties: { totalRecordsCount: count } });
        }
    }
    renderRowElement(data, index) {
        const row = new RowRenderer(this.serviceLocator, null, this);
        const model = new RowModelGenerator(this);
        const modelData = model.generateRows([data]);
        const tr = row.render(modelData[0], this.getColumns());
        this.addRowObject(modelData[0], index);
        let tbody = this.getContentTable().querySelector(literals.tbody);
        if (tbody.querySelector('.e-emptyrow')) {
            const emptyRow = tbody.querySelector('.e-emptyrow');
            emptyRow.parentNode.removeChild(emptyRow);
            if (this.frozenRows && this.element.querySelector('.e-frozenrow-empty')) {
                this.element.querySelector('.e-frozenrow-empty').classList.remove('e-frozenrow-empty');
            }
        }
        if (this.frozenRows && index < this.frozenRows) {
            tbody = this.getHeaderContent().querySelector(literals.tbody);
        }
        else {
            tbody = this.getContent().querySelector(literals.tbody);
        }
        tbody = this.getContent().querySelector(literals.tbody);
        tbody.appendChild(tr);
    }
    addRowObject(row, index) {
        this.getRowsObject().splice(index, 1, row);
    }
    /**
     * @hidden
     * @returns {void}
     */
    updateVisibleExpandCollapseRows() {
        const rows = this.getRowsObject();
        for (let i = 0, len = rows.length; i < len; i++) {
            if ((rows[parseInt(i.toString(), 10)].isDataRow || rows[parseInt(i.toString(), 10)].isAggregateRow)
                && this.getRowElementByUID(rows[parseInt(i.toString(), 10)].uid)
                && this.getRowElementByUID(rows[parseInt(i.toString(), 10)].uid).style.display === 'none') {
                rows[parseInt(i.toString(), 10)].visible = false;
            }
            else {
                rows[parseInt(i.toString(), 10)].visible = true;
            }
        }
    }
    /**
     * Method to sanitize any suspected untrusted strings and scripts before rendering them.
     *
     * @param {string} value - Specifies the html value to sanitize
     * @returns {string} Returns the sanitized html string
     * @hidden
     */
    sanitize(value) {
        if (this.enableHtmlSanitizer) {
            return SanitizeHtmlHelper.sanitize(value);
        }
        return value;
    }
    /**
     * @param {string | number} height - specifies the height
     * @returns {number | string} - specifies the height number
     * @hidden
     */
    getHeight(height) {
        if (!Number.isInteger(height) && height.indexOf('%') !== -1) {
            height = parseInt(height, 10) / 100 * this.element.clientHeight;
        }
        else if (!Number.isInteger(height) && this.height !== 'auto') {
            height = parseInt(height, 10);
        }
        else {
            height = this.height;
        }
        return height;
    }
    /**
     * @hidden
     * @returns {Element} - returns frozen right content
     * @deprecated This method is deprecated. Use `getContent()` method instead.
     */
    getFrozenRightContent() {
        return this.contentModule.getPanel();
    }
    /**
     * @hidden
     * @returns {Element} - returns frozen right header
     * @deprecated This method is deprecated. Use `getHeaderContent()` method instead.
     */
    getFrozenRightHeader() {
        return this.headerModule.getPanel();
    }
    /**
     * @hidden
     * @returns {Element} - returns movable header tbody
     * @deprecated This method is deprecated. Use `getHeaderContent().querySelector('tbody')` method instead.
     */
    getMovableHeaderTbody() {
        return this.getHeaderContent().querySelector(literals.tbody);
    }
    /**
     * @hidden
     * @returns {Element} - returns movable content tbody
     * @deprecated This method is deprecated. Use `getContent().querySelector('tbody')` method instead.
     */
    getMovableContentTbody() {
        return this.getContent().querySelector(literals.tbody);
    }
    /**
     * @hidden
     * @returns {Element} - returns frozen header tbody
     * @deprecated This method is deprecated. Use `getHeaderContent().querySelector('tbody')` method instead.
     */
    getFrozenHeaderTbody() {
        return this.getHeaderContent().querySelector(literals.tbody);
    }
    /**
     * @hidden
     * @returns {Element} - returns frozen left content tbody
     * @deprecated This method is deprecated. Use `getContent().querySelector('tbody')` method instead.
     */
    getFrozenLeftContentTbody() {
        return this.getContent().querySelector(literals.tbody);
    }
    /**
     * @hidden
     * @returns {Element} - returns frozen right header tbody
     * @deprecated This method is deprecated. Use `getHeaderContent().querySelector('tbody')` method instead.
     */
    getFrozenRightHeaderTbody() {
        return this.getHeaderContent().querySelector(literals.tbody);
    }
    /**
     * @returns {Element} returns frozen right content tbody
     * @deprecated This method is deprecated. Use `getContent().querySelector('tbody')` method instead.
     * @hidden
     */
    getFrozenRightContentTbody() {
        return this.getContent().querySelector(literals.tbody);
    }
    /**
     * @param {boolean} isCustom - Defines custom filter dialog open
     * @returns {void}
     * @hidden
     */
    showResponsiveCustomFilter(isCustom) {
        if (this.filterModule) {
            this.filterModule.showCustomFilter(isCustom || this.rowRenderingMode === 'Vertical');
        }
    }
    /**
     * @param {boolean} isCustom - Defines custom sort dialog open
     * @returns {void}
     * @hidden
     */
    showResponsiveCustomSort(isCustom) {
        if (this.sortModule) {
            this.sortModule.showCustomSort(isCustom || this.rowRenderingMode === 'Vertical');
        }
    }
    /**
     * @param {boolean} isCustom - Defines custom column chooser dialog open
     * @returns {void}
     * @hidden
     */
    showResponsiveCustomColumnChooser(isCustom) {
        if (this.columnChooserModule) {
            this.columnChooserModule.showCustomColumnChooser(isCustom || this.rowRenderingMode === 'Vertical');
        }
    }
    /**
     * To manually show the vertical row mode filter dialog
     *
     * @returns {void}
     */
    showAdaptiveFilterDialog() {
        if (this.enableAdaptiveUI) {
            this.showResponsiveCustomFilter(true);
        }
    }
    /**
     * To manually show the vertical row sort filter dialog
     *
     * @returns {void}
     */
    showAdaptiveSortDialog() {
        if (this.enableAdaptiveUI) {
            this.showResponsiveCustomSort(true);
        }
    }
    /**
     * @param {boolean} isColVirtualization - Defines column virtualization
     * @returns {Column[]} returns array of column models
     * @hidden
     */
    getCurrentVisibleColumns(isColVirtualization) {
        const cols = [];
        const gridCols = isColVirtualization ? this.getColumns() : this.columnModel;
        for (const col of gridCols) {
            if (col.visible) {
                cols.push(col);
            }
        }
        return cols;
    }
    enableInfiniteAggrgate() {
        if (this.enableInfiniteScrolling && this.groupSettings.columns.length && !this.groupSettings.disablePageWiseAggregates
            && !this.groupSettings.enableLazyLoading) {
            this.setProperties({ groupSettings: { disablePageWiseAggregates: true } }, true);
        }
    }
};
__decorate([
    Property([])
], Grid.prototype, "currentViewData", void 0);
__decorate([
    Property()
], Grid.prototype, "parentDetails", void 0);
__decorate([
    Property()
], Grid.prototype, "showHider", void 0);
__decorate([
    Property([])
], Grid.prototype, "columns", void 0);
__decorate([
    Property(true)
], Grid.prototype, "enableAltRow", void 0);
__decorate([
    Property(true)
], Grid.prototype, "enableHover", void 0);
__decorate([
    Property(false)
], Grid.prototype, "enableAutoFill", void 0);
__decorate([
    Property(true)
], Grid.prototype, "allowKeyboard", void 0);
__decorate([
    Property(false)
], Grid.prototype, "enableStickyHeader", void 0);
__decorate([
    Property(false)
], Grid.prototype, "enableHtmlSanitizer", void 0);
__decorate([
    Property(false)
], Grid.prototype, "allowTextWrap", void 0);
__decorate([
    Complex({}, TextWrapSettings)
], Grid.prototype, "textWrapSettings", void 0);
__decorate([
    Complex({}, ResizeSettings)
], Grid.prototype, "resizeSettings", void 0);
__decorate([
    Property(false)
], Grid.prototype, "allowPaging", void 0);
__decorate([
    Complex({}, PageSettings)
], Grid.prototype, "pageSettings", void 0);
__decorate([
    Complex({}, LoadingIndicator)
], Grid.prototype, "loadingIndicator", void 0);
__decorate([
    Property(true)
], Grid.prototype, "enableVirtualMaskRow", void 0);
__decorate([
    Property(false)
], Grid.prototype, "enableVirtualization", void 0);
__decorate([
    Property(false)
], Grid.prototype, "enableColumnVirtualization", void 0);
__decorate([
    Property(false)
], Grid.prototype, "enableInfiniteScrolling", void 0);
__decorate([
    Complex({}, SearchSettings)
], Grid.prototype, "searchSettings", void 0);
__decorate([
    Property(false)
], Grid.prototype, "allowSorting", void 0);
__decorate([
    Property('Ellipsis')
], Grid.prototype, "clipMode", void 0);
__decorate([
    Property(true)
], Grid.prototype, "allowMultiSorting", void 0);
__decorate([
    Property(false)
], Grid.prototype, "allowExcelExport", void 0);
__decorate([
    Property(false)
], Grid.prototype, "allowPdfExport", void 0);
__decorate([
    Complex({}, SortSettings)
], Grid.prototype, "sortSettings", void 0);
__decorate([
    Complex({}, InfiniteScrollSettings)
], Grid.prototype, "infiniteScrollSettings", void 0);
__decorate([
    Property(true)
], Grid.prototype, "allowSelection", void 0);
__decorate([
    Property(-1)
], Grid.prototype, "selectedRowIndex", void 0);
__decorate([
    Complex({}, SelectionSettings)
], Grid.prototype, "selectionSettings", void 0);
__decorate([
    Property(false)
], Grid.prototype, "allowFiltering", void 0);
__decorate([
    Property('Horizontal')
], Grid.prototype, "rowRenderingMode", void 0);
__decorate([
    Property(false)
], Grid.prototype, "enableAdaptiveUI", void 0);
__decorate([
    Property('Both')
], Grid.prototype, "adaptiveUIMode", void 0);
__decorate([
    Property(false)
], Grid.prototype, "allowReordering", void 0);
__decorate([
    Property(false)
], Grid.prototype, "enableRowSpan", void 0);
__decorate([
    Property(false)
], Grid.prototype, "enableColumnSpan", void 0);
__decorate([
    Property(false)
], Grid.prototype, "allowResizing", void 0);
__decorate([
    Property(false)
], Grid.prototype, "allowRowDragAndDrop", void 0);
__decorate([
    Complex({}, RowDropSettings)
], Grid.prototype, "rowDropSettings", void 0);
__decorate([
    Complex({}, FilterSettings)
], Grid.prototype, "filterSettings", void 0);
__decorate([
    Property(false)
], Grid.prototype, "allowGrouping", void 0);
__decorate([
    Property(false)
], Grid.prototype, "enableImmutableMode", void 0);
__decorate([
    Property(false)
], Grid.prototype, "showColumnMenu", void 0);
__decorate([
    Property(false)
], Grid.prototype, "autoFit", void 0);
__decorate([
    Complex({}, GroupSettings)
], Grid.prototype, "groupSettings", void 0);
__decorate([
    Complex({}, EditSettings)
], Grid.prototype, "editSettings", void 0);
__decorate([
    Collection([], AggregateRow)
], Grid.prototype, "aggregates", void 0);
__decorate([
    Property(false)
], Grid.prototype, "showColumnChooser", void 0);
__decorate([
    Complex({}, ColumnChooserSettings)
], Grid.prototype, "columnChooserSettings", void 0);
__decorate([
    Property(false)
], Grid.prototype, "enableHeaderFocus", void 0);
__decorate([
    Property('auto')
], Grid.prototype, "height", void 0);
__decorate([
    Property('auto')
], Grid.prototype, "width", void 0);
__decorate([
    Property('Default')
], Grid.prototype, "gridLines", void 0);
__decorate([
    Property()
], Grid.prototype, "rowTemplate", void 0);
__decorate([
    Property()
], Grid.prototype, "emptyRecordTemplate", void 0);
__decorate([
    Property()
], Grid.prototype, "detailTemplate", void 0);
__decorate([
    Property()
], Grid.prototype, "childGrid", void 0);
__decorate([
    Property()
], Grid.prototype, "queryString", void 0);
__decorate([
    Property('AllPages')
], Grid.prototype, "printMode", void 0);
__decorate([
    Property('Expanded')
], Grid.prototype, "hierarchyPrintMode", void 0);
__decorate([
    Property([])
], Grid.prototype, "dataSource", void 0);
__decorate([
    Property(null)
], Grid.prototype, "rowHeight", void 0);
__decorate([
    Property()
], Grid.prototype, "query", void 0);
__decorate([
    Property('USD')
], Grid.prototype, "currencyCode", void 0);
__decorate([
    Property()
], Grid.prototype, "exportGrids", void 0);
__decorate([
    Property()
], Grid.prototype, "toolbar", void 0);
__decorate([
    Property()
], Grid.prototype, "contextMenuItems", void 0);
__decorate([
    Property()
], Grid.prototype, "columnMenuItems", void 0);
__decorate([
    Property()
], Grid.prototype, "toolbarTemplate", void 0);
__decorate([
    Property()
], Grid.prototype, "pagerTemplate", void 0);
__decorate([
    Property(0)
], Grid.prototype, "frozenRows", void 0);
__decorate([
    Property(0)
], Grid.prototype, "frozenColumns", void 0);
__decorate([
    Property('')
], Grid.prototype, "cssClass", void 0);
__decorate([
    Property('All')
], Grid.prototype, "columnQueryMode", void 0);
__decorate([
    Property({})
], Grid.prototype, "currentAction", void 0);
__decorate([
    Property('')
], Grid.prototype, "ej2StatePersistenceVersion", void 0);
__decorate([
    Property(null)
], Grid.prototype, "isRowSelectable", void 0);
__decorate([
    Event()
], Grid.prototype, "isRowPinned", void 0);
__decorate([
    Event()
], Grid.prototype, "created", void 0);
__decorate([
    Event()
], Grid.prototype, "destroyed", void 0);
__decorate([
    Event()
], Grid.prototype, "load", void 0);
__decorate([
    Event()
], Grid.prototype, "rowDataBound", void 0);
__decorate([
    Event()
], Grid.prototype, "queryCellInfo", void 0);
__decorate([
    Event()
], Grid.prototype, "headerCellInfo", void 0);
__decorate([
    Event()
], Grid.prototype, "actionBegin", void 0);
__decorate([
    Event()
], Grid.prototype, "actionComplete", void 0);
__decorate([
    Event()
], Grid.prototype, "actionFailure", void 0);
__decorate([
    Event()
], Grid.prototype, "dataBound", void 0);
__decorate([
    Event()
], Grid.prototype, "recordDoubleClick", void 0);
__decorate([
    Event()
], Grid.prototype, "recordClick", void 0);
__decorate([
    Event()
], Grid.prototype, "rowSelecting", void 0);
__decorate([
    Event()
], Grid.prototype, "rowSelected", void 0);
__decorate([
    Event()
], Grid.prototype, "rowDeselecting", void 0);
__decorate([
    Event()
], Grid.prototype, "rowDeselected", void 0);
__decorate([
    Event()
], Grid.prototype, "cellSelecting", void 0);
__decorate([
    Event()
], Grid.prototype, "cellSelected", void 0);
__decorate([
    Event()
], Grid.prototype, "cellDeselecting", void 0);
__decorate([
    Event()
], Grid.prototype, "cellDeselected", void 0);
__decorate([
    Event()
], Grid.prototype, "columnSelecting", void 0);
__decorate([
    Event()
], Grid.prototype, "columnSelected", void 0);
__decorate([
    Event()
], Grid.prototype, "columnDeselecting", void 0);
__decorate([
    Event()
], Grid.prototype, "columnDeselected", void 0);
__decorate([
    Event()
], Grid.prototype, "columnDragStart", void 0);
__decorate([
    Event()
], Grid.prototype, "columnDrag", void 0);
__decorate([
    Event()
], Grid.prototype, "columnDrop", void 0);
__decorate([
    Event()
], Grid.prototype, "printComplete", void 0);
__decorate([
    Event()
], Grid.prototype, "beforePrint", void 0);
__decorate([
    Event()
], Grid.prototype, "pdfQueryCellInfo", void 0);
__decorate([
    Event()
], Grid.prototype, "pdfHeaderQueryCellInfo", void 0);
__decorate([
    Event()
], Grid.prototype, "pdfAggregateQueryCellInfo", void 0);
__decorate([
    Event()
], Grid.prototype, "excelAggregateQueryCellInfo", void 0);
__decorate([
    Event()
], Grid.prototype, "exportDetailDataBound", void 0);
__decorate([
    Event()
], Grid.prototype, "exportDetailTemplate", void 0);
__decorate([
    Event()
], Grid.prototype, "excelQueryCellInfo", void 0);
__decorate([
    Event()
], Grid.prototype, "excelHeaderQueryCellInfo", void 0);
__decorate([
    Event()
], Grid.prototype, "beforeExcelExport", void 0);
__decorate([
    Event()
], Grid.prototype, "excelExportComplete", void 0);
__decorate([
    Event()
], Grid.prototype, "beforePdfExport", void 0);
__decorate([
    Event()
], Grid.prototype, "pdfExportComplete", void 0);
__decorate([
    Event()
], Grid.prototype, "rowDragStartHelper", void 0);
__decorate([
    Event()
], Grid.prototype, "detailDataBound", void 0);
__decorate([
    Event()
], Grid.prototype, "detailExpand", void 0);
__decorate([
    Event()
], Grid.prototype, "detailCollapse", void 0);
__decorate([
    Event()
], Grid.prototype, "rowDragStart", void 0);
__decorate([
    Event()
], Grid.prototype, "rowDrag", void 0);
__decorate([
    Event()
], Grid.prototype, "rowDrop", void 0);
__decorate([
    Event()
], Grid.prototype, "toolbarClick", void 0);
__decorate([
    Event()
], Grid.prototype, "beforeOpenColumnChooser", void 0);
__decorate([
    Event()
], Grid.prototype, "beforeOpenAdaptiveDialog", void 0);
__decorate([
    Event()
], Grid.prototype, "batchAdd", void 0);
__decorate([
    Event()
], Grid.prototype, "batchDelete", void 0);
__decorate([
    Event()
], Grid.prototype, "batchCancel", void 0);
__decorate([
    Event()
], Grid.prototype, "beforeBatchAdd", void 0);
__decorate([
    Event()
], Grid.prototype, "beforeBatchDelete", void 0);
__decorate([
    Event()
], Grid.prototype, "beforeBatchSave", void 0);
__decorate([
    Event()
], Grid.prototype, "beginEdit", void 0);
__decorate([
    Event()
], Grid.prototype, "commandClick", void 0);
__decorate([
    Event()
], Grid.prototype, "cellEdit", void 0);
__decorate([
    Event()
], Grid.prototype, "cellSave", void 0);
__decorate([
    Event()
], Grid.prototype, "cellSaved", void 0);
__decorate([
    Event()
], Grid.prototype, "resizeStart", void 0);
__decorate([
    Event()
], Grid.prototype, "resizing", void 0);
__decorate([
    Event()
], Grid.prototype, "resizeStop", void 0);
__decorate([
    Event()
], Grid.prototype, "keyPressed", void 0);
__decorate([
    Event()
], Grid.prototype, "beforeDataBound", void 0);
__decorate([
    Event()
], Grid.prototype, "contextMenuOpen", void 0);
__decorate([
    Event()
], Grid.prototype, "contextMenuClick", void 0);
__decorate([
    Event()
], Grid.prototype, "contextMenuClose", void 0);
__decorate([
    Event()
], Grid.prototype, "columnMenuOpen", void 0);
__decorate([
    Event()
], Grid.prototype, "columnMenuClick", void 0);
__decorate([
    Event()
], Grid.prototype, "columnMenuClose", void 0);
__decorate([
    Event()
], Grid.prototype, "checkBoxChange", void 0);
__decorate([
    Event()
], Grid.prototype, "beforeCopy", void 0);
__decorate([
    Event()
], Grid.prototype, "beforePaste", void 0);
__decorate([
    Event()
], Grid.prototype, "beforeAutoFill", void 0);
__decorate([
    Event()
], Grid.prototype, "columnDataStateChange", void 0);
__decorate([
    Event()
], Grid.prototype, "dataStateChange", void 0);
__decorate([
    Event()
], Grid.prototype, "dataSourceChanged", void 0);
__decorate([
    Event()
], Grid.prototype, "exportGroupCaption", void 0);
__decorate([
    Event()
], Grid.prototype, "lazyLoadGroupExpand", void 0);
__decorate([
    Event()
], Grid.prototype, "lazyLoadGroupCollapse", void 0);
__decorate([
    Event()
], Grid.prototype, "beforeDetailTemplateDetach", void 0);
__decorate([
    Event()
], Grid.prototype, "beforeCustomFilterOpen", void 0);
Grid = Grid_1 = __decorate([
    NotifyPropertyChanges
], Grid);
export { Grid };
